var ZR = [
  { L: "442F14", B: "D5AF2", R: "4437DE", T: "D5DE0" },
  { L: "442F14", B: "D5DE0", R: "4437DE", T: "D60CE" },
  { L: "44CD48", B: "D9B66", R: "44D612", T: "D9E54" },
  { L: "44CD48", B: "D9E54", R: "44D612", T: "DA142" },
  { L: "461B44", B: "E53F8", R: "46240E", T: "E59D4" },
  { L: "46240E", B: "E53F8", R: "462CD8", T: "E59D4" },
  { L: "461B44", B: "E59D4", R: "46240E", T: "E5FB0" },
  { L: "46240E", B: "E59D4", R: "462CD8", T: "E5FB0" },
  { L: "461B44", B: "E5FB0", R: "46240E", T: "E658C" },
  { L: "46240E", B: "E5FB0", R: "462CD8", T: "E658C" },
  { L: "461B44", B: "E658C", R: "46240E", T: "E6B68" },
  { L: "46240E", B: "E658C", R: "462CD8", T: "E6B68" },
  { L: "462CD8", B: "E5FB0", R: "4635A2", T: "E658C" },
  { L: "462CD8", B: "E658C", R: "4635A2", T: "E6B68" },
  { L: "461B44", B: "E6B68", R: "46240E", T: "E7144" },
  { L: "46240E", B: "E6B68", R: "462CD8", T: "E7144" },
  { L: "46240E", B: "E7144", R: "462CD8", T: "E7720" },
  { L: "462CD8", B: "E6B68", R: "4635A2", T: "E7144" },
  { L: "4635A2", B: "E6B68", R: "463E6C", T: "E7144" },
  { L: "462CD8", B: "E7144", R: "4635A2", T: "E7720" },
  { L: "4635A2", B: "E7144", R: "463E6C", T: "E7720" },
  { L: "463E6C", B: "E6B68", R: "464736", T: "E7144" },
  { L: "463E6C", B: "E7144", R: "464736", T: "E7720" },
  { L: "46240E", B: "E7720", R: "462CD8", T: "E7CFC" },
  { L: "462CD8", B: "E7720", R: "4635A2", T: "E7CFC" },
  { L: "4635A2", B: "E7720", R: "463E6C", T: "E7CFC" },
  { L: "4635A2", B: "E7CFC", R: "463E6C", T: "E82D8" },
  { L: "463E6C", B: "E7720", R: "464736", T: "E7CFC" },
  { L: "463E6C", B: "E7CFC", R: "464736", T: "E82D8" },
  { L: "4635A2", B: "E82D8", R: "463E6C", T: "E88B4" },
  { L: "464736", B: "E975A", R: "465000", T: "E9A48" },
  { L: "464736", B: "E9A48", R: "465000", T: "E9D36" },
  { L: "471E8B", B: "F934E", R: "4722F0", T: "F963C" },
  { L: "471E8B", B: "F963C", R: "4722F0", T: "F992A" },
  { L: "4722F0", B: "F934E", R: "472755", T: "F963C" },
  { L: "4722F0", B: "F963C", R: "472755", T: "F992A" },
  { L: "47F17B", B: "10DE5C", R: "47F5E0", T: "10E438" },
  { L: "47C124", B: "1124AC", R: "47C9EE", T: "112A88" },
  { L: "478C68", B: "112A88", R: "479532", T: "113064" },
  { L: "479532", B: "112A88", R: "479DFC", T: "113064" },
  { L: "47C124", B: "112A88", R: "47C9EE", T: "113064" },
  { L: "47F5E0", B: "10DE5C", R: "47FA45", T: "10E438" },
  { L: "479532", B: "113C1C", R: "479DFC", T: "1141F8" },
  { L: "47DB82", B: "113640", R: "47E44C", T: "113C1C" },
  { L: "47DB82", B: "113C1C", R: "47E44C", T: "1141F8" },
  { L: "479532", B: "1141F8", R: "479DFC", T: "1147D4" },
  { L: "47A6C6", B: "1141F8", R: "47AF90", T: "1147D4" },
  { L: "47A6C6", B: "1147D4", R: "47AF90", T: "114DB0" },
  { L: "47AF90", B: "1141F8", R: "47B85A", T: "1147D4" },
  { L: "47AF90", B: "1147D4", R: "47B85A", T: "114DB0" },
  { L: "47C9EE", B: "1147D4", R: "47D2B8", T: "114DB0" },
  { L: "47A6C6", B: "114DB0", R: "47AF90", T: "11538C" },
  { L: "47A6C6", B: "11538C", R: "47AF90", T: "115968" },
  { L: "47AF90", B: "114DB0", R: "47B85A", T: "11538C" },
  { L: "47AF90", B: "11538C", R: "47B85A", T: "115968" },
  { L: "47B85A", B: "11538C", R: "47C124", T: "115968" },
  { L: "47C9EE", B: "114DB0", R: "47D2B8", T: "11538C" },
  { L: "47A6C6", B: "115968", R: "47AF90", T: "115F44" },
  { L: "47A6C6", B: "115F44", R: "47AF90", T: "116520" },
  { L: "47AF90", B: "115968", R: "47B85A", T: "115F44" },
  { L: "47B85A", B: "115968", R: "47C124", T: "115F44" },
  { L: "47AF90", B: "115F44", R: "47B85A", T: "116520" },
  { L: "47B85A", B: "115F44", R: "47C124", T: "116520" },
  { L: "478C68", B: "116520", R: "479532", T: "116AFC" },
  { L: "478C68", B: "116AFC", R: "479532", T: "1170D8" },
  { L: "47A6C6", B: "116520", R: "47AF90", T: "116AFC" },
  { L: "47AF90", B: "116520", R: "47B85A", T: "116AFC" },
  { L: "47B85A", B: "116520", R: "47C124", T: "116AFC" },
  { L: "47B85A", B: "116AFC", R: "47C124", T: "1170D8" },
  { L: "47C124", B: "116520", R: "47C9EE", T: "116AFC" },
  { L: "47C9EE", B: "116520", R: "47D2B8", T: "116AFC" },
  { L: "47C124", B: "116AFC", R: "47C9EE", T: "1170D8" },
  { L: "47C9EE", B: "116AFC", R: "47D2B8", T: "1170D8" },
  { L: "47D2B8", B: "116520", R: "47DB82", T: "116AFC" },
  { L: "47D2B8", B: "116AFC", R: "47DB82", T: "1170D8" },
  { L: "478C68", B: "1176B4", R: "479532", T: "117C90" },
  { L: "479532", B: "1176B4", R: "479DFC", T: "117C90" },
  { L: "47DB82", B: "11826C", R: "47E44C", T: "118848" },
  { L: "47839E", B: "118E24", R: "478C68", T: "119400" },
  { L: "47ED16", B: "118E24", R: "47F5E0", T: "119400" },
  { L: "48103E", B: "1141F8", R: "481908", T: "1147D4" },
  { L: "48103E", B: "1147D4", R: "481908", T: "114DB0" },
  { L: "482A9C", B: "11538C", R: "483366", T: "115968" },
  { L: "4821D2", B: "115968", R: "482A9C", T: "115F44" },
  { L: "4821D2", B: "115F44", R: "482A9C", T: "116520" },
  { L: "482A9C", B: "115968", R: "483366", T: "115F44" },
  { L: "47F5E0", B: "116AFC", R: "47FEAA", T: "1170D8" },
  { L: "47FEAA", B: "116AFC", R: "480774", T: "1170D8" },
  { L: "483366", B: "116AFC", R: "483C30", T: "1170D8" },
  { L: "483366", B: "1170D8", R: "483C30", T: "1176B4" },
  { L: "482A9C", B: "1176B4", R: "483366", T: "117C90" },
  { L: "483366", B: "1176B4", R: "483C30", T: "117C90" },
  { L: "4821D2", B: "117C90", R: "482A9C", T: "11826C" },
  { L: "4821D2", B: "11826C", R: "482A9C", T: "118848" },
  { L: "482A9C", B: "117C90", R: "483366", T: "11826C" },
  { L: "483366", B: "117C90", R: "483C30", T: "11826C" },
  { L: "482A9C", B: "11826C", R: "483366", T: "118848" },
  { L: "483366", B: "11826C", R: "483C30", T: "118848" },
  { L: "4821D2", B: "118848", R: "482A9C", T: "118E24" },
  { L: "4821D2", B: "118E24", R: "482A9C", T: "119400" },
  { L: "482A9C", B: "118848", R: "483366", T: "118E24" },
  { L: "483366", B: "118848", R: "483C30", T: "118E24" },
  { L: "482A9C", B: "118E24", R: "483366", T: "119400" },
  { L: "483366", B: "118E24", R: "483C30", T: "119400" },
  { L: "474EE2", B: "11EBE4", R: "4757AC", T: "11F1C0" },
  { L: "4757AC", B: "11EBE4", R: "476076", T: "11F1C0" },
  { L: "47839E", B: "119400", R: "478C68", T: "1199DC" },
  { L: "479532", B: "1199DC", R: "479DFC", T: "119FB8" },
  { L: "47B85A", B: "119400", R: "47C124", T: "1199DC" },
  { L: "47B85A", B: "1199DC", R: "47C124", T: "119FB8" },
  { L: "47D2B8", B: "119400", R: "47DB82", T: "1199DC" },
  { L: "47DB82", B: "119400", R: "47E44C", T: "1199DC" },
  { L: "47D2B8", B: "1199DC", R: "47DB82", T: "119FB8" },
  { L: "47DB82", B: "1199DC", R: "47E44C", T: "119FB8" },
  { L: "479532", B: "119FB8", R: "479DFC", T: "11A594" },
  { L: "476940", B: "11AB70", R: "47720A", T: "11B14C" },
  { L: "479DFC", B: "11AB70", R: "47A6C6", T: "11B14C" },
  { L: "479DFC", B: "11B14C", R: "47A6C6", T: "11B728" },
  { L: "47C9EE", B: "11AB70", R: "47D2B8", T: "11B14C" },
  { L: "47C9EE", B: "11B14C", R: "47D2B8", T: "11B728" },
  { L: "47D2B8", B: "11AB70", R: "47DB82", T: "11B14C" },
  { L: "47D2B8", B: "11B14C", R: "47DB82", T: "11B728" },
  { L: "477AD4", B: "11CE98", R: "47839E", T: "11D474" },
  { L: "47839E", B: "11CE98", R: "478C68", T: "11D474" },
  { L: "477AD4", B: "11D474", R: "47839E", T: "11DA50" },
  { L: "47839E", B: "11D474", R: "478C68", T: "11DA50" },
  { L: "47AF90", B: "11CE98", R: "47B85A", T: "11D474" },
  { L: "47B85A", B: "11CE98", R: "47C124", T: "11D474" },
  { L: "47AF90", B: "11D474", R: "47B85A", T: "11DA50" },
  { L: "47B85A", B: "11D474", R: "47C124", T: "11DA50" },
  { L: "47C124", B: "11D474", R: "47C9EE", T: "11DA50" },
  { L: "47AF90", B: "11DA50", R: "47B85A", T: "11E02C" },
  { L: "47B85A", B: "11DA50", R: "47C124", T: "11E02C" },
  { L: "47C124", B: "11DA50", R: "47C9EE", T: "11E02C" },
  { L: "482A9C", B: "119400", R: "483366", T: "1199DC" },
  { L: "483366", B: "119400", R: "483C30", T: "1199DC" },
  { L: "483366", B: "1199DC", R: "483C30", T: "119FB8" },
  { L: "483C30", B: "119400", R: "4844FA", T: "1199DC" },
  { L: "483C30", B: "1199DC", R: "4844FA", T: "119FB8" },
  { L: "482A9C", B: "119FB8", R: "483366", T: "11A594" },
  { L: "483C30", B: "119FB8", R: "4844FA", T: "11A594" },
  { L: "483C30", B: "11A594", R: "4844FA", T: "11AB70" },
  { L: "4844FA", B: "11C8BC", R: "484DC4", T: "11CE98" },
  { L: "484DC4", B: "11C8BC", R: "48568E", T: "11CE98" },
  { L: "4844FA", B: "11CE98", R: "484DC4", T: "11D474" },
  { L: "484DC4", B: "11CE98", R: "48568E", T: "11D474" },
  { L: "484DC4", B: "11D474", R: "48568E", T: "11DA50" },
  { L: "484DC4", B: "11DA50", R: "48568E", T: "11E02C" },
  { L: "48568E", B: "11DA50", R: "485F58", T: "11E02C" },
  { L: "484DC4", B: "11E02C", R: "48568E", T: "11E608" },
  { L: "48568E", B: "11E02C", R: "485F58", T: "11E608" },
  { L: "484DC4", B: "11E608", R: "48568E", T: "11EBE4" },
  { L: "48568E", B: "11E608", R: "485F58", T: "11EBE4" },
  { L: "46C242", B: "11F1C0", R: "46CB0C", T: "11F79C" },
  { L: "474618", B: "11F1C0", R: "474EE2", T: "11F79C" },
  { L: "474EE2", B: "11F1C0", R: "4757AC", T: "11F79C" },
  { L: "474618", B: "11F79C", R: "474EE2", T: "11FD78" },
  { L: "474EE2", B: "11F79C", R: "4757AC", T: "11FD78" },
  { L: "4757AC", B: "11F1C0", R: "476076", T: "11F79C" },
  { L: "4757AC", B: "11F79C", R: "476076", T: "11FD78" },
  { L: "476076", B: "11F79C", R: "476940", T: "11FD78" },
  { L: "473D4E", B: "120354", R: "474618", T: "120930" },
  { L: "474618", B: "11FD78", R: "474EE2", T: "120354" },
  { L: "474EE2", B: "11FD78", R: "4757AC", T: "120354" },
  { L: "474618", B: "120354", R: "474EE2", T: "120930" },
  { L: "474EE2", B: "120354", R: "4757AC", T: "120930" },
  { L: "4757AC", B: "11FD78", R: "476076", T: "120354" },
  { L: "476076", B: "11FD78", R: "476940", T: "120354" },
  { L: "4757AC", B: "120354", R: "476076", T: "120930" },
  { L: "476076", B: "120354", R: "476940", T: "120930" },
  { L: "473D4E", B: "120930", R: "474618", T: "120F0C" },
  { L: "474618", B: "120930", R: "474EE2", T: "120F0C" },
  { L: "474EE2", B: "120930", R: "4757AC", T: "120F0C" },
  { L: "4757AC", B: "120930", R: "476076", T: "120F0C" },
  { L: "476076", B: "120930", R: "476940", T: "120F0C" },
  { L: "4757AC", B: "120F0C", R: "476076", T: "1214E8" },
  { L: "476076", B: "120F0C", R: "476940", T: "1214E8" },
  { L: "4757AC", B: "1214E8", R: "476076", T: "121AC4" },
  { L: "476076", B: "1214E8", R: "476940", T: "121AC4" },
  { L: "4757AC", B: "121AC4", R: "476076", T: "1220A0" },
  { L: "476076", B: "121AC4", R: "476940", T: "1220A0" },
  { L: "474618", B: "12267C", R: "474EE2", T: "122C58" },
  { L: "473D4E", B: "122C58", R: "474618", T: "123234" },
  { L: "473484", B: "123234", R: "473D4E", T: "123810" },
  { L: "473D4E", B: "123234", R: "474618", T: "123810" },
  { L: "474618", B: "122C58", R: "474EE2", T: "123234" },
  { L: "474618", B: "123234", R: "474EE2", T: "123810" },
  { L: "474EE2", B: "123234", R: "4757AC", T: "123810" },
  { L: "473484", B: "123810", R: "473D4E", T: "123DEC" },
  { L: "473D4E", B: "123810", R: "474618", T: "123DEC" },
  { L: "473484", B: "123DEC", R: "473D4E", T: "1243C8" },
  { L: "473D4E", B: "123DEC", R: "474618", T: "1243C8" },
  { L: "474618", B: "123810", R: "474EE2", T: "123DEC" },
  { L: "474618", B: "123DEC", R: "474EE2", T: "1243C8" },
  { L: "473D4E", B: "1249A4", R: "474618", T: "124F80" },
  { L: "474EE2", B: "1243C8", R: "4757AC", T: "1249A4" },
  { L: "4757AC", B: "1243C8", R: "476076", T: "1249A4" },
  { L: "47839E", B: "11F79C", R: "478C68", T: "11FD78" },
  { L: "478C68", B: "11F79C", R: "479532", T: "11FD78" },
  { L: "47B85A", B: "11F79C", R: "47C124", T: "11FD78" },
  { L: "47C124", B: "11F1C0", R: "47C9EE", T: "11F79C" },
  { L: "47C9EE", B: "11F1C0", R: "47D2B8", T: "11F79C" },
  { L: "47C124", B: "11F79C", R: "47C9EE", T: "11FD78" },
  { L: "47C9EE", B: "11F79C", R: "47D2B8", T: "11FD78" },
  { L: "47D2B8", B: "11F79C", R: "47DB82", T: "11FD78" },
  { L: "476940", B: "120354", R: "47720A", T: "120930" },
  { L: "47720A", B: "120354", R: "477AD4", T: "120930" },
  { L: "479532", B: "11FD78", R: "479DFC", T: "120354" },
  { L: "479532", B: "120354", R: "479DFC", T: "120930" },
  { L: "479DFC", B: "11FD78", R: "47A6C6", T: "120354" },
  { L: "47B85A", B: "11FD78", R: "47C124", T: "120354" },
  { L: "47B85A", B: "120354", R: "47C124", T: "120930" },
  { L: "47C124", B: "11FD78", R: "47C9EE", T: "120354" },
  { L: "47C9EE", B: "11FD78", R: "47D2B8", T: "120354" },
  { L: "47C124", B: "120354", R: "47C9EE", T: "120930" },
  { L: "47C9EE", B: "120354", R: "47D2B8", T: "120930" },
  { L: "47D2B8", B: "11FD78", R: "47DB82", T: "120354" },
  { L: "47DB82", B: "11FD78", R: "47E44C", T: "120354" },
  { L: "47D2B8", B: "120354", R: "47DB82", T: "120930" },
  { L: "47DB82", B: "120354", R: "47E44C", T: "120930" },
  { L: "476940", B: "120930", R: "47720A", T: "120F0C" },
  { L: "47720A", B: "120930", R: "477AD4", T: "120F0C" },
  { L: "476940", B: "120F0C", R: "47720A", T: "1214E8" },
  { L: "47B85A", B: "120930", R: "47C124", T: "120F0C" },
  { L: "47AF90", B: "120F0C", R: "47B85A", T: "1214E8" },
  { L: "47B85A", B: "120F0C", R: "47C124", T: "1214E8" },
  { L: "47C124", B: "120930", R: "47C9EE", T: "120F0C" },
  { L: "47C9EE", B: "120930", R: "47D2B8", T: "120F0C" },
  { L: "47C124", B: "120F0C", R: "47C9EE", T: "1214E8" },
  { L: "47C9EE", B: "120F0C", R: "47D2B8", T: "1214E8" },
  { L: "47D2B8", B: "120930", R: "47DB82", T: "120F0C" },
  { L: "47DB82", B: "120930", R: "47E44C", T: "120F0C" },
  { L: "47D2B8", B: "120F0C", R: "47DB82", T: "1214E8" },
  { L: "47DB82", B: "120F0C", R: "47E44C", T: "1214E8" },
  { L: "479DFC", B: "1214E8", R: "47A6C6", T: "121AC4" },
  { L: "47A6C6", B: "1214E8", R: "47AF90", T: "121AC4" },
  { L: "479DFC", B: "121AC4", R: "47A6C6", T: "1220A0" },
  { L: "47A6C6", B: "121AC4", R: "47AF90", T: "1220A0" },
  { L: "47AF90", B: "1214E8", R: "47B85A", T: "121AC4" },
  { L: "47B85A", B: "1214E8", R: "47C124", T: "121AC4" },
  { L: "47D2B8", B: "121AC4", R: "47DB82", T: "1220A0" },
  { L: "47DB82", B: "121AC4", R: "47E44C", T: "1220A0" },
  { L: "479DFC", B: "1220A0", R: "47A6C6", T: "12267C" },
  { L: "47A6C6", B: "1220A0", R: "47AF90", T: "12267C" },
  { L: "479DFC", B: "12267C", R: "47A6C6", T: "122C58" },
  { L: "47A6C6", B: "12267C", R: "47AF90", T: "122C58" },
  { L: "47C124", B: "1220A0", R: "47C9EE", T: "12267C" },
  { L: "47C9EE", B: "1220A0", R: "47D2B8", T: "12267C" },
  { L: "47720A", B: "122C58", R: "477AD4", T: "123234" },
  { L: "477AD4", B: "122C58", R: "47839E", T: "123234" },
  { L: "479DFC", B: "122C58", R: "47A6C6", T: "123234" },
  { L: "47A6C6", B: "122C58", R: "47AF90", T: "123234" },
  { L: "479DFC", B: "123234", R: "47A6C6", T: "123810" },
  { L: "47A6C6", B: "123234", R: "47AF90", T: "123810" },
  { L: "476940", B: "123810", R: "47720A", T: "123DEC" },
  { L: "476940", B: "123DEC", R: "47720A", T: "1243C8" },
  { L: "478C68", B: "123810", R: "479532", T: "123DEC" },
  { L: "479532", B: "123810", R: "479DFC", T: "123DEC" },
  { L: "478C68", B: "123DEC", R: "479532", T: "1243C8" },
  { L: "479532", B: "123DEC", R: "479DFC", T: "1243C8" },
  { L: "479DFC", B: "123810", R: "47A6C6", T: "123DEC" },
  { L: "47A6C6", B: "123810", R: "47AF90", T: "123DEC" },
  { L: "479DFC", B: "123DEC", R: "47A6C6", T: "1243C8" },
  { L: "47A6C6", B: "123DEC", R: "47AF90", T: "1243C8" },
  { L: "47AF90", B: "123810", R: "47B85A", T: "123DEC" },
  { L: "47B85A", B: "123810", R: "47C124", T: "123DEC" },
  { L: "47AF90", B: "123DEC", R: "47B85A", T: "1243C8" },
  { L: "47B85A", B: "123DEC", R: "47C124", T: "1243C8" },
  { L: "47720A", B: "1243C8", R: "477AD4", T: "1249A4" },
  { L: "477AD4", B: "1243C8", R: "47839E", T: "1249A4" },
  { L: "478C68", B: "1243C8", R: "479532", T: "1249A4" },
  { L: "479532", B: "1243C8", R: "479DFC", T: "1249A4" },
  { L: "478C68", B: "1249A4", R: "479532", T: "124F80" },
  { L: "479532", B: "1249A4", R: "479DFC", T: "124F80" },
  { L: "479DFC", B: "1243C8", R: "47A6C6", T: "1249A4" },
  { L: "47A6C6", B: "1243C8", R: "47AF90", T: "1249A4" },
  { L: "479DFC", B: "1249A4", R: "47A6C6", T: "124F80" },
  { L: "47A6C6", B: "1249A4", R: "47AF90", T: "124F80" },
  { L: "47AF90", B: "1243C8", R: "47B85A", T: "1249A4" },
  { L: "47B85A", B: "1243C8", R: "47C124", T: "1249A4" },
  { L: "47AF90", B: "1249A4", R: "47B85A", T: "124F80" },
  { L: "47B85A", B: "1249A4", R: "47C124", T: "124F80" },
  { L: "47E44C", B: "1249A4", R: "47ED16", T: "124F80" },
  { L: "47ED16", B: "1249A4", R: "47F5E0", T: "124F80" },
  { L: "482A9C", B: "1214E8", R: "483366", T: "121AC4" },
  { L: "482A9C", B: "121AC4", R: "483366", T: "1220A0" },
  { L: "4870EC", B: "1214E8", R: "4879B6", T: "121AC4" },
  { L: "4870EC", B: "121AC4", R: "4879B6", T: "1220A0" },
  { L: "480774", B: "12267C", R: "48103E", T: "122C58" },
  { L: "486822", B: "12267C", R: "4870EC", T: "122C58" },
  { L: "4844FA", B: "122C58", R: "484DC4", T: "123234" },
  { L: "483C30", B: "123234", R: "4844FA", T: "123810" },
  { L: "4844FA", B: "123234", R: "484DC4", T: "123810" },
  { L: "484DC4", B: "122C58", R: "48568E", T: "123234" },
  { L: "48568E", B: "122C58", R: "485F58", T: "123234" },
  { L: "484DC4", B: "123234", R: "48568E", T: "123810" },
  { L: "48568E", B: "123234", R: "485F58", T: "123810" },
  { L: "485F58", B: "122C58", R: "486822", T: "123234" },
  { L: "486822", B: "122C58", R: "4870EC", T: "123234" },
  { L: "485F58", B: "123234", R: "486822", T: "123810" },
  { L: "4821D2", B: "123DEC", R: "482A9C", T: "1243C8" },
  { L: "483C30", B: "123810", R: "4844FA", T: "123DEC" },
  { L: "4844FA", B: "123810", R: "484DC4", T: "123DEC" },
  { L: "483C30", B: "123DEC", R: "4844FA", T: "1243C8" },
  { L: "4844FA", B: "123DEC", R: "484DC4", T: "1243C8" },
  { L: "484DC4", B: "123810", R: "48568E", T: "123DEC" },
  { L: "48568E", B: "123810", R: "485F58", T: "123DEC" },
  { L: "484DC4", B: "123DEC", R: "48568E", T: "1243C8" },
  { L: "48568E", B: "123DEC", R: "485F58", T: "1243C8" },
  { L: "485F58", B: "123810", R: "486822", T: "123DEC" },
  { L: "485F58", B: "123DEC", R: "486822", T: "1243C8" },
  { L: "4821D2", B: "1243C8", R: "482A9C", T: "1249A4" },
  { L: "483366", B: "1243C8", R: "483C30", T: "1249A4" },
  { L: "483366", B: "1249A4", R: "483C30", T: "124F80" },
  { L: "483C30", B: "1243C8", R: "4844FA", T: "1249A4" },
  { L: "4844FA", B: "1243C8", R: "484DC4", T: "1249A4" },
  { L: "483C30", B: "1249A4", R: "4844FA", T: "124F80" },
  { L: "484DC4", B: "1243C8", R: "48568E", T: "1249A4" },
  { L: "48568E", B: "1243C8", R: "485F58", T: "1249A4" },
  { L: "490656", B: "11FD78", R: "490F20", T: "120354" },
  { L: "48E32E", B: "120F0C", R: "48EBF8", T: "1214E8" },
  { L: "48E32E", B: "1214E8", R: "48EBF8", T: "121AC4" },
  { L: "48FD8C", B: "121AC4", R: "490656", T: "1220A0" },
  { L: "490656", B: "121AC4", R: "490F20", T: "1220A0" },
  { L: "48C8D0", B: "123810", R: "48D19A", T: "123DEC" },
  { L: "48D19A", B: "123810", R: "48DA64", T: "123DEC" },
  { L: "48C8D0", B: "123DEC", R: "48D19A", T: "1243C8" },
  { L: "48D19A", B: "123DEC", R: "48DA64", T: "1243C8" },
  { L: "49AD54", B: "123DEC", R: "49B61E", T: "1243C8" },
  { L: "49AD54", B: "1243C8", R: "49B61E", T: "1249A4" },
  { L: "4722F0", B: "124F80", R: "472BBA", T: "12555C" },
  { L: "472BBA", B: "124F80", R: "473484", T: "12555C" },
  { L: "473D4E", B: "124F80", R: "474618", T: "12555C" },
  { L: "476076", B: "12555C", R: "476940", T: "125B38" },
  { L: "476076", B: "125B38", R: "476940", T: "126114" },
  { L: "476076", B: "126114", R: "476940", T: "1266F0" },
  { L: "476940", B: "12555C", R: "47720A", T: "125B38" },
  { L: "47A6C6", B: "124F80", R: "47AF90", T: "12555C" },
  { L: "47A6C6", B: "12555C", R: "47AF90", T: "125B38" },
  { L: "47AF90", B: "124F80", R: "47B85A", T: "12555C" },
  { L: "47B85A", B: "124F80", R: "47C124", T: "12555C" },
  { L: "47AF90", B: "12555C", R: "47B85A", T: "125B38" },
  { L: "47B85A", B: "12555C", R: "47C124", T: "125B38" },
  { L: "47C124", B: "12555C", R: "47C9EE", T: "125B38" },
  { L: "47E44C", B: "124F80", R: "47ED16", T: "12555C" },
  { L: "47ED16", B: "124F80", R: "47F5E0", T: "12555C" },
  { L: "476940", B: "125B38", R: "47720A", T: "126114" },
  { L: "479532", B: "125B38", R: "479DFC", T: "126114" },
  { L: "478C68", B: "126114", R: "479532", T: "1266F0" },
  { L: "479532", B: "126114", R: "479DFC", T: "1266F0" },
  { L: "479DFC", B: "125B38", R: "47A6C6", T: "126114" },
  { L: "47A6C6", B: "125B38", R: "47AF90", T: "126114" },
  { L: "479DFC", B: "126114", R: "47A6C6", T: "1266F0" },
  { L: "47A6C6", B: "126114", R: "47AF90", T: "1266F0" },
  { L: "47AF90", B: "125B38", R: "47B85A", T: "126114" },
  { L: "47B85A", B: "125B38", R: "47C124", T: "126114" },
  { L: "47AF90", B: "126114", R: "47B85A", T: "1266F0" },
  { L: "47C124", B: "125B38", R: "47C9EE", T: "126114" },
  { L: "477AD4", B: "1266F0", R: "47839E", T: "126CCC" },
  { L: "47839E", B: "1266F0", R: "478C68", T: "126CCC" },
  { L: "477AD4", B: "126CCC", R: "47839E", T: "1272A8" },
  { L: "47839E", B: "126CCC", R: "478C68", T: "1272A8" },
  { L: "478C68", B: "1266F0", R: "479532", T: "126CCC" },
  { L: "479532", B: "1266F0", R: "479DFC", T: "126CCC" },
  { L: "478C68", B: "126CCC", R: "479532", T: "1272A8" },
  { L: "479532", B: "126CCC", R: "479DFC", T: "1272A8" },
  { L: "479DFC", B: "1266F0", R: "47A6C6", T: "126CCC" },
  { L: "47A6C6", B: "1266F0", R: "47AF90", T: "126CCC" },
  { L: "479DFC", B: "126CCC", R: "47A6C6", T: "1272A8" },
  { L: "47A6C6", B: "126CCC", R: "47AF90", T: "1272A8" },
  { L: "47AF90", B: "1266F0", R: "47B85A", T: "126CCC" },
  { L: "47AF90", B: "126CCC", R: "47B85A", T: "1272A8" },
  { L: "47D2B8", B: "126CCC", R: "47DB82", T: "1272A8" },
  { L: "47839E", B: "1272A8", R: "478C68", T: "127884" },
  { L: "47839E", B: "127884", R: "478C68", T: "127E60" },
  { L: "478C68", B: "1272A8", R: "479532", T: "127884" },
  { L: "479532", B: "1272A8", R: "479DFC", T: "127884" },
  { L: "478C68", B: "127884", R: "479532", T: "127E60" },
  { L: "479532", B: "127884", R: "479DFC", T: "127E60" },
  { L: "479DFC", B: "1272A8", R: "47A6C6", T: "127884" },
  { L: "47A6C6", B: "1272A8", R: "47AF90", T: "127884" },
  { L: "479DFC", B: "127884", R: "47A6C6", T: "127E60" },
  { L: "47A6C6", B: "127884", R: "47AF90", T: "127E60" },
  { L: "47AF90", B: "1272A8", R: "47B85A", T: "127884" },
  { L: "47AF90", B: "127884", R: "47B85A", T: "127E60" },
  { L: "47C124", B: "1272A8", R: "47C9EE", T: "127884" },
  { L: "47C9EE", B: "1272A8", R: "47D2B8", T: "127884" },
  { L: "47C124", B: "127884", R: "47C9EE", T: "127E60" },
  { L: "47C9EE", B: "127884", R: "47D2B8", T: "127E60" },
  { L: "47D2B8", B: "1272A8", R: "47DB82", T: "127884" },
  { L: "47DB82", B: "1272A8", R: "47E44C", T: "127884" },
  { L: "47D2B8", B: "127884", R: "47DB82", T: "127E60" },
  { L: "47DB82", B: "127884", R: "47E44C", T: "127E60" },
  { L: "478C68", B: "127E60", R: "479532", T: "12843C" },
  { L: "479532", B: "127E60", R: "479DFC", T: "12843C" },
  { L: "479DFC", B: "127E60", R: "47A6C6", T: "12843C" },
  { L: "47A6C6", B: "127E60", R: "47AF90", T: "12843C" },
  { L: "479DFC", B: "12843C", R: "47A6C6", T: "128A18" },
  { L: "47A6C6", B: "12843C", R: "47AF90", T: "128A18" },
  { L: "47AF90", B: "127E60", R: "47B85A", T: "12843C" },
  { L: "47AF90", B: "12843C", R: "47B85A", T: "128A18" },
  { L: "47C124", B: "127E60", R: "47C9EE", T: "12843C" },
  { L: "47C9EE", B: "127E60", R: "47D2B8", T: "12843C" },
  { L: "47C9EE", B: "12843C", R: "47D2B8", T: "128A18" },
  { L: "47ED16", B: "127E60", R: "47F5E0", T: "12843C" },
  { L: "47ED16", B: "12843C", R: "47F5E0", T: "128A18" },
  { L: "47A6C6", B: "128A18", R: "47AF90", T: "128FF4" },
  { L: "47AF90", B: "128A18", R: "47B85A", T: "128FF4" },
  { L: "47B85A", B: "128A18", R: "47C124", T: "128FF4" },
  { L: "47AF90", B: "128FF4", R: "47B85A", T: "1295D0" },
  { L: "47B85A", B: "128FF4", R: "47C124", T: "1295D0" },
  { L: "47C124", B: "128A18", R: "47C9EE", T: "128FF4" },
  { L: "47C9EE", B: "128A18", R: "47D2B8", T: "128FF4" },
  { L: "47C124", B: "128FF4", R: "47C9EE", T: "1295D0" },
  { L: "47C9EE", B: "128FF4", R: "47D2B8", T: "1295D0" },
  { L: "47D2B8", B: "128A18", R: "47DB82", T: "128FF4" },
  { L: "47DB82", B: "128A18", R: "47E44C", T: "128FF4" },
  { L: "47D2B8", B: "128FF4", R: "47DB82", T: "1295D0" },
  { L: "47DB82", B: "128FF4", R: "47E44C", T: "1295D0" },
  { L: "47E44C", B: "128A18", R: "47ED16", T: "128FF4" },
  { L: "47ED16", B: "128A18", R: "47F5E0", T: "128FF4" },
  { L: "47E44C", B: "128FF4", R: "47ED16", T: "1295D0" },
  { L: "47ED16", B: "128FF4", R: "47F5E0", T: "1295D0" },
  { L: "47C124", B: "1295D0", R: "47C9EE", T: "129BAC" },
  { L: "47C9EE", B: "1295D0", R: "47D2B8", T: "129BAC" },
  { L: "47C124", B: "129BAC", R: "47C9EE", T: "12A188" },
  { L: "47C9EE", B: "129BAC", R: "47D2B8", T: "12A188" },
  { L: "47D2B8", B: "1295D0", R: "47DB82", T: "129BAC" },
  { L: "47DB82", B: "1295D0", R: "47E44C", T: "129BAC" },
  { L: "47D2B8", B: "129BAC", R: "47DB82", T: "12A188" },
  { L: "47DB82", B: "129BAC", R: "47E44C", T: "12A188" },
  { L: "47E44C", B: "1295D0", R: "47ED16", T: "129BAC" },
  { L: "47ED16", B: "1295D0", R: "47F5E0", T: "129BAC" },
  { L: "47E44C", B: "129BAC", R: "47ED16", T: "12A188" },
  { L: "47ED16", B: "129BAC", R: "47F5E0", T: "12A188" },
  { L: "47C124", B: "12A188", R: "47C9EE", T: "12A764" },
  { L: "47C9EE", B: "12A188", R: "47D2B8", T: "12A764" },
  { L: "47D2B8", B: "12A188", R: "47DB82", T: "12A764" },
  { L: "47DB82", B: "12A188", R: "47E44C", T: "12A764" },
  { L: "47DB82", B: "12A764", R: "47E44C", T: "12AD40" },
  { L: "47E44C", B: "12A188", R: "47ED16", T: "12A764" },
  { L: "47ED16", B: "12A188", R: "47F5E0", T: "12A764" },
  { L: "47E44C", B: "12A764", R: "47ED16", T: "12AD40" },
  { L: "47ED16", B: "12A764", R: "47F5E0", T: "12AD40" },
  { L: "483366", B: "124F80", R: "483C30", T: "12555C" },
  { L: "4844FA", B: "12555C", R: "484DC4", T: "125B38" },
  { L: "484DC4", B: "12555C", R: "48568E", T: "125B38" },
  { L: "4844FA", B: "125B38", R: "484DC4", T: "126114" },
  { L: "484DC4", B: "125B38", R: "48568E", T: "126114" },
  { L: "480774", B: "126CCC", R: "48103E", T: "1272A8" },
  { L: "48103E", B: "126CCC", R: "481908", T: "1272A8" },
  { L: "481908", B: "1266F0", R: "4821D2", T: "126CCC" },
  { L: "4821D2", B: "1266F0", R: "482A9C", T: "126CCC" },
  { L: "481908", B: "126CCC", R: "4821D2", T: "1272A8" },
  { L: "4821D2", B: "126CCC", R: "482A9C", T: "1272A8" },
  { L: "482A9C", B: "1266F0", R: "483366", T: "126CCC" },
  { L: "482A9C", B: "126CCC", R: "483366", T: "1272A8" },
  { L: "483366", B: "126CCC", R: "483C30", T: "1272A8" },
  { L: "47FEAA", B: "1272A8", R: "480774", T: "127884" },
  { L: "47FEAA", B: "127884", R: "480774", T: "127E60" },
  { L: "480774", B: "1272A8", R: "48103E", T: "127884" },
  { L: "48103E", B: "1272A8", R: "481908", T: "127884" },
  { L: "480774", B: "127884", R: "48103E", T: "127E60" },
  { L: "481908", B: "1272A8", R: "4821D2", T: "127884" },
  { L: "47F5E0", B: "127E60", R: "47FEAA", T: "12843C" },
  { L: "47F5E0", B: "12843C", R: "47FEAA", T: "128A18" },
  { L: "47F5E0", B: "128A18", R: "47FEAA", T: "128FF4" },
  { L: "47F5E0", B: "128FF4", R: "47FEAA", T: "1295D0" },
  { L: "47F5E0", B: "1295D0", R: "47FEAA", T: "129BAC" },
  { L: "47F5E0", B: "129BAC", R: "47FEAA", T: "12A188" },
  { L: "4879B6", B: "129BAC", R: "488280", T: "12A188" },
  { L: "47F5E0", B: "12A188", R: "47FEAA", T: "12A764" },
  { L: "47F5E0", B: "12A764", R: "47FEAA", T: "12AD40" },
  { L: "480774", B: "12A188", R: "48103E", T: "12A764" },
  { L: "48103E", B: "12A188", R: "481908", T: "12A764" },
  { L: "480774", B: "12A764", R: "48103E", T: "12AD40" },
  { L: "48103E", B: "12A764", R: "481908", T: "12AD40" },
  { L: "481908", B: "12A188", R: "4821D2", T: "12A764" },
  { L: "4821D2", B: "12A188", R: "482A9C", T: "12A764" },
  { L: "481908", B: "12A764", R: "4821D2", T: "12AD40" },
  { L: "4821D2", B: "12A764", R: "482A9C", T: "12AD40" },
  { L: "486822", B: "12A764", R: "4870EC", T: "12AD40" },
  { L: "4870EC", B: "12A188", R: "4879B6", T: "12A764" },
  { L: "4879B6", B: "12A188", R: "488280", T: "12A764" },
  { L: "4870EC", B: "12A764", R: "4879B6", T: "12AD40" },
  { L: "4879B6", B: "12A764", R: "488280", T: "12AD40" },
  { L: "48B73C", B: "125B38", R: "48C006", T: "126114" },
  { L: "48C006", B: "125B38", R: "48C8D0", T: "126114" },
  { L: "48B73C", B: "126114", R: "48C006", T: "1266F0" },
  { L: "48C006", B: "126114", R: "48C8D0", T: "1266F0" },
  { L: "48C8D0", B: "126114", R: "48D19A", T: "1266F0" },
  { L: "48C8D0", B: "1266F0", R: "48D19A", T: "126CCC" },
  { L: "48D19A", B: "1266F0", R: "48DA64", T: "126CCC" },
  { L: "48E32E", B: "12843C", R: "48EBF8", T: "128A18" },
  { L: "48EBF8", B: "12843C", R: "48F4C2", T: "128A18" },
  { L: "48F4C2", B: "12843C", R: "48FD8C", T: "128A18" },
  { L: "48E32E", B: "128A18", R: "48EBF8", T: "128FF4" },
  { L: "48E32E", B: "128FF4", R: "48EBF8", T: "1295D0" },
  { L: "48EBF8", B: "128A18", R: "48F4C2", T: "128FF4" },
  { L: "48F4C2", B: "128A18", R: "48FD8C", T: "128FF4" },
  { L: "48EBF8", B: "128FF4", R: "48F4C2", T: "1295D0" },
  { L: "48F4C2", B: "128FF4", R: "48FD8C", T: "1295D0" },
  { L: "48FD8C", B: "128A18", R: "490656", T: "128FF4" },
  { L: "48FD8C", B: "128FF4", R: "490656", T: "1295D0" },
  { L: "48E32E", B: "1295D0", R: "48EBF8", T: "129BAC" },
  { L: "48E32E", B: "129BAC", R: "48EBF8", T: "12A188" },
  { L: "48EBF8", B: "1295D0", R: "48F4C2", T: "129BAC" },
  { L: "48F4C2", B: "1295D0", R: "48FD8C", T: "129BAC" },
  { L: "48EBF8", B: "129BAC", R: "48F4C2", T: "12A188" },
  { L: "48F4C2", B: "129BAC", R: "48FD8C", T: "12A188" },
  { L: "488B4A", B: "12A188", R: "489414", T: "12A764" },
  { L: "488B4A", B: "12A764", R: "489414", T: "12AD40" },
  { L: "489414", B: "12A188", R: "489CDE", T: "12A764" },
  { L: "489414", B: "12A764", R: "489CDE", T: "12AD40" },
  { L: "48EBF8", B: "12A188", R: "48F4C2", T: "12A764" },
  { L: "48EBF8", B: "12A764", R: "48F4C2", T: "12AD40" },
  { L: "493248", B: "12555C", R: "493B12", T: "125B38" },
  { L: "4943DC", B: "126114", R: "494CA6", T: "1266F0" },
  { L: "494CA6", B: "126114", R: "495570", T: "1266F0" },
  { L: "495570", B: "126114", R: "495E3A", T: "1266F0" },
  { L: "495E3A", B: "126114", R: "496704", T: "1266F0" },
  { L: "498A2C", B: "126114", R: "4992F6", T: "1266F0" },
  { L: "494CA6", B: "1266F0", R: "495570", T: "126CCC" },
  { L: "494CA6", B: "126CCC", R: "495570", T: "1272A8" },
  { L: "495570", B: "1266F0", R: "495E3A", T: "126CCC" },
  { L: "495E3A", B: "1266F0", R: "496704", T: "126CCC" },
  { L: "495570", B: "126CCC", R: "495E3A", T: "1272A8" },
  { L: "495E3A", B: "126CCC", R: "496704", T: "1272A8" },
  { L: "496704", B: "1266F0", R: "496FCE", T: "126CCC" },
  { L: "496704", B: "126CCC", R: "496FCE", T: "1272A8" },
  { L: "498A2C", B: "1266F0", R: "4992F6", T: "126CCC" },
  { L: "494CA6", B: "1272A8", R: "495570", T: "127884" },
  { L: "495570", B: "1272A8", R: "495E3A", T: "127884" },
  { L: "495E3A", B: "1272A8", R: "496704", T: "127884" },
  { L: "496704", B: "1272A8", R: "496FCE", T: "127884" },
  { L: "4917EA", B: "129BAC", R: "4920B4", T: "12A188" },
  { L: "4920B4", B: "129BAC", R: "49297E", T: "12A188" },
  { L: "49297E", B: "129BAC", R: "493248", T: "12A188" },
  { L: "493248", B: "129BAC", R: "493B12", T: "12A188" },
  { L: "4917EA", B: "12A188", R: "4920B4", T: "12A764" },
  { L: "4920B4", B: "12A188", R: "49297E", T: "12A764" },
  { L: "49297E", B: "12A188", R: "493248", T: "12A764" },
  { L: "493248", B: "12A188", R: "493B12", T: "12A764" },
  { L: "493B12", B: "12A188", R: "4943DC", T: "12A764" },
  { L: "493248", B: "12A764", R: "493B12", T: "12AD40" },
  { L: "493B12", B: "12A764", R: "4943DC", T: "12AD40" },
  { L: "495570", B: "12A764", R: "495E3A", T: "12AD40" },
  { L: "495E3A", B: "12A764", R: "496704", T: "12AD40" },
  { L: "49F3A4", B: "1295D0", R: "49FC6E", T: "129BAC" },
  { L: "49F3A4", B: "129BAC", R: "49FC6E", T: "12A188" },
  { L: "49FC6E", B: "129BAC", R: "4A0538", T: "12A188" },
  { L: "49EADA", B: "12A764", R: "49F3A4", T: "12AD40" },
  { L: "49F3A4", B: "12A188", R: "49FC6E", T: "12A764" },
  { L: "49FC6E", B: "12A188", R: "4A0538", T: "12A764" },
  { L: "49F3A4", B: "12A764", R: "49FC6E", T: "12AD40" },
  { L: "4A5452", B: "127884", R: "4A5D1C", T: "127E60" },
  { L: "4A5D1C", B: "127884", R: "4A65E6", T: "127E60" },
  { L: "4A5452", B: "127E60", R: "4A5D1C", T: "12843C" },
  { L: "4A5452", B: "12843C", R: "4A5D1C", T: "128A18" },
  { L: "4A5D1C", B: "127E60", R: "4A65E6", T: "12843C" },
  { L: "4A5D1C", B: "12843C", R: "4A65E6", T: "128A18" },
  { L: "4AAC36", B: "127E60", R: "4AB500", T: "12843C" },
  { L: "4AAC36", B: "12843C", R: "4AB500", T: "128A18" },
  { L: "4A5452", B: "128A18", R: "4A5D1C", T: "128FF4" },
  { L: "4A39F4", B: "1295D0", R: "4A42BE", T: "129BAC" },
  { L: "4A39F4", B: "129BAC", R: "4A42BE", T: "12A188" },
  { L: "4AB500", B: "127E60", R: "4ABDCA", T: "12843C" },
  { L: "4AB500", B: "12843C", R: "4ABDCA", T: "128A18" },
  { L: "4ABDCA", B: "1295D0", R: "4AC694", T: "129BAC" },
  { L: "4ABDCA", B: "129BAC", R: "4AC694", T: "12A188" },
  { L: "47E44C", B: "12AD40", R: "47ED16", T: "12B31C" },
  { L: "47ED16", B: "12AD40", R: "47F5E0", T: "12B31C" },
  { L: "47E44C", B: "12B31C", R: "47ED16", T: "12B8F8" },
  { L: "47ED16", B: "12B31C", R: "47F5E0", T: "12B8F8" },
  { L: "47E44C", B: "12B8F8", R: "47ED16", T: "12BED4" },
  { L: "47ED16", B: "12B8F8", R: "47F5E0", T: "12BED4" },
  { L: "47F5E0", B: "12AD40", R: "47FEAA", T: "12B31C" },
  { L: "47F5E0", B: "12B31C", R: "47FEAA", T: "12B8F8" },
  { L: "480774", B: "12AD40", R: "48103E", T: "12B31C" },
  { L: "48103E", B: "12AD40", R: "481908", T: "12B31C" },
  { L: "483C30", B: "12AD40", R: "4844FA", T: "12B31C" },
  { L: "4844FA", B: "12AD40", R: "484DC4", T: "12B31C" },
  { L: "483C30", B: "12B31C", R: "4844FA", T: "12B8F8" },
  { L: "4844FA", B: "12B31C", R: "484DC4", T: "12B8F8" },
  { L: "48568E", B: "12B31C", R: "485F58", T: "12B8F8" },
  { L: "485F58", B: "12AD40", R: "486822", T: "12B31C" },
  { L: "486822", B: "12AD40", R: "4870EC", T: "12B31C" },
  { L: "485F58", B: "12B31C", R: "486822", T: "12B8F8" },
  { L: "486822", B: "12B31C", R: "4870EC", T: "12B8F8" },
  { L: "4870EC", B: "12AD40", R: "4879B6", T: "12B31C" },
  { L: "47F5E0", B: "12B8F8", R: "47FEAA", T: "12BED4" },
  { L: "48103E", B: "12BED4", R: "481908", T: "12C4B0" },
  { L: "482A9C", B: "12B8F8", R: "483366", T: "12BED4" },
  { L: "482A9C", B: "12BED4", R: "483366", T: "12C4B0" },
  { L: "483366", B: "12BED4", R: "483C30", T: "12C4B0" },
  { L: "483C30", B: "12BED4", R: "4844FA", T: "12C4B0" },
  { L: "48103E", B: "12C4B0", R: "481908", T: "12CA8C" },
  { L: "483366", B: "12C4B0", R: "483C30", T: "12CA8C" },
  { L: "483C30", B: "12C4B0", R: "4844FA", T: "12CA8C" },
  { L: "480774", B: "12DC20", R: "48103E", T: "12E1FC" },
  { L: "48103E", B: "12DC20", R: "481908", T: "12E1FC" },
  { L: "480774", B: "12E1FC", R: "48103E", T: "12E7D8" },
  { L: "48103E", B: "12E1FC", R: "481908", T: "12E7D8" },
  { L: "482A9C", B: "12E1FC", R: "483366", T: "12E7D8" },
  { L: "482A9C", B: "12E7D8", R: "483366", T: "12EDB4" },
  { L: "485F58", B: "12E7D8", R: "486822", T: "12EDB4" },
  { L: "485F58", B: "12EDB4", R: "486822", T: "12F390" },
  { L: "489CDE", B: "12B31C", R: "48A5A8", T: "12B8F8" },
  { L: "490656", B: "12AD40", R: "490F20", T: "12B31C" },
  { L: "490656", B: "12B31C", R: "490F20", T: "12B8F8" },
  { L: "489CDE", B: "12B8F8", R: "48A5A8", T: "12BED4" },
  { L: "489414", B: "12BED4", R: "489CDE", T: "12C4B0" },
  { L: "489CDE", B: "12BED4", R: "48A5A8", T: "12C4B0" },
  { L: "490656", B: "12B8F8", R: "490F20", T: "12BED4" },
  { L: "489414", B: "12C4B0", R: "489CDE", T: "12CA8C" },
  { L: "489CDE", B: "12C4B0", R: "48A5A8", T: "12CA8C" },
  { L: "489CDE", B: "12CA8C", R: "48A5A8", T: "12D068" },
  { L: "48C8D0", B: "12C4B0", R: "48D19A", T: "12CA8C" },
  { L: "48D19A", B: "12C4B0", R: "48DA64", T: "12CA8C" },
  { L: "48C8D0", B: "12CA8C", R: "48D19A", T: "12D068" },
  { L: "48D19A", B: "12CA8C", R: "48DA64", T: "12D068" },
  { L: "48DA64", B: "12C4B0", R: "48E32E", T: "12CA8C" },
  { L: "48DA64", B: "12CA8C", R: "48E32E", T: "12D068" },
  { L: "489CDE", B: "12D068", R: "48A5A8", T: "12D644" },
  { L: "48A5A8", B: "12D068", R: "48AE72", T: "12D644" },
  { L: "48AE72", B: "12D068", R: "48B73C", T: "12D644" },
  { L: "48A5A8", B: "12D644", R: "48AE72", T: "12DC20" },
  { L: "48AE72", B: "12D644", R: "48B73C", T: "12DC20" },
  { L: "48B73C", B: "12D644", R: "48C006", T: "12DC20" },
  { L: "48C006", B: "12D644", R: "48C8D0", T: "12DC20" },
  { L: "48C8D0", B: "12D068", R: "48D19A", T: "12D644" },
  { L: "48D19A", B: "12D068", R: "48DA64", T: "12D644" },
  { L: "48C8D0", B: "12D644", R: "48D19A", T: "12DC20" },
  { L: "48D19A", B: "12D644", R: "48DA64", T: "12DC20" },
  { L: "48DA64", B: "12D068", R: "48E32E", T: "12D644" },
  { L: "48DA64", B: "12D644", R: "48E32E", T: "12DC20" },
  { L: "48FD8C", B: "12D644", R: "490656", T: "12DC20" },
  { L: "490656", B: "12D644", R: "490F20", T: "12DC20" },
  { L: "48A5A8", B: "12DC20", R: "48AE72", T: "12E1FC" },
  { L: "48AE72", B: "12DC20", R: "48B73C", T: "12E1FC" },
  { L: "48AE72", B: "12E1FC", R: "48B73C", T: "12E7D8" },
  { L: "48B73C", B: "12DC20", R: "48C006", T: "12E1FC" },
  { L: "48C006", B: "12DC20", R: "48C8D0", T: "12E1FC" },
  { L: "48B73C", B: "12E1FC", R: "48C006", T: "12E7D8" },
  { L: "48C006", B: "12E1FC", R: "48C8D0", T: "12E7D8" },
  { L: "48C8D0", B: "12DC20", R: "48D19A", T: "12E1FC" },
  { L: "48D19A", B: "12DC20", R: "48DA64", T: "12E1FC" },
  { L: "48C8D0", B: "12E1FC", R: "48D19A", T: "12E7D8" },
  { L: "48D19A", B: "12E1FC", R: "48DA64", T: "12E7D8" },
  { L: "48DA64", B: "12DC20", R: "48E32E", T: "12E1FC" },
  { L: "48E32E", B: "12DC20", R: "48EBF8", T: "12E1FC" },
  { L: "48DA64", B: "12E1FC", R: "48E32E", T: "12E7D8" },
  { L: "48E32E", B: "12E1FC", R: "48EBF8", T: "12E7D8" },
  { L: "48EBF8", B: "12E1FC", R: "48F4C2", T: "12E7D8" },
  { L: "48F4C2", B: "12E1FC", R: "48FD8C", T: "12E7D8" },
  { L: "48FD8C", B: "12DC20", R: "490656", T: "12E1FC" },
  { L: "490656", B: "12DC20", R: "490F20", T: "12E1FC" },
  { L: "48FD8C", B: "12E1FC", R: "490656", T: "12E7D8" },
  { L: "490656", B: "12E1FC", R: "490F20", T: "12E7D8" },
  { L: "48AE72", B: "12E7D8", R: "48B73C", T: "12EDB4" },
  { L: "48AE72", B: "12EDB4", R: "48B73C", T: "12F390" },
  { L: "48B73C", B: "12E7D8", R: "48C006", T: "12EDB4" },
  { L: "48C006", B: "12E7D8", R: "48C8D0", T: "12EDB4" },
  { L: "48B73C", B: "12EDB4", R: "48C006", T: "12F390" },
  { L: "48C006", B: "12EDB4", R: "48C8D0", T: "12F390" },
  { L: "48C8D0", B: "12E7D8", R: "48D19A", T: "12EDB4" },
  { L: "48D19A", B: "12E7D8", R: "48DA64", T: "12EDB4" },
  { L: "48C8D0", B: "12EDB4", R: "48D19A", T: "12F390" },
  { L: "48D19A", B: "12EDB4", R: "48DA64", T: "12F390" },
  { L: "48DA64", B: "12E7D8", R: "48E32E", T: "12EDB4" },
  { L: "48E32E", B: "12E7D8", R: "48EBF8", T: "12EDB4" },
  { L: "48DA64", B: "12EDB4", R: "48E32E", T: "12F390" },
  { L: "48E32E", B: "12EDB4", R: "48EBF8", T: "12F390" },
  { L: "48EBF8", B: "12E7D8", R: "48F4C2", T: "12EDB4" },
  { L: "48F4C2", B: "12E7D8", R: "48FD8C", T: "12EDB4" },
  { L: "48EBF8", B: "12EDB4", R: "48F4C2", T: "12F390" },
  { L: "48F4C2", B: "12EDB4", R: "48FD8C", T: "12F390" },
  { L: "48FD8C", B: "12E7D8", R: "490656", T: "12EDB4" },
  { L: "490656", B: "12E7D8", R: "490F20", T: "12EDB4" },
  { L: "48B73C", B: "12F390", R: "48C006", T: "12F96C" },
  { L: "48C006", B: "12F390", R: "48C8D0", T: "12F96C" },
  { L: "48B73C", B: "12F96C", R: "48C006", T: "12FF48" },
  { L: "48C006", B: "12F96C", R: "48C8D0", T: "12FF48" },
  { L: "48C8D0", B: "12F390", R: "48D19A", T: "12F96C" },
  { L: "48D19A", B: "12F390", R: "48DA64", T: "12F96C" },
  { L: "48C8D0", B: "12F96C", R: "48D19A", T: "12FF48" },
  { L: "48D19A", B: "12F96C", R: "48DA64", T: "12FF48" },
  { L: "48DA64", B: "12F390", R: "48E32E", T: "12F96C" },
  { L: "48DA64", B: "12F96C", R: "48E32E", T: "12FF48" },
  { L: "490F20", B: "12AD40", R: "4917EA", T: "12B31C" },
  { L: "490F20", B: "12B31C", R: "4917EA", T: "12B8F8" },
  { L: "495570", B: "12AD40", R: "495E3A", T: "12B31C" },
  { L: "495E3A", B: "12AD40", R: "496704", T: "12B31C" },
  { L: "496704", B: "12B8F8", R: "496FCE", T: "12BED4" },
  { L: "496704", B: "12BED4", R: "496FCE", T: "12C4B0" },
  { L: "497898", B: "12C4B0", R: "498162", T: "12CA8C" },
  { L: "498162", B: "12C4B0", R: "498A2C", T: "12CA8C" },
  { L: "497898", B: "12CA8C", R: "498162", T: "12D068" },
  { L: "498162", B: "12CA8C", R: "498A2C", T: "12D068" },
  { L: "4920B4", B: "12D068", R: "49297E", T: "12D644" },
  { L: "49297E", B: "12D068", R: "493248", T: "12D644" },
  { L: "4920B4", B: "12D644", R: "49297E", T: "12DC20" },
  { L: "49297E", B: "12D644", R: "493248", T: "12DC20" },
  { L: "497898", B: "12D068", R: "498162", T: "12D644" },
  { L: "498162", B: "12D068", R: "498A2C", T: "12D644" },
  { L: "497898", B: "12D644", R: "498162", T: "12DC20" },
  { L: "498162", B: "12D644", R: "498A2C", T: "12DC20" },
  { L: "498A2C", B: "12D068", R: "4992F6", T: "12D644" },
  { L: "4992F6", B: "12D068", R: "499BC0", T: "12D644" },
  { L: "498A2C", B: "12D644", R: "4992F6", T: "12DC20" },
  { L: "4992F6", B: "12D644", R: "499BC0", T: "12DC20" },
  { L: "490F20", B: "12E1FC", R: "4917EA", T: "12E7D8" },
  { L: "4917EA", B: "12E1FC", R: "4920B4", T: "12E7D8" },
  { L: "4920B4", B: "12E1FC", R: "49297E", T: "12E7D8" },
  { L: "49297E", B: "12E1FC", R: "493248", T: "12E7D8" },
  { L: "493248", B: "12E1FC", R: "493B12", T: "12E7D8" },
  { L: "493B12", B: "12E1FC", R: "4943DC", T: "12E7D8" },
  { L: "4943DC", B: "12E1FC", R: "494CA6", T: "12E7D8" },
  { L: "498162", B: "12DC20", R: "498A2C", T: "12E1FC" },
  { L: "498A2C", B: "12DC20", R: "4992F6", T: "12E1FC" },
  { L: "4992F6", B: "12DC20", R: "499BC0", T: "12E1FC" },
  { L: "4920B4", B: "12E7D8", R: "49297E", T: "12EDB4" },
  { L: "49297E", B: "12E7D8", R: "493248", T: "12EDB4" },
  { L: "49297E", B: "12EDB4", R: "493248", T: "12F390" },
  { L: "493248", B: "12E7D8", R: "493B12", T: "12EDB4" },
  { L: "493B12", B: "12E7D8", R: "4943DC", T: "12EDB4" },
  { L: "493248", B: "12EDB4", R: "493B12", T: "12F390" },
  { L: "493B12", B: "12EDB4", R: "4943DC", T: "12F390" },
  { L: "4943DC", B: "12E7D8", R: "494CA6", T: "12EDB4" },
  { L: "494CA6", B: "12E7D8", R: "495570", T: "12EDB4" },
  { L: "4943DC", B: "12EDB4", R: "494CA6", T: "12F390" },
  { L: "494CA6", B: "12EDB4", R: "495570", T: "12F390" },
  { L: "495570", B: "12E7D8", R: "495E3A", T: "12EDB4" },
  { L: "495570", B: "12EDB4", R: "495E3A", T: "12F390" },
  { L: "496704", B: "12EDB4", R: "496FCE", T: "12F390" },
  { L: "496FCE", B: "12EDB4", R: "497898", T: "12F390" },
  { L: "497898", B: "12E7D8", R: "498162", T: "12EDB4" },
  { L: "498162", B: "12E7D8", R: "498A2C", T: "12EDB4" },
  { L: "497898", B: "12EDB4", R: "498162", T: "12F390" },
  { L: "498162", B: "12EDB4", R: "498A2C", T: "12F390" },
  { L: "498A2C", B: "12E7D8", R: "4992F6", T: "12EDB4" },
  { L: "4992F6", B: "12E7D8", R: "499BC0", T: "12EDB4" },
  { L: "498A2C", B: "12EDB4", R: "4992F6", T: "12F390" },
  { L: "4992F6", B: "12EDB4", R: "499BC0", T: "12F390" },
  { L: "49297E", B: "12F390", R: "493248", T: "12F96C" },
  { L: "49297E", B: "12F96C", R: "493248", T: "12FF48" },
  { L: "493248", B: "12F390", R: "493B12", T: "12F96C" },
  { L: "493B12", B: "12F390", R: "4943DC", T: "12F96C" },
  { L: "493248", B: "12F96C", R: "493B12", T: "12FF48" },
  { L: "493B12", B: "12F96C", R: "4943DC", T: "12FF48" },
  { L: "4943DC", B: "12F390", R: "494CA6", T: "12F96C" },
  { L: "494CA6", B: "12F390", R: "495570", T: "12F96C" },
  { L: "4943DC", B: "12F96C", R: "494CA6", T: "12FF48" },
  { L: "494CA6", B: "12F96C", R: "495570", T: "12FF48" },
  { L: "495570", B: "12F390", R: "495E3A", T: "12F96C" },
  { L: "495570", B: "12F96C", R: "495E3A", T: "12FF48" },
  { L: "496704", B: "12F390", R: "496FCE", T: "12F96C" },
  { L: "496FCE", B: "12F390", R: "497898", T: "12F96C" },
  { L: "496704", B: "12F96C", R: "496FCE", T: "12FF48" },
  { L: "496FCE", B: "12F96C", R: "497898", T: "12FF48" },
  { L: "497898", B: "12F390", R: "498162", T: "12F96C" },
  { L: "498162", B: "12F390", R: "498A2C", T: "12F96C" },
  { L: "497898", B: "12F96C", R: "498162", T: "12FF48" },
  { L: "498162", B: "12F96C", R: "498A2C", T: "12FF48" },
  { L: "498A2C", B: "12F390", R: "4992F6", T: "12F96C" },
  { L: "4992F6", B: "12F390", R: "499BC0", T: "12F96C" },
  { L: "498A2C", B: "12F96C", R: "4992F6", T: "12FF48" },
  { L: "4992F6", B: "12F96C", R: "499BC0", T: "12FF48" },
  { L: "493B12", B: "12FF48", R: "4943DC", T: "130524" },
  { L: "4943DC", B: "12FF48", R: "494CA6", T: "130524" },
  { L: "494CA6", B: "12FF48", R: "495570", T: "130524" },
  { L: "495570", B: "12FF48", R: "495E3A", T: "130524" },
  { L: "496704", B: "12FF48", R: "496FCE", T: "130524" },
  { L: "496FCE", B: "12FF48", R: "497898", T: "130524" },
  { L: "496FCE", B: "130524", R: "497898", T: "130B00" },
  { L: "497898", B: "12FF48", R: "498162", T: "130524" },
  { L: "498162", B: "12FF48", R: "498A2C", T: "130524" },
  { L: "497898", B: "130524", R: "498162", T: "130B00" },
  { L: "498162", B: "130524", R: "498A2C", T: "130B00" },
  { L: "498A2C", B: "12FF48", R: "4992F6", T: "130524" },
  { L: "4992F6", B: "12FF48", R: "499BC0", T: "130524" },
  { L: "498A2C", B: "130524", R: "4992F6", T: "130B00" },
  { L: "4992F6", B: "130524", R: "499BC0", T: "130B00" },
  { L: "49D946", B: "12AD40", R: "49E210", T: "12B31C" },
  { L: "49D946", B: "12B31C", R: "49E210", T: "12B8F8" },
  { L: "49E210", B: "12AD40", R: "49EADA", T: "12B31C" },
  { L: "49EADA", B: "12AD40", R: "49F3A4", T: "12B31C" },
  { L: "49E210", B: "12B31C", R: "49EADA", T: "12B8F8" },
  { L: "49EADA", B: "12B31C", R: "49F3A4", T: "12B8F8" },
  { L: "49D946", B: "12B8F8", R: "49E210", T: "12BED4" },
  { L: "49E210", B: "12B8F8", R: "49EADA", T: "12BED4" },
  { L: "49EADA", B: "12B8F8", R: "49F3A4", T: "12BED4" },
  { L: "49E210", B: "12BED4", R: "49EADA", T: "12C4B0" },
  { L: "49EADA", B: "12BED4", R: "49F3A4", T: "12C4B0" },
  { L: "49F3A4", B: "12B8F8", R: "49FC6E", T: "12BED4" },
  { L: "49F3A4", B: "12BED4", R: "49FC6E", T: "12C4B0" },
  { L: "499BC0", B: "12CA8C", R: "49A48A", T: "12D068" },
  { L: "49A48A", B: "12CA8C", R: "49AD54", T: "12D068" },
  { L: "49BEE8", B: "12CA8C", R: "49C7B2", T: "12D068" },
  { L: "49C7B2", B: "12CA8C", R: "49D07C", T: "12D068" },
  { L: "49D07C", B: "12CA8C", R: "49D946", T: "12D068" },
  { L: "49EADA", B: "12C4B0", R: "49F3A4", T: "12CA8C" },
  { L: "49F3A4", B: "12C4B0", R: "49FC6E", T: "12CA8C" },
  { L: "499BC0", B: "12D068", R: "49A48A", T: "12D644" },
  { L: "49A48A", B: "12D068", R: "49AD54", T: "12D644" },
  { L: "499BC0", B: "12D644", R: "49A48A", T: "12DC20" },
  { L: "49A48A", B: "12D644", R: "49AD54", T: "12DC20" },
  { L: "49AD54", B: "12D068", R: "49B61E", T: "12D644" },
  { L: "49B61E", B: "12D068", R: "49BEE8", T: "12D644" },
  { L: "49AD54", B: "12D644", R: "49B61E", T: "12DC20" },
  { L: "49B61E", B: "12D644", R: "49BEE8", T: "12DC20" },
  { L: "49BEE8", B: "12D068", R: "49C7B2", T: "12D644" },
  { L: "49C7B2", B: "12D068", R: "49D07C", T: "12D644" },
  { L: "4A0E02", B: "12D644", R: "4A16CC", T: "12DC20" },
  { L: "4A16CC", B: "12D644", R: "4A1F96", T: "12DC20" },
  { L: "499BC0", B: "12DC20", R: "49A48A", T: "12E1FC" },
  { L: "49A48A", B: "12DC20", R: "49AD54", T: "12E1FC" },
  { L: "49AD54", B: "12DC20", R: "49B61E", T: "12E1FC" },
  { L: "4A0E02", B: "12DC20", R: "4A16CC", T: "12E1FC" },
  { L: "4A16CC", B: "12DC20", R: "4A1F96", T: "12E1FC" },
  { L: "499BC0", B: "12F96C", R: "49A48A", T: "12FF48" },
  { L: "499BC0", B: "12FF48", R: "49A48A", T: "130524" },
  { L: "49A48A", B: "12FF48", R: "49AD54", T: "130524" },
  { L: "499BC0", B: "130524", R: "49A48A", T: "130B00" },
  { L: "49A48A", B: "130524", R: "49AD54", T: "130B00" },
  { L: "4A16CC", B: "130524", R: "4A1F96", T: "130B00" },
  { L: "4A1F96", B: "130524", R: "4A2860", T: "130B00" },
  { L: "4A312A", B: "12B31C", R: "4A39F4", T: "12B8F8" },
  { L: "4A39F4", B: "12B31C", R: "4A42BE", T: "12B8F8" },
  { L: "4A312A", B: "12B8F8", R: "4A39F4", T: "12BED4" },
  { L: "4A312A", B: "12BED4", R: "4A39F4", T: "12C4B0" },
  { L: "4A39F4", B: "12B8F8", R: "4A42BE", T: "12BED4" },
  { L: "4A39F4", B: "12BED4", R: "4A42BE", T: "12C4B0" },
  { L: "4A42BE", B: "12BED4", R: "4A4B88", T: "12C4B0" },
  { L: "4A4B88", B: "12BED4", R: "4A5452", T: "12C4B0" },
  { L: "4A312A", B: "12CA8C", R: "4A39F4", T: "12D068" },
  { L: "4A39F4", B: "12C4B0", R: "4A42BE", T: "12CA8C" },
  { L: "4A42BE", B: "12C4B0", R: "4A4B88", T: "12CA8C" },
  { L: "4A39F4", B: "12CA8C", R: "4A42BE", T: "12D068" },
  { L: "4A42BE", B: "12CA8C", R: "4A4B88", T: "12D068" },
  { L: "4A4B88", B: "12C4B0", R: "4A5452", T: "12CA8C" },
  { L: "4A4B88", B: "12CA8C", R: "4A5452", T: "12D068" },
  { L: "4A5452", B: "12CA8C", R: "4A5D1C", T: "12D068" },
  { L: "4A777A", B: "12C79E", R: "4A8044", T: "12CA8C" },
  { L: "4A777A", B: "12CA8C", R: "4A8044", T: "12CD7A" },
  { L: "4A312A", B: "12D068", R: "4A39F4", T: "12D644" },
  { L: "4A312A", B: "12D644", R: "4A39F4", T: "12DC20" },
  { L: "4A39F4", B: "12D068", R: "4A42BE", T: "12D644" },
  { L: "4A42BE", B: "12D068", R: "4A4B88", T: "12D644" },
  { L: "4A39F4", B: "12D644", R: "4A42BE", T: "12DC20" },
  { L: "4A42BE", B: "12D644", R: "4A4B88", T: "12DC20" },
  { L: "4A4B88", B: "12D068", R: "4A5452", T: "12D644" },
  { L: "4A5452", B: "12D068", R: "4A5D1C", T: "12D644" },
  { L: "4A4B88", B: "12D644", R: "4A5452", T: "12DC20" },
  { L: "4A5452", B: "12D644", R: "4A5D1C", T: "12DC20" },
  { L: "4A777A", B: "12D644", R: "4A8044", T: "12DC20" },
  { L: "4A8044", B: "12D644", R: "4A890E", T: "12DC20" },
  { L: "4A39F4", B: "12DC20", R: "4A42BE", T: "12E1FC" },
  { L: "4A42BE", B: "12DC20", R: "4A4B88", T: "12E1FC" },
  { L: "4A42BE", B: "12E1FC", R: "4A4B88", T: "12E7D8" },
  { L: "4A4B88", B: "12DC20", R: "4A5452", T: "12E1FC" },
  { L: "4A5452", B: "12DC20", R: "4A5D1C", T: "12E1FC" },
  { L: "4A4B88", B: "12E1FC", R: "4A5452", T: "12E7D8" },
  { L: "4A5452", B: "12E1FC", R: "4A5D1C", T: "12E7D8" },
  { L: "4A5D1C", B: "12DC20", R: "4A65E6", T: "12E1FC" },
  { L: "4A65E6", B: "12DC20", R: "4A6EB0", T: "12E1FC" },
  { L: "4A5D1C", B: "12E1FC", R: "4A65E6", T: "12E7D8" },
  { L: "4A65E6", B: "12E1FC", R: "4A6EB0", T: "12E7D8" },
  { L: "4A6EB0", B: "12DC20", R: "4A777A", T: "12E1FC" },
  { L: "4A777A", B: "12DC20", R: "4A8044", T: "12E1FC" },
  { L: "4A6EB0", B: "12E1FC", R: "4A777A", T: "12E7D8" },
  { L: "4A777A", B: "12E1FC", R: "4A8044", T: "12E7D8" },
  { L: "4A8044", B: "12DC20", R: "4A890E", T: "12E1FC" },
  { L: "4A890E", B: "12DC20", R: "4A91D8", T: "12E1FC" },
  { L: "4A8044", B: "12E1FC", R: "4A890E", T: "12E7D8" },
  { L: "4A890E", B: "12E1FC", R: "4A91D8", T: "12E7D8" },
  { L: "4A9AA2", B: "12DC20", R: "4AA36C", T: "12E1FC" },
  { L: "4A42BE", B: "12E7D8", R: "4A4B88", T: "12EDB4" },
  { L: "4A4B88", B: "12E7D8", R: "4A5452", T: "12EDB4" },
  { L: "4A5452", B: "12E7D8", R: "4A5D1C", T: "12EDB4" },
  { L: "4A5452", B: "12EDB4", R: "4A5D1C", T: "12F390" },
  { L: "4A5D1C", B: "12E7D8", R: "4A65E6", T: "12EDB4" },
  { L: "4A65E6", B: "12E7D8", R: "4A6EB0", T: "12EDB4" },
  { L: "4A5D1C", B: "12EDB4", R: "4A65E6", T: "12F390" },
  { L: "4A65E6", B: "12EDB4", R: "4A6EB0", T: "12F390" },
  { L: "4A6EB0", B: "12E7D8", R: "4A777A", T: "12EDB4" },
  { L: "4A777A", B: "12E7D8", R: "4A8044", T: "12EDB4" },
  { L: "4A6EB0", B: "12EDB4", R: "4A777A", T: "12F390" },
  { L: "4A777A", B: "12EDB4", R: "4A8044", T: "12F390" },
  { L: "4A8044", B: "12E7D8", R: "4A890E", T: "12EDB4" },
  { L: "4A890E", B: "12E7D8", R: "4A91D8", T: "12EDB4" },
  { L: "4A8044", B: "12EDB4", R: "4A890E", T: "12F390" },
  { L: "4A890E", B: "12EDB4", R: "4A91D8", T: "12F390" },
  { L: "4A91D8", B: "12E7D8", R: "4A9AA2", T: "12EDB4" },
  { L: "4A91D8", B: "12EDB4", R: "4A9AA2", T: "12F390" },
  { L: "4A9AA2", B: "12EDB4", R: "4AA36C", T: "12F390" },
  { L: "4A5452", B: "12F390", R: "4A5D1C", T: "12F96C" },
  { L: "4A5D1C", B: "12F390", R: "4A65E6", T: "12F96C" },
  { L: "4A65E6", B: "12F390", R: "4A6EB0", T: "12F96C" },
  { L: "4A5D1C", B: "12F96C", R: "4A65E6", T: "12FF48" },
  { L: "4A65E6", B: "12F96C", R: "4A6EB0", T: "12FF48" },
  { L: "4A6EB0", B: "12F390", R: "4A777A", T: "12F96C" },
  { L: "4A777A", B: "12F390", R: "4A8044", T: "12F96C" },
  { L: "4A6EB0", B: "12F96C", R: "4A777A", T: "12FF48" },
  { L: "4A777A", B: "12F96C", R: "4A8044", T: "12FF48" },
  { L: "4A8044", B: "12F390", R: "4A890E", T: "12F96C" },
  { L: "4A890E", B: "12F390", R: "4A91D8", T: "12F96C" },
  { L: "4A8044", B: "12F96C", R: "4A890E", T: "12FF48" },
  { L: "4A890E", B: "12F96C", R: "4A91D8", T: "12FF48" },
  { L: "4A91D8", B: "12F390", R: "4A9AA2", T: "12F96C" },
  { L: "4A9AA2", B: "12F390", R: "4AA36C", T: "12F96C" },
  { L: "4A91D8", B: "12F96C", R: "4A9AA2", T: "12FF48" },
  { L: "4A9AA2", B: "12F96C", R: "4AA36C", T: "12FF48" },
  { L: "4AA36C", B: "12F390", R: "4AAC36", T: "12F96C" },
  { L: "4AA36C", B: "12F96C", R: "4AAC36", T: "12FF48" },
  { L: "4A2860", B: "12FF48", R: "4A312A", T: "130524" },
  { L: "4A312A", B: "12FF48", R: "4A39F4", T: "130524" },
  { L: "4A2860", B: "130524", R: "4A312A", T: "130B00" },
  { L: "4A312A", B: "130524", R: "4A39F4", T: "130B00" },
  { L: "4A39F4", B: "130524", R: "4A42BE", T: "130B00" },
  { L: "4A42BE", B: "130524", R: "4A4B88", T: "130B00" },
  { L: "4A5D1C", B: "12FF48", R: "4A65E6", T: "130524" },
  { L: "4A65E6", B: "12FF48", R: "4A6EB0", T: "130524" },
  { L: "4A5D1C", B: "130524", R: "4A65E6", T: "130B00" },
  { L: "4A65E6", B: "130524", R: "4A6EB0", T: "130B00" },
  { L: "4A6EB0", B: "12FF48", R: "4A777A", T: "130524" },
  { L: "4A777A", B: "12FF48", R: "4A8044", T: "130524" },
  { L: "4A6EB0", B: "130524", R: "4A777A", T: "130B00" },
  { L: "4A777A", B: "130524", R: "4A8044", T: "130B00" },
  { L: "4A8044", B: "12FF48", R: "4A890E", T: "130524" },
  { L: "4A890E", B: "12FF48", R: "4A91D8", T: "130524" },
  { L: "4A8044", B: "130524", R: "4A890E", T: "130B00" },
  { L: "4A890E", B: "130524", R: "4A91D8", T: "130B00" },
  { L: "4A91D8", B: "12FF48", R: "4A9AA2", T: "130524" },
  { L: "4A9AA2", B: "12FF48", R: "4AA36C", T: "130524" },
  { L: "4A91D8", B: "130524", R: "4A9AA2", T: "130B00" },
  { L: "4A9AA2", B: "130524", R: "4AA36C", T: "130B00" },
  { L: "4AA36C", B: "12FF48", R: "4AAC36", T: "130524" },
  { L: "4AA36C", B: "130524", R: "4AAC36", T: "130B00" },
  { L: "4AAC36", B: "130524", R: "4AB500", T: "130B00" },
  { L: "4ACF5E", B: "12B31C", R: "4AD828", T: "12B8F8" },
  { L: "4B2742", B: "12D644", R: "4B300C", T: "12DC20" },
  { L: "4B15AE", B: "12E7D8", R: "4B1E78", T: "12EDB4" },
  { L: "4B0CE4", B: "12EDB4", R: "4B15AE", T: "12F390" },
  { L: "4B15AE", B: "12EDB4", R: "4B1E78", T: "12F390" },
  { L: "4B1E78", B: "12EDB4", R: "4B2742", T: "12F390" },
  { L: "4B2742", B: "12EDB4", R: "4B300C", T: "12F390" },
  { L: "4AF286", B: "12F96C", R: "4AFB50", T: "12FF48" },
  { L: "4AFB50", B: "12F390", R: "4B041A", T: "12F96C" },
  { L: "4B041A", B: "12F390", R: "4B0CE4", T: "12F96C" },
  { L: "4AFB50", B: "12F96C", R: "4B041A", T: "12FF48" },
  { L: "4B041A", B: "12F96C", R: "4B0CE4", T: "12FF48" },
  { L: "4B0CE4", B: "12F390", R: "4B15AE", T: "12F96C" },
  { L: "4B15AE", B: "12F390", R: "4B1E78", T: "12F96C" },
  { L: "4B0CE4", B: "12F96C", R: "4B15AE", T: "12FF48" },
  { L: "4B15AE", B: "12F96C", R: "4B1E78", T: "12FF48" },
  { L: "4B1E78", B: "12F390", R: "4B2742", T: "12F96C" },
  { L: "4ABDCA", B: "12FF48", R: "4AC694", T: "130524" },
  { L: "4ABDCA", B: "130524", R: "4AC694", T: "130B00" },
  { L: "4AC694", B: "12FF48", R: "4ACF5E", T: "130524" },
  { L: "4AC694", B: "130524", R: "4ACF5E", T: "130B00" },
  { L: "4AF286", B: "12FF48", R: "4AFB50", T: "130524" },
  { L: "4AF286", B: "130524", R: "4AFB50", T: "130B00" },
  { L: "4AFB50", B: "12FF48", R: "4B041A", T: "130524" },
  { L: "4B041A", B: "12FF48", R: "4B0CE4", T: "130524" },
  { L: "4AFB50", B: "130524", R: "4B041A", T: "130B00" },
  { L: "4B0CE4", B: "12FF48", R: "4B15AE", T: "130524" },
  { L: "4B64C8", B: "130524", R: "4B6D92", T: "130B00" },
  { L: "4B6D92", B: "130524", R: "4B765C", T: "130B00" },
  { L: "4B765C", B: "130524", R: "4B7F26", T: "130B00" },
  { L: "4B7F26", B: "130524", R: "4B87F0", T: "130B00" },
  { L: "4B9984", B: "130524", R: "4BA24E", T: "130B00" },
  { L: "4BA24E", B: "130524", R: "4BAB18", T: "130B00" },
  { L: "4BAB18", B: "130524", R: "4BB3E2", T: "130B00" },
  { L: "4BB3E2", B: "130524", R: "4BBCAC", T: "130B00" },
  { L: "4BBCAC", B: "130524", R: "4BC576", T: "130B00" },
  { L: "4BC576", B: "130524", R: "4BCE40", T: "130B00" },
  { L: "4C494C", B: "130524", R: "4C5216", T: "130B00" },
  { L: "4C5216", B: "130524", R: "4C5AE0", T: "130B00" },
  { L: "485F58", B: "130B00", R: "486822", T: "1310DC" },
  { L: "486822", B: "130B00", R: "4870EC", T: "1310DC" },
  { L: "48F4C2", B: "1316B8", R: "48FD8C", T: "131C94" },
  { L: "48F4C2", B: "131C94", R: "48FD8C", T: "132270" },
  { L: "48FD8C", B: "1316B8", R: "490656", T: "131C94" },
  { L: "48FD8C", B: "131C94", R: "490656", T: "132270" },
  { L: "488280", B: "132270", R: "488B4A", T: "13284C" },
  { L: "488B4A", B: "132270", R: "489414", T: "13284C" },
  { L: "488280", B: "13284C", R: "488B4A", T: "132E28" },
  { L: "488B4A", B: "13284C", R: "489414", T: "132E28" },
  { L: "489414", B: "133404", R: "489CDE", T: "1339E0" },
  { L: "489CDE", B: "133404", R: "48A5A8", T: "1339E0" },
  { L: "489CDE", B: "1339E0", R: "48A5A8", T: "133FBC" },
  { L: "48C006", B: "135150", R: "48C8D0", T: "13572C" },
  { L: "48C006", B: "13572C", R: "48C8D0", T: "135D08" },
  { L: "48C8D0", B: "135150", R: "48D19A", T: "13572C" },
  { L: "48C8D0", B: "13572C", R: "48D19A", T: "135D08" },
  { L: "496FCE", B: "130B00", R: "497898", T: "1310DC" },
  { L: "497898", B: "130B00", R: "498162", T: "1310DC" },
  { L: "498162", B: "130B00", R: "498A2C", T: "1310DC" },
  { L: "497898", B: "1310DC", R: "498162", T: "1316B8" },
  { L: "498162", B: "1310DC", R: "498A2C", T: "1316B8" },
  { L: "498A2C", B: "130B00", R: "4992F6", T: "1310DC" },
  { L: "4992F6", B: "130B00", R: "499BC0", T: "1310DC" },
  { L: "498A2C", B: "1310DC", R: "4992F6", T: "1316B8" },
  { L: "4992F6", B: "1310DC", R: "499BC0", T: "1316B8" },
  { L: "495E3A", B: "1316B8", R: "496704", T: "131C94" },
  { L: "495E3A", B: "131C94", R: "496704", T: "132270" },
  { L: "496704", B: "1316B8", R: "496FCE", T: "131C94" },
  { L: "496704", B: "131C94", R: "496FCE", T: "132270" },
  { L: "497898", B: "1316B8", R: "498162", T: "131C94" },
  { L: "498162", B: "1316B8", R: "498A2C", T: "131C94" },
  { L: "497898", B: "131C94", R: "498162", T: "132270" },
  { L: "498A2C", B: "1316B8", R: "4992F6", T: "131C94" },
  { L: "4992F6", B: "1316B8", R: "499BC0", T: "131C94" },
  { L: "490F20", B: "132270", R: "4917EA", T: "13284C" },
  { L: "494CA6", B: "133404", R: "495570", T: "1339E0" },
  { L: "4992F6", B: "1339E0", R: "499BC0", T: "133FBC" },
  { L: "4992F6", B: "133FBC", R: "499BC0", T: "134598" },
  { L: "4992F6", B: "134598", R: "499BC0", T: "134B74" },
  { L: "496FCE", B: "135150", R: "497898", T: "13572C" },
  { L: "499BC0", B: "130B00", R: "49A48A", T: "1310DC" },
  { L: "49A48A", B: "130B00", R: "49AD54", T: "1310DC" },
  { L: "499BC0", B: "1310DC", R: "49A48A", T: "1316B8" },
  { L: "49A48A", B: "1310DC", R: "49AD54", T: "1316B8" },
  { L: "49AD54", B: "1310DC", R: "49B61E", T: "1316B8" },
  { L: "49B61E", B: "1310DC", R: "49BEE8", T: "1316B8" },
  { L: "49C7B2", B: "1310DC", R: "49D07C", T: "1316B8" },
  { L: "49D07C", B: "1310DC", R: "49D946", T: "1316B8" },
  { L: "4A0E02", B: "130B00", R: "4A16CC", T: "1310DC" },
  { L: "4A0538", B: "1310DC", R: "4A0E02", T: "1316B8" },
  { L: "4A0E02", B: "1310DC", R: "4A16CC", T: "1316B8" },
  { L: "4A16CC", B: "130B00", R: "4A1F96", T: "1310DC" },
  { L: "4A1F96", B: "130B00", R: "4A2860", T: "1310DC" },
  { L: "4A16CC", B: "1310DC", R: "4A1F96", T: "1316B8" },
  { L: "4A1F96", B: "1310DC", R: "4A2860", T: "1316B8" },
  { L: "49B61E", B: "1316B8", R: "49BEE8", T: "131C94" },
  { L: "49C7B2", B: "1316B8", R: "49D07C", T: "131C94" },
  { L: "49D07C", B: "1316B8", R: "49D946", T: "131C94" },
  { L: "49D946", B: "1316B8", R: "49E210", T: "131C94" },
  { L: "49D07C", B: "131C94", R: "49D946", T: "132270" },
  { L: "49D946", B: "131C94", R: "49E210", T: "132270" },
  { L: "49E210", B: "1316B8", R: "49EADA", T: "131C94" },
  { L: "49EADA", B: "1316B8", R: "49F3A4", T: "131C94" },
  { L: "49E210", B: "131C94", R: "49EADA", T: "132270" },
  { L: "49EADA", B: "131C94", R: "49F3A4", T: "132270" },
  { L: "49F3A4", B: "1316B8", R: "49FC6E", T: "131C94" },
  { L: "49FC6E", B: "1316B8", R: "4A0538", T: "131C94" },
  { L: "49F3A4", B: "131C94", R: "49FC6E", T: "132270" },
  { L: "49FC6E", B: "131C94", R: "4A0538", T: "132270" },
  { L: "4A0538", B: "1316B8", R: "4A0E02", T: "131C94" },
  { L: "4A0E02", B: "1316B8", R: "4A16CC", T: "131C94" },
  { L: "4A0538", B: "131C94", R: "4A0E02", T: "132270" },
  { L: "4A0E02", B: "131C94", R: "4A16CC", T: "132270" },
  { L: "4A16CC", B: "1316B8", R: "4A1F96", T: "131C94" },
  { L: "4A1F96", B: "1316B8", R: "4A2860", T: "131C94" },
  { L: "4A16CC", B: "131C94", R: "4A1F96", T: "132270" },
  { L: "4A1F96", B: "131C94", R: "4A2860", T: "132270" },
  { L: "49D946", B: "132270", R: "49E210", T: "13284C" },
  { L: "49E210", B: "132270", R: "49EADA", T: "13284C" },
  { L: "49EADA", B: "132270", R: "49F3A4", T: "13284C" },
  { L: "49E210", B: "13284C", R: "49EADA", T: "132E28" },
  { L: "49EADA", B: "13284C", R: "49F3A4", T: "132E28" },
  { L: "49F3A4", B: "132270", R: "49FC6E", T: "13284C" },
  { L: "49FC6E", B: "132270", R: "4A0538", T: "13284C" },
  { L: "49F3A4", B: "13284C", R: "49FC6E", T: "132E28" },
  { L: "49FC6E", B: "13284C", R: "4A0538", T: "132E28" },
  { L: "4A0538", B: "132270", R: "4A0E02", T: "13284C" },
  { L: "4A0E02", B: "132270", R: "4A16CC", T: "13284C" },
  { L: "4A0538", B: "13284C", R: "4A0E02", T: "132E28" },
  { L: "4A0E02", B: "13284C", R: "4A16CC", T: "132E28" },
  { L: "4A16CC", B: "132270", R: "4A1F96", T: "13284C" },
  { L: "4A1F96", B: "132270", R: "4A2860", T: "13284C" },
  { L: "4A16CC", B: "13284C", R: "4A1F96", T: "132E28" },
  { L: "4A1F96", B: "13284C", R: "4A2860", T: "132E28" },
  { L: "4A0538", B: "132E28", R: "4A0E02", T: "133404" },
  { L: "4A0E02", B: "132E28", R: "4A16CC", T: "133404" },
  { L: "4A16CC", B: "132E28", R: "4A1F96", T: "133404" },
  { L: "4A1F96", B: "132E28", R: "4A2860", T: "133404" },
  { L: "4A1F96", B: "133404", R: "4A2860", T: "1339E0" },
  { L: "499BC0", B: "1339E0", R: "49A48A", T: "133FBC" },
  { L: "499BC0", B: "133FBC", R: "49A48A", T: "134598" },
  { L: "4A1F96", B: "1339E0", R: "4A2860", T: "133FBC" },
  { L: "499BC0", B: "134598", R: "49A48A", T: "134B74" },
  { L: "4A0E02", B: "1362E4", R: "4A16CC", T: "1368C0" },
  { L: "4A2860", B: "130B00", R: "4A312A", T: "1310DC" },
  { L: "4A312A", B: "130B00", R: "4A39F4", T: "1310DC" },
  { L: "4A2860", B: "1310DC", R: "4A312A", T: "1316B8" },
  { L: "4A312A", B: "1310DC", R: "4A39F4", T: "1316B8" },
  { L: "4A39F4", B: "130B00", R: "4A42BE", T: "1310DC" },
  { L: "4A42BE", B: "130B00", R: "4A4B88", T: "1310DC" },
  { L: "4A39F4", B: "1310DC", R: "4A42BE", T: "1316B8" },
  { L: "4A42BE", B: "1310DC", R: "4A4B88", T: "1316B8" },
  { L: "4A4B88", B: "130B00", R: "4A5452", T: "1310DC" },
  { L: "4A5452", B: "130B00", R: "4A5D1C", T: "1310DC" },
  { L: "4A4B88", B: "1310DC", R: "4A5452", T: "1316B8" },
  { L: "4A5452", B: "1310DC", R: "4A5D1C", T: "1316B8" },
  { L: "4A5D1C", B: "130B00", R: "4A65E6", T: "1310DC" },
  { L: "4A65E6", B: "130B00", R: "4A6EB0", T: "1310DC" },
  { L: "4A5D1C", B: "1310DC", R: "4A65E6", T: "1316B8" },
  { L: "4A65E6", B: "1310DC", R: "4A6EB0", T: "1316B8" },
  { L: "4A6EB0", B: "130B00", R: "4A777A", T: "1310DC" },
  { L: "4A777A", B: "130B00", R: "4A8044", T: "1310DC" },
  { L: "4A6EB0", B: "1310DC", R: "4A777A", T: "1316B8" },
  { L: "4A777A", B: "1310DC", R: "4A8044", T: "1316B8" },
  { L: "4A8044", B: "130B00", R: "4A890E", T: "1310DC" },
  { L: "4A890E", B: "130B00", R: "4A91D8", T: "1310DC" },
  { L: "4A8044", B: "1310DC", R: "4A890E", T: "1316B8" },
  { L: "4A890E", B: "1310DC", R: "4A91D8", T: "1316B8" },
  { L: "4A91D8", B: "130B00", R: "4A9AA2", T: "1310DC" },
  { L: "4A9AA2", B: "130B00", R: "4AA36C", T: "1310DC" },
  { L: "4A91D8", B: "1310DC", R: "4A9AA2", T: "1316B8" },
  { L: "4A9AA2", B: "1310DC", R: "4AA36C", T: "1316B8" },
  { L: "4AA36C", B: "130B00", R: "4AAC36", T: "1310DC" },
  { L: "4AAC36", B: "130B00", R: "4AB500", T: "1310DC" },
  { L: "4AA36C", B: "1310DC", R: "4AAC36", T: "1316B8" },
  { L: "4AAC36", B: "1310DC", R: "4AB500", T: "1316B8" },
  { L: "4A2860", B: "1316B8", R: "4A312A", T: "131C94" },
  { L: "4A312A", B: "1316B8", R: "4A39F4", T: "131C94" },
  { L: "4A2860", B: "131C94", R: "4A312A", T: "132270" },
  { L: "4A312A", B: "131C94", R: "4A39F4", T: "132270" },
  { L: "4A39F4", B: "1316B8", R: "4A42BE", T: "131C94" },
  { L: "4A42BE", B: "1316B8", R: "4A4B88", T: "131C94" },
  { L: "4A39F4", B: "131C94", R: "4A42BE", T: "132270" },
  { L: "4A42BE", B: "131C94", R: "4A4B88", T: "132270" },
  { L: "4A4B88", B: "1316B8", R: "4A5452", T: "131C94" },
  { L: "4A5452", B: "1316B8", R: "4A5D1C", T: "131C94" },
  { L: "4A4B88", B: "131C94", R: "4A5452", T: "132270" },
  { L: "4A5452", B: "131C94", R: "4A5D1C", T: "132270" },
  { L: "4A5D1C", B: "1316B8", R: "4A65E6", T: "131C94" },
  { L: "4A65E6", B: "1316B8", R: "4A6EB0", T: "131C94" },
  { L: "4A5D1C", B: "131C94", R: "4A65E6", T: "132270" },
  { L: "4A65E6", B: "131C94", R: "4A6EB0", T: "132270" },
  { L: "4A6EB0", B: "1316B8", R: "4A777A", T: "131C94" },
  { L: "4A777A", B: "1316B8", R: "4A8044", T: "131C94" },
  { L: "4A6EB0", B: "131C94", R: "4A777A", T: "132270" },
  { L: "4A777A", B: "131C94", R: "4A8044", T: "132270" },
  { L: "4A8044", B: "1316B8", R: "4A890E", T: "131C94" },
  { L: "4A890E", B: "1316B8", R: "4A91D8", T: "131C94" },
  { L: "4A8044", B: "131C94", R: "4A890E", T: "132270" },
  { L: "4A890E", B: "131C94", R: "4A91D8", T: "132270" },
  { L: "4A91D8", B: "1316B8", R: "4A9AA2", T: "131C94" },
  { L: "4A9AA2", B: "1316B8", R: "4AA36C", T: "131C94" },
  { L: "4A91D8", B: "131C94", R: "4A9AA2", T: "132270" },
  { L: "4A9AA2", B: "131C94", R: "4AA36C", T: "132270" },
  { L: "4A39F4", B: "132270", R: "4A42BE", T: "13284C" },
  { L: "4A42BE", B: "132270", R: "4A4B88", T: "13284C" },
  { L: "4A39F4", B: "13284C", R: "4A42BE", T: "132E28" },
  { L: "4A42BE", B: "13284C", R: "4A4B88", T: "132E28" },
  { L: "4A4B88", B: "132270", R: "4A5452", T: "13284C" },
  { L: "4A5452", B: "132270", R: "4A5D1C", T: "13284C" },
  { L: "4A4B88", B: "13284C", R: "4A5452", T: "132E28" },
  { L: "4A5452", B: "13284C", R: "4A5D1C", T: "132E28" },
  { L: "4A5D1C", B: "132270", R: "4A65E6", T: "13284C" },
  { L: "4A65E6", B: "132270", R: "4A6EB0", T: "13284C" },
  { L: "4A5D1C", B: "13284C", R: "4A65E6", T: "132E28" },
  { L: "4A65E6", B: "13284C", R: "4A6EB0", T: "132E28" },
  { L: "4A6EB0", B: "132270", R: "4A777A", T: "13284C" },
  { L: "4A777A", B: "132270", R: "4A8044", T: "13284C" },
  { L: "4A6EB0", B: "13284C", R: "4A777A", T: "132E28" },
  { L: "4A777A", B: "13284C", R: "4A8044", T: "132E28" },
  { L: "4A8044", B: "132270", R: "4A890E", T: "13284C" },
  { L: "4A890E", B: "132270", R: "4A91D8", T: "13284C" },
  { L: "4A8044", B: "13284C", R: "4A890E", T: "132E28" },
  { L: "4A890E", B: "13284C", R: "4A91D8", T: "132E28" },
  { L: "4A91D8", B: "132270", R: "4A9AA2", T: "13284C" },
  { L: "4A9AA2", B: "132270", R: "4AA36C", T: "13284C" },
  { L: "4A91D8", B: "13284C", R: "4A9AA2", T: "132E28" },
  { L: "4A9AA2", B: "13284C", R: "4AA36C", T: "132E28" },
  { L: "4AA36C", B: "132270", R: "4AAC36", T: "13284C" },
  { L: "4AA36C", B: "13284C", R: "4AAC36", T: "132E28" },
  { L: "4AAC36", B: "13284C", R: "4AB500", T: "132E28" },
  { L: "4A2860", B: "133404", R: "4A312A", T: "1339E0" },
  { L: "4A39F4", B: "132E28", R: "4A42BE", T: "133404" },
  { L: "4A42BE", B: "132E28", R: "4A4B88", T: "133404" },
  { L: "4A5452", B: "132E28", R: "4A5D1C", T: "133404" },
  { L: "4A5452", B: "133404", R: "4A5D1C", T: "1339E0" },
  { L: "4A5D1C", B: "132E28", R: "4A65E6", T: "133404" },
  { L: "4A65E6", B: "132E28", R: "4A6EB0", T: "133404" },
  { L: "4A5D1C", B: "133404", R: "4A65E6", T: "1339E0" },
  { L: "4A65E6", B: "133404", R: "4A6EB0", T: "1339E0" },
  { L: "4A6EB0", B: "132E28", R: "4A777A", T: "133404" },
  { L: "4A777A", B: "132E28", R: "4A8044", T: "133404" },
  { L: "4A6EB0", B: "133404", R: "4A777A", T: "1339E0" },
  { L: "4A777A", B: "133404", R: "4A8044", T: "1339E0" },
  { L: "4A8044", B: "132E28", R: "4A890E", T: "133404" },
  { L: "4A890E", B: "132E28", R: "4A91D8", T: "133404" },
  { L: "4A8044", B: "133404", R: "4A890E", T: "1339E0" },
  { L: "4A890E", B: "133404", R: "4A91D8", T: "1339E0" },
  { L: "4A91D8", B: "132E28", R: "4A9AA2", T: "133404" },
  { L: "4A9AA2", B: "132E28", R: "4AA36C", T: "133404" },
  { L: "4A91D8", B: "133404", R: "4A9AA2", T: "1339E0" },
  { L: "4A9AA2", B: "133404", R: "4AA36C", T: "1339E0" },
  { L: "4AA36C", B: "132E28", R: "4AAC36", T: "133404" },
  { L: "4AAC36", B: "132E28", R: "4AB500", T: "133404" },
  { L: "4AA36C", B: "133404", R: "4AAC36", T: "1339E0" },
  { L: "4AAC36", B: "133404", R: "4AB500", T: "1339E0" },
  { L: "4A2860", B: "1339E0", R: "4A312A", T: "133FBC" },
  { L: "4A39F4", B: "133FBC", R: "4A42BE", T: "134598" },
  { L: "4A42BE", B: "133FBC", R: "4A4B88", T: "134598" },
  { L: "4A5452", B: "1339E0", R: "4A5D1C", T: "133FBC" },
  { L: "4A5452", B: "133FBC", R: "4A5D1C", T: "134598" },
  { L: "4A5D1C", B: "1339E0", R: "4A65E6", T: "133FBC" },
  { L: "4A6EB0", B: "1339E0", R: "4A777A", T: "133FBC" },
  { L: "4A777A", B: "1339E0", R: "4A8044", T: "133FBC" },
  { L: "4A8044", B: "1339E0", R: "4A890E", T: "133FBC" },
  { L: "4A890E", B: "1339E0", R: "4A91D8", T: "133FBC" },
  { L: "4A890E", B: "133FBC", R: "4A91D8", T: "134598" },
  { L: "4A91D8", B: "1339E0", R: "4A9AA2", T: "133FBC" },
  { L: "4A9AA2", B: "1339E0", R: "4AA36C", T: "133FBC" },
  { L: "4A91D8", B: "133FBC", R: "4A9AA2", T: "134598" },
  { L: "4A9AA2", B: "133FBC", R: "4AA36C", T: "134598" },
  { L: "4AA36C", B: "1339E0", R: "4AAC36", T: "133FBC" },
  { L: "4AAC36", B: "1339E0", R: "4AB500", T: "133FBC" },
  { L: "4AA36C", B: "133FBC", R: "4AAC36", T: "134598" },
  { L: "4AAC36", B: "133FBC", R: "4AB500", T: "134598" },
  { L: "4A312A", B: "134598", R: "4A39F4", T: "134B74" },
  { L: "4A2860", B: "134B74", R: "4A312A", T: "135150" },
  { L: "4A312A", B: "134B74", R: "4A39F4", T: "135150" },
  { L: "4A91D8", B: "134598", R: "4A9AA2", T: "134B74" },
  { L: "4A9AA2", B: "134598", R: "4AA36C", T: "134B74" },
  { L: "4AA36C", B: "134598", R: "4AAC36", T: "134B74" },
  { L: "4AAC36", B: "134598", R: "4AB500", T: "134B74" },
  { L: "4AA36C", B: "134B74", R: "4AAC36", T: "135150" },
  { L: "4AAC36", B: "134B74", R: "4AB500", T: "135150" },
  { L: "4A2860", B: "135150", R: "4A312A", T: "13572C" },
  { L: "4A312A", B: "135D08", R: "4A39F4", T: "1362E4" },
  { L: "4A312A", B: "1362E4", R: "4A39F4", T: "1368C0" },
  { L: "4A39F4", B: "135D08", R: "4A42BE", T: "1362E4" },
  { L: "4A42BE", B: "135D08", R: "4A4B88", T: "1362E4" },
  { L: "4A39F4", B: "1362E4", R: "4A42BE", T: "1368C0" },
  { L: "4A42BE", B: "1362E4", R: "4A4B88", T: "1368C0" },
  { L: "4A4B88", B: "135D08", R: "4A5452", T: "1362E4" },
  { L: "4A4B88", B: "1362E4", R: "4A5452", T: "1368C0" },
  { L: "4ABDCA", B: "1310DC", R: "4AC694", T: "1316B8" },
  { L: "4AC694", B: "1310DC", R: "4ACF5E", T: "1316B8" },
  { L: "4AF286", B: "130B00", R: "4AFB50", T: "1310DC" },
  { L: "4AF286", B: "1310DC", R: "4AFB50", T: "1316B8" },
  { L: "4AFB50", B: "130B00", R: "4B041A", T: "1310DC" },
  { L: "4AFB50", B: "1310DC", R: "4B041A", T: "1316B8" },
  { L: "4B2742", B: "1310DC", R: "4B300C", T: "1316B8" },
  { L: "4B300C", B: "130B00", R: "4B38D6", T: "1310DC" },
  { L: "4B38D6", B: "130B00", R: "4B41A0", T: "1310DC" },
  { L: "4B300C", B: "1310DC", R: "4B38D6", T: "1316B8" },
  { L: "4B38D6", B: "1310DC", R: "4B41A0", T: "1316B8" },
  { L: "4ABDCA", B: "1316B8", R: "4AC694", T: "131C94" },
  { L: "4AC694", B: "1316B8", R: "4ACF5E", T: "131C94" },
  { L: "4AF286", B: "1316B8", R: "4AFB50", T: "131C94" },
  { L: "4AF286", B: "131C94", R: "4AFB50", T: "132270" },
  { L: "4AFB50", B: "1316B8", R: "4B041A", T: "131C94" },
  { L: "4B041A", B: "1316B8", R: "4B0CE4", T: "131C94" },
  { L: "4AFB50", B: "131C94", R: "4B041A", T: "132270" },
  { L: "4B041A", B: "131C94", R: "4B0CE4", T: "132270" },
  { L: "4B2742", B: "1316B8", R: "4B300C", T: "131C94" },
  { L: "4B2742", B: "131C94", R: "4B300C", T: "132270" },
  { L: "4B300C", B: "1316B8", R: "4B38D6", T: "131C94" },
  { L: "4B38D6", B: "1316B8", R: "4B41A0", T: "131C94" },
  { L: "4B300C", B: "131C94", R: "4B38D6", T: "132270" },
  { L: "4B38D6", B: "131C94", R: "4B41A0", T: "132270" },
  { L: "4AE9BC", B: "132270", R: "4AF286", T: "13284C" },
  { L: "4AF286", B: "132270", R: "4AFB50", T: "13284C" },
  { L: "4AF286", B: "13284C", R: "4AFB50", T: "132E28" },
  { L: "4AFB50", B: "132270", R: "4B041A", T: "13284C" },
  { L: "4B041A", B: "132270", R: "4B0CE4", T: "13284C" },
  { L: "4AFB50", B: "13284C", R: "4B041A", T: "132E28" },
  { L: "4B041A", B: "13284C", R: "4B0CE4", T: "132E28" },
  { L: "4B0CE4", B: "132270", R: "4B15AE", T: "13284C" },
  { L: "4B0CE4", B: "13284C", R: "4B15AE", T: "132E28" },
  { L: "4B1E78", B: "132270", R: "4B2742", T: "13284C" },
  { L: "4B2742", B: "132270", R: "4B300C", T: "13284C" },
  { L: "4B1E78", B: "13284C", R: "4B2742", T: "132E28" },
  { L: "4B2742", B: "13284C", R: "4B300C", T: "132E28" },
  { L: "4B300C", B: "132270", R: "4B38D6", T: "13284C" },
  { L: "4B38D6", B: "132270", R: "4B41A0", T: "13284C" },
  { L: "4B300C", B: "13284C", R: "4B38D6", T: "132E28" },
  { L: "4B38D6", B: "13284C", R: "4B41A0", T: "132E28" },
  { L: "4AB500", B: "133404", R: "4ABDCA", T: "1339E0" },
  { L: "4AF286", B: "132E28", R: "4AFB50", T: "133404" },
  { L: "4AF286", B: "133404", R: "4AFB50", T: "1339E0" },
  { L: "4AFB50", B: "132E28", R: "4B041A", T: "133404" },
  { L: "4B041A", B: "132E28", R: "4B0CE4", T: "133404" },
  { L: "4AFB50", B: "133404", R: "4B041A", T: "1339E0" },
  { L: "4B041A", B: "133404", R: "4B0CE4", T: "1339E0" },
  { L: "4B0CE4", B: "132E28", R: "4B15AE", T: "133404" },
  { L: "4B0CE4", B: "133404", R: "4B15AE", T: "1339E0" },
  { L: "4B2742", B: "132E28", R: "4B300C", T: "133404" },
  { L: "4B2742", B: "133404", R: "4B300C", T: "1339E0" },
  { L: "4B300C", B: "132E28", R: "4B38D6", T: "133404" },
  { L: "4B38D6", B: "132E28", R: "4B41A0", T: "133404" },
  { L: "4B300C", B: "133404", R: "4B38D6", T: "1339E0" },
  { L: "4B38D6", B: "133404", R: "4B41A0", T: "1339E0" },
  { L: "4AB500", B: "1339E0", R: "4ABDCA", T: "133FBC" },
  { L: "4AB500", B: "133FBC", R: "4ABDCA", T: "134598" },
  { L: "4ABDCA", B: "133FBC", R: "4AC694", T: "134598" },
  { L: "4AC694", B: "133FBC", R: "4ACF5E", T: "134598" },
  { L: "4ACF5E", B: "133FBC", R: "4AD828", T: "134598" },
  { L: "4AF286", B: "1339E0", R: "4AFB50", T: "133FBC" },
  { L: "4AFB50", B: "1339E0", R: "4B041A", T: "133FBC" },
  { L: "4B041A", B: "1339E0", R: "4B0CE4", T: "133FBC" },
  { L: "4AFB50", B: "133FBC", R: "4B041A", T: "134598" },
  { L: "4B041A", B: "133FBC", R: "4B0CE4", T: "134598" },
  { L: "4B0CE4", B: "1339E0", R: "4B15AE", T: "133FBC" },
  { L: "4B15AE", B: "1339E0", R: "4B1E78", T: "133FBC" },
  { L: "4B0CE4", B: "133FBC", R: "4B15AE", T: "134598" },
  { L: "4B15AE", B: "133FBC", R: "4B1E78", T: "134598" },
  { L: "4B1E78", B: "1339E0", R: "4B2742", T: "133FBC" },
  { L: "4B2742", B: "1339E0", R: "4B300C", T: "133FBC" },
  { L: "4B1E78", B: "133FBC", R: "4B2742", T: "134598" },
  { L: "4B2742", B: "133FBC", R: "4B300C", T: "134598" },
  { L: "4B300C", B: "1339E0", R: "4B38D6", T: "133FBC" },
  { L: "4B38D6", B: "1339E0", R: "4B41A0", T: "133FBC" },
  { L: "4B300C", B: "133FBC", R: "4B38D6", T: "134598" },
  { L: "4B38D6", B: "133FBC", R: "4B41A0", T: "134598" },
  { L: "4AB500", B: "134598", R: "4ABDCA", T: "134B74" },
  { L: "4ABDCA", B: "134598", R: "4AC694", T: "134B74" },
  { L: "4AB500", B: "134B74", R: "4ABDCA", T: "135150" },
  { L: "4ABDCA", B: "134B74", R: "4AC694", T: "135150" },
  { L: "4AC694", B: "134598", R: "4ACF5E", T: "134B74" },
  { L: "4ACF5E", B: "134598", R: "4AD828", T: "134B74" },
  { L: "4AC694", B: "134B74", R: "4ACF5E", T: "135150" },
  { L: "4ACF5E", B: "134B74", R: "4AD828", T: "135150" },
  { L: "4AFB50", B: "134598", R: "4B041A", T: "134B74" },
  { L: "4B041A", B: "134598", R: "4B0CE4", T: "134B74" },
  { L: "4B0CE4", B: "134598", R: "4B15AE", T: "134B74" },
  { L: "4B15AE", B: "134598", R: "4B1E78", T: "134B74" },
  { L: "4B0CE4", B: "134B74", R: "4B15AE", T: "135150" },
  { L: "4B15AE", B: "134B74", R: "4B1E78", T: "135150" },
  { L: "4B1E78", B: "134598", R: "4B2742", T: "134B74" },
  { L: "4B2742", B: "134598", R: "4B300C", T: "134B74" },
  { L: "4B1E78", B: "134B74", R: "4B2742", T: "135150" },
  { L: "4B2742", B: "134B74", R: "4B300C", T: "135150" },
  { L: "4B300C", B: "134598", R: "4B38D6", T: "134B74" },
  { L: "4B38D6", B: "134598", R: "4B41A0", T: "134B74" },
  { L: "4B300C", B: "134B74", R: "4B38D6", T: "135150" },
  { L: "4B38D6", B: "134B74", R: "4B41A0", T: "135150" },
  { L: "4ABDCA", B: "135150", R: "4AC694", T: "13572C" },
  { L: "4ABDCA", B: "13572C", R: "4AC694", T: "135D08" },
  { L: "4AC694", B: "135150", R: "4ACF5E", T: "13572C" },
  { L: "4ACF5E", B: "135150", R: "4AD828", T: "13572C" },
  { L: "4AC694", B: "13572C", R: "4ACF5E", T: "135D08" },
  { L: "4ACF5E", B: "13572C", R: "4AD828", T: "135D08" },
  { L: "4AD828", B: "13572C", R: "4AE0F2", T: "135D08" },
  { L: "4B0CE4", B: "135150", R: "4B15AE", T: "13572C" },
  { L: "4B15AE", B: "135150", R: "4B1E78", T: "13572C" },
  { L: "4B0CE4", B: "13572C", R: "4B15AE", T: "135D08" },
  { L: "4B15AE", B: "13572C", R: "4B1E78", T: "135D08" },
  { L: "4B1E78", B: "135150", R: "4B2742", T: "13572C" },
  { L: "4B2742", B: "135150", R: "4B300C", T: "13572C" },
  { L: "4B1E78", B: "13572C", R: "4B2742", T: "135D08" },
  { L: "4B2742", B: "13572C", R: "4B300C", T: "135D08" },
  { L: "4B300C", B: "135150", R: "4B38D6", T: "13572C" },
  { L: "4B38D6", B: "135150", R: "4B41A0", T: "13572C" },
  { L: "4B300C", B: "13572C", R: "4B38D6", T: "135D08" },
  { L: "4B38D6", B: "13572C", R: "4B41A0", T: "135D08" },
  { L: "4ACF5E", B: "135D08", R: "4AD828", T: "1362E4" },
  { L: "4AD828", B: "135D08", R: "4AE0F2", T: "1362E4" },
  { L: "4AD828", B: "1362E4", R: "4AE0F2", T: "1368C0" },
  { L: "4AE0F2", B: "1362E4", R: "4AE9BC", T: "1368C0" },
  { L: "4AE9BC", B: "1362E4", R: "4AF286", T: "1368C0" },
  { L: "4B041A", B: "1362E4", R: "4B0CE4", T: "1368C0" },
  { L: "4B0CE4", B: "135D08", R: "4B15AE", T: "1362E4" },
  { L: "4B15AE", B: "135D08", R: "4B1E78", T: "1362E4" },
  { L: "4B0CE4", B: "1362E4", R: "4B15AE", T: "1368C0" },
  { L: "4B15AE", B: "1362E4", R: "4B1E78", T: "1368C0" },
  { L: "4B1E78", B: "135D08", R: "4B2742", T: "1362E4" },
  { L: "4B2742", B: "135D08", R: "4B300C", T: "1362E4" },
  { L: "4B1E78", B: "1362E4", R: "4B2742", T: "1368C0" },
  { L: "4B2742", B: "1362E4", R: "4B300C", T: "1368C0" },
  { L: "4B300C", B: "135D08", R: "4B38D6", T: "1362E4" },
  { L: "4B38D6", B: "135D08", R: "4B41A0", T: "1362E4" },
  { L: "4B300C", B: "1362E4", R: "4B38D6", T: "1368C0" },
  { L: "4B38D6", B: "1362E4", R: "4B41A0", T: "1368C0" },
  { L: "4B64C8", B: "130B00", R: "4B6D92", T: "1310DC" },
  { L: "4B6D92", B: "130B00", R: "4B765C", T: "1310DC" },
  { L: "4B64C8", B: "1310DC", R: "4B6D92", T: "1316B8" },
  { L: "4B6D92", B: "1310DC", R: "4B765C", T: "1316B8" },
  { L: "4B765C", B: "130B00", R: "4B7F26", T: "1310DC" },
  { L: "4B7F26", B: "130B00", R: "4B87F0", T: "1310DC" },
  { L: "4B765C", B: "1310DC", R: "4B7F26", T: "1316B8" },
  { L: "4B7F26", B: "1310DC", R: "4B87F0", T: "1316B8" },
  { L: "4B87F0", B: "130B00", R: "4B90BA", T: "1310DC" },
  { L: "4B90BA", B: "130B00", R: "4B9984", T: "1310DC" },
  { L: "4B87F0", B: "1310DC", R: "4B90BA", T: "1316B8" },
  { L: "4B90BA", B: "1310DC", R: "4B9984", T: "1316B8" },
  { L: "4B9984", B: "130B00", R: "4BA24E", T: "1310DC" },
  { L: "4BA24E", B: "130B00", R: "4BAB18", T: "1310DC" },
  { L: "4B9984", B: "1310DC", R: "4BA24E", T: "1316B8" },
  { L: "4BA24E", B: "1310DC", R: "4BAB18", T: "1316B8" },
  { L: "4BAB18", B: "130B00", R: "4BB3E2", T: "1310DC" },
  { L: "4BB3E2", B: "130B00", R: "4BBCAC", T: "1310DC" },
  { L: "4BAB18", B: "1310DC", R: "4BB3E2", T: "1316B8" },
  { L: "4BB3E2", B: "1310DC", R: "4BBCAC", T: "1316B8" },
  { L: "4BBCAC", B: "130B00", R: "4BC576", T: "1310DC" },
  { L: "4BC576", B: "130B00", R: "4BCE40", T: "1310DC" },
  { L: "4BBCAC", B: "1310DC", R: "4BC576", T: "1316B8" },
  { L: "4BC576", B: "1310DC", R: "4BCE40", T: "1316B8" },
  { L: "4B41A0", B: "1316B8", R: "4B4A6A", T: "131C94" },
  { L: "4B4A6A", B: "1316B8", R: "4B5334", T: "131C94" },
  { L: "4B41A0", B: "131C94", R: "4B4A6A", T: "132270" },
  { L: "4B4A6A", B: "131C94", R: "4B5334", T: "132270" },
  { L: "4B5334", B: "1316B8", R: "4B5BFE", T: "131C94" },
  { L: "4B5BFE", B: "1316B8", R: "4B64C8", T: "131C94" },
  { L: "4B5334", B: "131C94", R: "4B5BFE", T: "132270" },
  { L: "4B5BFE", B: "131C94", R: "4B64C8", T: "132270" },
  { L: "4B64C8", B: "1316B8", R: "4B6D92", T: "131C94" },
  { L: "4B6D92", B: "1316B8", R: "4B765C", T: "131C94" },
  { L: "4B64C8", B: "131C94", R: "4B6D92", T: "132270" },
  { L: "4B6D92", B: "131C94", R: "4B765C", T: "132270" },
  { L: "4B765C", B: "1316B8", R: "4B7F26", T: "131C94" },
  { L: "4B7F26", B: "1316B8", R: "4B87F0", T: "131C94" },
  { L: "4B765C", B: "131C94", R: "4B7F26", T: "132270" },
  { L: "4B7F26", B: "131C94", R: "4B87F0", T: "132270" },
  { L: "4B90BA", B: "1316B8", R: "4B9984", T: "131C94" },
  { L: "4B9984", B: "1316B8", R: "4BA24E", T: "131C94" },
  { L: "4BA24E", B: "1316B8", R: "4BAB18", T: "131C94" },
  { L: "4B9984", B: "131C94", R: "4BA24E", T: "132270" },
  { L: "4BA24E", B: "131C94", R: "4BAB18", T: "132270" },
  { L: "4BAB18", B: "1316B8", R: "4BB3E2", T: "131C94" },
  { L: "4BB3E2", B: "1316B8", R: "4BBCAC", T: "131C94" },
  { L: "4BAB18", B: "131C94", R: "4BB3E2", T: "132270" },
  { L: "4BB3E2", B: "131C94", R: "4BBCAC", T: "132270" },
  { L: "4BBCAC", B: "1316B8", R: "4BC576", T: "131C94" },
  { L: "4BC576", B: "1316B8", R: "4BCE40", T: "131C94" },
  { L: "4BBCAC", B: "131C94", R: "4BC576", T: "132270" },
  { L: "4BC576", B: "131C94", R: "4BCE40", T: "132270" },
  { L: "4B41A0", B: "132270", R: "4B4A6A", T: "13284C" },
  { L: "4B4A6A", B: "132270", R: "4B5334", T: "13284C" },
  { L: "4B41A0", B: "13284C", R: "4B4A6A", T: "132E28" },
  { L: "4B4A6A", B: "13284C", R: "4B5334", T: "132E28" },
  { L: "4B5334", B: "132270", R: "4B5BFE", T: "13284C" },
  { L: "4B5BFE", B: "132270", R: "4B64C8", T: "13284C" },
  { L: "4B5334", B: "13284C", R: "4B5BFE", T: "132E28" },
  { L: "4B5BFE", B: "13284C", R: "4B64C8", T: "132E28" },
  { L: "4B64C8", B: "132270", R: "4B6D92", T: "13284C" },
  { L: "4B6D92", B: "132270", R: "4B765C", T: "13284C" },
  { L: "4B64C8", B: "13284C", R: "4B6D92", T: "132E28" },
  { L: "4B765C", B: "132270", R: "4B7F26", T: "13284C" },
  { L: "4B7F26", B: "132270", R: "4B87F0", T: "13284C" },
  { L: "4B7F26", B: "13284C", R: "4B87F0", T: "132E28" },
  { L: "4B87F0", B: "13284C", R: "4B90BA", T: "132E28" },
  { L: "4BAB18", B: "132270", R: "4BB3E2", T: "13284C" },
  { L: "4BB3E2", B: "132270", R: "4BBCAC", T: "13284C" },
  { L: "4BAB18", B: "13284C", R: "4BB3E2", T: "132E28" },
  { L: "4BB3E2", B: "13284C", R: "4BBCAC", T: "132E28" },
  { L: "4BBCAC", B: "132270", R: "4BC576", T: "13284C" },
  { L: "4BC576", B: "132270", R: "4BCE40", T: "13284C" },
  { L: "4B41A0", B: "132E28", R: "4B4A6A", T: "133404" },
  { L: "4B4A6A", B: "132E28", R: "4B5334", T: "133404" },
  { L: "4B41A0", B: "133404", R: "4B4A6A", T: "1339E0" },
  { L: "4B4A6A", B: "133404", R: "4B5334", T: "1339E0" },
  { L: "4B5334", B: "132E28", R: "4B5BFE", T: "133404" },
  { L: "4B5BFE", B: "132E28", R: "4B64C8", T: "133404" },
  { L: "4B5334", B: "133404", R: "4B5BFE", T: "1339E0" },
  { L: "4B5BFE", B: "133404", R: "4B64C8", T: "1339E0" },
  { L: "4B41A0", B: "1339E0", R: "4B4A6A", T: "133FBC" },
  { L: "4B4A6A", B: "1339E0", R: "4B5334", T: "133FBC" },
  { L: "4B41A0", B: "133FBC", R: "4B4A6A", T: "134598" },
  { L: "4B4A6A", B: "133FBC", R: "4B5334", T: "134598" },
  { L: "4B5334", B: "1339E0", R: "4B5BFE", T: "133FBC" },
  { L: "4B5BFE", B: "1339E0", R: "4B64C8", T: "133FBC" },
  { L: "4B5334", B: "133FBC", R: "4B5BFE", T: "134598" },
  { L: "4B5BFE", B: "133FBC", R: "4B64C8", T: "134598" },
  { L: "4B41A0", B: "134598", R: "4B4A6A", T: "134B74" },
  { L: "4B4A6A", B: "134598", R: "4B5334", T: "134B74" },
  { L: "4B41A0", B: "134B74", R: "4B4A6A", T: "135150" },
  { L: "4B4A6A", B: "134B74", R: "4B5334", T: "135150" },
  { L: "4B5334", B: "134598", R: "4B5BFE", T: "134B74" },
  { L: "4B5BFE", B: "134598", R: "4B64C8", T: "134B74" },
  { L: "4B5334", B: "134B74", R: "4B5BFE", T: "135150" },
  { L: "4B5BFE", B: "134B74", R: "4B64C8", T: "135150" },
  { L: "4B692D", B: "134886", R: "4B6D92", T: "134B74" },
  { L: "4B6D92", B: "134886", R: "4B71F7", T: "134B74" },
  { L: "4B692D", B: "134B74", R: "4B6D92", T: "134E62" },
  { L: "4B6D92", B: "134B74", R: "4B71F7", T: "134E62" },
  { L: "4B41A0", B: "135150", R: "4B4A6A", T: "13572C" },
  { L: "4B4A6A", B: "135150", R: "4B5334", T: "13572C" },
  { L: "4B41A0", B: "13572C", R: "4B4A6A", T: "135D08" },
  { L: "4B4A6A", B: "13572C", R: "4B5334", T: "135D08" },
  { L: "4B5334", B: "135150", R: "4B5BFE", T: "13572C" },
  { L: "4B5334", B: "13572C", R: "4B5BFE", T: "135D08" },
  { L: "4B41A0", B: "135D08", R: "4B4A6A", T: "1362E4" },
  { L: "4B4A6A", B: "135D08", R: "4B5334", T: "1362E4" },
  { L: "4B41A0", B: "1362E4", R: "4B4A6A", T: "1368C0" },
  { L: "4B4A6A", B: "1362E4", R: "4B5334", T: "1368C0" },
  { L: "4B5334", B: "135D08", R: "4B5BFE", T: "1362E4" },
  { L: "4B5334", B: "1362E4", R: "4B5BFE", T: "1368C0" },
  { L: "4B5BFE", B: "1362E4", R: "4B64C8", T: "1368C0" },
  { L: "4C37B8", B: "1310DC", R: "4C4082", T: "1316B8" },
  { L: "4C494C", B: "130B00", R: "4C5216", T: "1310DC" },
  { L: "4C5216", B: "130B00", R: "4C5AE0", T: "1310DC" },
  { L: "4C567B", B: "1313CA", R: "4C5AE0", T: "1316B8" },
  { L: "4BCE40", B: "1316B8", R: "4BD70A", T: "131C94" },
  { L: "4BDFD4", B: "131C94", R: "4BE89E", T: "132270" },
  { L: "4BE89E", B: "131C94", R: "4BF168", T: "132270" },
  { L: "4BF168", B: "131C94", R: "4BFA32", T: "132270" },
  { L: "4BFA32", B: "131C94", R: "4C02FC", T: "132270" },
  { L: "4C37B8", B: "1316B8", R: "4C4082", T: "131C94" },
  { L: "4C567B", B: "1316B8", R: "4C5AE0", T: "1319A6" },
  { L: "4BDFD4", B: "132270", R: "4BE89E", T: "13284C" },
  { L: "4BE89E", B: "132270", R: "4BF168", T: "13284C" },
  { L: "4BE89E", B: "13284C", R: "4BF168", T: "132E28" },
  { L: "4BF168", B: "132270", R: "4BFA32", T: "13284C" },
  { L: "4BFA32", B: "132270", R: "4C02FC", T: "13284C" },
  { L: "4BF168", B: "13284C", R: "4BFA32", T: "132E28" },
  { L: "4BFA32", B: "13284C", R: "4C02FC", T: "132E28" },
  { L: "4C37B8", B: "13284C", R: "4C4082", T: "132E28" },
  { L: "4C494C", B: "13284C", R: "4C5216", T: "132E28" },
  { L: "4BFA32", B: "132E28", R: "4C02FC", T: "133404" },
  { L: "4BFA32", B: "133404", R: "4C02FC", T: "1339E0" },
  { L: "4C02FC", B: "132E28", R: "4C0BC6", T: "133404" },
  { L: "4C0BC6", B: "132E28", R: "4C1490", T: "133404" },
  { L: "4C02FC", B: "133404", R: "4C0BC6", T: "1339E0" },
  { L: "4C0BC6", B: "133404", R: "4C1490", T: "1339E0" },
  { L: "4C1490", B: "133404", R: "4C1D5A", T: "1339E0" },
  { L: "4C37B8", B: "133404", R: "4C4082", T: "1339E0" },
  { L: "4C494C", B: "132E28", R: "4C5216", T: "133404" },
  { L: "4C494C", B: "133404", R: "4C5216", T: "1339E0" },
  { L: "4C5216", B: "133404", R: "4C5AE0", T: "1339E0" },
  { L: "4BFA32", B: "1339E0", R: "4C02FC", T: "133FBC" },
  { L: "4C02FC", B: "1339E0", R: "4C0BC6", T: "133FBC" },
  { L: "4C0BC6", B: "1339E0", R: "4C1490", T: "133FBC" },
  { L: "4C0BC6", B: "133FBC", R: "4C1490", T: "134598" },
  { L: "4C1490", B: "1339E0", R: "4C1D5A", T: "133FBC" },
  { L: "4C1490", B: "133FBC", R: "4C1D5A", T: "134598" },
  { L: "4C4082", B: "133FBC", R: "4C494C", T: "134598" },
  { L: "4C494C", B: "1339E0", R: "4C5216", T: "133FBC" },
  { L: "4C5216", B: "1339E0", R: "4C5AE0", T: "133FBC" },
  { L: "4C494C", B: "133FBC", R: "4C5216", T: "134598" },
  { L: "4C5216", B: "133FBC", R: "4C5AE0", T: "134598" },
  { L: "4C1490", B: "134598", R: "4C1D5A", T: "134B74" },
  { L: "4C1D5A", B: "134598", R: "4C2624", T: "134B74" },
  { L: "4C1D5A", B: "134B74", R: "4C2624", T: "135150" },
  { L: "4C2624", B: "134598", R: "4C2EEE", T: "134B74" },
  { L: "4C2624", B: "134B74", R: "4C2EEE", T: "135150" },
  { L: "4C2EEE", B: "134B74", R: "4C37B8", T: "135150" },
  { L: "4C37B8", B: "134598", R: "4C4082", T: "134B74" },
  { L: "4C4082", B: "134598", R: "4C494C", T: "134B74" },
  { L: "4C37B8", B: "134B74", R: "4C4082", T: "135150" },
  { L: "4C4082", B: "134B74", R: "4C494C", T: "135150" },
  { L: "4C494C", B: "134598", R: "4C5216", T: "134B74" },
  { L: "4C5216", B: "134598", R: "4C5AE0", T: "134B74" },
  { L: "4C494C", B: "134B74", R: "4C5216", T: "135150" },
  { L: "4C5216", B: "134B74", R: "4C5AE0", T: "135150" },
  { L: "4C1D5A", B: "135150", R: "4C2624", T: "13572C" },
  { L: "4C1D5A", B: "13572C", R: "4C2624", T: "135D08" },
  { L: "4C2624", B: "135150", R: "4C2EEE", T: "13572C" },
  { L: "4C2EEE", B: "135150", R: "4C37B8", T: "13572C" },
  { L: "4C2624", B: "13572C", R: "4C2EEE", T: "135D08" },
  { L: "4C494C", B: "135150", R: "4C5216", T: "13572C" },
  { L: "4C1D5A", B: "135D08", R: "4C2624", T: "1362E4" },
  { L: "4C2624", B: "135D08", R: "4C2EEE", T: "1362E4" },
  { L: "4C494C", B: "135D08", R: "4C5216", T: "1362E4" },
  { L: "4C5216", B: "135D08", R: "4C5AE0", T: "1362E4" },
  { L: "4C494C", B: "1362E4", R: "4C5216", T: "1368C0" },
  { L: "4C5216", B: "1362E4", R: "4C5AE0", T: "1368C0" },
  { L: "4C5AE0", B: "1313CA", R: "4C5F45", T: "1316B8" },
  { L: "4C5AE0", B: "1316B8", R: "4C5F45", T: "1319A6" },
  { L: "4C63AA", B: "1316B8", R: "4C6C74", T: "131C94" },
  { L: "4C63AA", B: "131C94", R: "4C6C74", T: "132270" },
  { L: "4C63AA", B: "132270", R: "4C6C74", T: "13284C" },
  { L: "4C63AA", B: "13284C", R: "4C6C74", T: "132E28" },
  { L: "4C6C74", B: "132270", R: "4C753E", T: "13284C" },
  { L: "4C6C74", B: "13284C", R: "4C753E", T: "132E28" },
  { L: "4C63AA", B: "132E28", R: "4C6C74", T: "133404" },
  { L: "4C63AA", B: "133404", R: "4C6C74", T: "1339E0" },
  { L: "4C6C74", B: "132E28", R: "4C753E", T: "133404" },
  { L: "4C6C74", B: "133404", R: "4C753E", T: "1339E0" },
  { L: "4CCD22", B: "133404", R: "4CD5EC", T: "1339E0" },
  { L: "4CD5EC", B: "133404", R: "4CDEB6", T: "1339E0" },
  { L: "4C63AA", B: "1339E0", R: "4C6C74", T: "133FBC" },
  { L: "4C5AE0", B: "133FBC", R: "4C63AA", T: "134598" },
  { L: "4C63AA", B: "133FBC", R: "4C6C74", T: "134598" },
  { L: "4CCD22", B: "1339E0", R: "4CD5EC", T: "133FBC" },
  { L: "4CD5EC", B: "1339E0", R: "4CDEB6", T: "133FBC" },
  { L: "4C5AE0", B: "134598", R: "4C63AA", T: "134B74" },
  { L: "4C63AA", B: "134598", R: "4C6C74", T: "134B74" },
  { L: "4C5AE0", B: "134B74", R: "4C63AA", T: "135150" },
  { L: "4C63AA", B: "134B74", R: "4C6C74", T: "135150" },
  { L: "4C6C74", B: "134B74", R: "4C753E", T: "135150" },
  { L: "4CA9FA", B: "134B74", R: "4CB2C4", T: "135150" },
  { L: "4CB2C4", B: "134B74", R: "4CBB8E", T: "135150" },
  { L: "4C5AE0", B: "135150", R: "4C63AA", T: "13572C" },
  { L: "4C63AA", B: "135150", R: "4C6C74", T: "13572C" },
  { L: "4C5AE0", B: "13572C", R: "4C63AA", T: "135D08" },
  { L: "4C63AA", B: "13572C", R: "4C6C74", T: "135D08" },
  { L: "4C6C74", B: "135150", R: "4C753E", T: "13572C" },
  { L: "4C6C74", B: "13572C", R: "4C753E", T: "135D08" },
  { L: "4CA9FA", B: "135150", R: "4CB2C4", T: "13572C" },
  { L: "4CA9FA", B: "13572C", R: "4CB2C4", T: "135D08" },
  { L: "4CB2C4", B: "135150", R: "4CBB8E", T: "13572C" },
  { L: "4CBB8E", B: "135150", R: "4CC458", T: "13572C" },
  { L: "4CB2C4", B: "13572C", R: "4CBB8E", T: "135D08" },
  { L: "4CBB8E", B: "13572C", R: "4CC458", T: "135D08" },
  { L: "4CCD22", B: "135150", R: "4CD5EC", T: "13572C" },
  { L: "4CCD22", B: "13572C", R: "4CD5EC", T: "135D08" },
  { L: "4CD5EC", B: "135150", R: "4CDEB6", T: "13572C" },
  { L: "4CD5EC", B: "13572C", R: "4CDEB6", T: "135D08" },
  { L: "4C5AE0", B: "135D08", R: "4C63AA", T: "1362E4" },
  { L: "4C63AA", B: "135D08", R: "4C6C74", T: "1362E4" },
  { L: "4C63AA", B: "1362E4", R: "4C6C74", T: "1368C0" },
  { L: "4C6C74", B: "135D08", R: "4C753E", T: "1362E4" },
  { L: "4C753E", B: "135D08", R: "4C7E08", T: "1362E4" },
  { L: "4C6C74", B: "1362E4", R: "4C753E", T: "1368C0" },
  { L: "4C753E", B: "1362E4", R: "4C7E08", T: "1368C0" },
  { L: "4C7E08", B: "135D08", R: "4C86D2", T: "1362E4" },
  { L: "4C7E08", B: "1362E4", R: "4C86D2", T: "1368C0" },
  { L: "4C86D2", B: "1362E4", R: "4C8F9C", T: "1368C0" },
  { L: "4C8F9C", B: "1362E4", R: "4C9866", T: "1368C0" },
  { L: "4C9866", B: "1362E4", R: "4CA130", T: "1368C0" },
  { L: "4CA130", B: "135D08", R: "4CA9FA", T: "1362E4" },
  { L: "4CA9FA", B: "135D08", R: "4CB2C4", T: "1362E4" },
  { L: "4CA130", B: "1362E4", R: "4CA9FA", T: "1368C0" },
  { L: "4CA9FA", B: "1362E4", R: "4CB2C4", T: "1368C0" },
  { L: "4CB2C4", B: "135D08", R: "4CBB8E", T: "1362E4" },
  { L: "4CBB8E", B: "135D08", R: "4CC458", T: "1362E4" },
  { L: "4CB2C4", B: "1362E4", R: "4CBB8E", T: "1368C0" },
  { L: "4CC458", B: "135D08", R: "4CCD22", T: "1362E4" },
  { L: "4CC458", B: "1362E4", R: "4CCD22", T: "1368C0" },
  { L: "4CCD22", B: "1362E4", R: "4CD5EC", T: "1368C0" },
  { L: "4CD5EC", B: "1362E4", R: "4CDEB6", T: "1368C0" },
  { L: "4CDEB6", B: "1362E4", R: "4CE780", T: "1368C0" },
  { L: "4CF04A", B: "134598", R: "4CF914", T: "134B74" },
  { L: "4D0AA8", B: "134B74", R: "4D1372", T: "135150" },
  { L: "4D1372", B: "134B74", R: "4D1C3C", T: "135150" },
  { L: "4D1C3C", B: "13572C", R: "4D2506", T: "135D08" },
  { L: "4D1C3C", B: "135D08", R: "4D2506", T: "1362E4" },
  { L: "48DA64", B: "1368C0", R: "48E32E", T: "136E9C" },
  { L: "48E32E", B: "1368C0", R: "48EBF8", T: "136E9C" },
  { L: "48DA64", B: "136E9C", R: "48E32E", T: "137478" },
  { L: "48E32E", B: "136E9C", R: "48EBF8", T: "137478" },
  { L: "48EBF8", B: "1368C0", R: "48F4C2", T: "136E9C" },
  { L: "48EBF8", B: "136E9C", R: "48F4C2", T: "137478" },
  { L: "48F4C2", B: "136E9C", R: "48FD8C", T: "137478" },
  { L: "48EBF8", B: "137478", R: "48F4C2", T: "137A54" },
  { L: "48F4C2", B: "137478", R: "48FD8C", T: "137A54" },
  { L: "490F20", B: "136E9C", R: "4917EA", T: "137478" },
  { L: "49297E", B: "136E9C", R: "493248", T: "137478" },
  { L: "493248", B: "136E9C", R: "493B12", T: "137478" },
  { L: "493B12", B: "136E9C", R: "4943DC", T: "137478" },
  { L: "4943DC", B: "136E9C", R: "494CA6", T: "137478" },
  { L: "498A2C", B: "136E9C", R: "4992F6", T: "137478" },
  { L: "490F20", B: "137478", R: "4917EA", T: "137A54" },
  { L: "4917EA", B: "137478", R: "4920B4", T: "137A54" },
  { L: "490F20", B: "137A54", R: "4917EA", T: "138030" },
  { L: "4917EA", B: "137A54", R: "4920B4", T: "138030" },
  { L: "4920B4", B: "137478", R: "49297E", T: "137A54" },
  { L: "49297E", B: "137478", R: "493248", T: "137A54" },
  { L: "4920B4", B: "137A54", R: "49297E", T: "138030" },
  { L: "49297E", B: "137A54", R: "493248", T: "138030" },
  { L: "493248", B: "137478", R: "493B12", T: "137A54" },
  { L: "493B12", B: "137478", R: "4943DC", T: "137A54" },
  { L: "493248", B: "137A54", R: "493B12", T: "138030" },
  { L: "493B12", B: "137A54", R: "4943DC", T: "138030" },
  { L: "4943DC", B: "137478", R: "494CA6", T: "137A54" },
  { L: "497898", B: "137478", R: "498162", T: "137A54" },
  { L: "498162", B: "137478", R: "498A2C", T: "137A54" },
  { L: "490F20", B: "138030", R: "4917EA", T: "13860C" },
  { L: "4917EA", B: "138030", R: "4920B4", T: "13860C" },
  { L: "4920B4", B: "138030", R: "49297E", T: "13860C" },
  { L: "49297E", B: "138030", R: "493248", T: "13860C" },
  { L: "49297E", B: "13860C", R: "493248", T: "138BE8" },
  { L: "493248", B: "138030", R: "493B12", T: "13860C" },
  { L: "493248", B: "13860C", R: "493B12", T: "138BE8" },
  { L: "4A0E02", B: "1368C0", R: "4A16CC", T: "136E9C" },
  { L: "49B61E", B: "137478", R: "49BEE8", T: "137A54" },
  { L: "49AD54", B: "137A54", R: "49B61E", T: "138030" },
  { L: "49B61E", B: "137A54", R: "49BEE8", T: "138030" },
  { L: "49BEE8", B: "137478", R: "49C7B2", T: "137A54" },
  { L: "49BEE8", B: "137A54", R: "49C7B2", T: "138030" },
  { L: "4A1267", B: "137766", R: "4A16CC", T: "137A54" },
  { L: "4A1267", B: "137A54", R: "4A16CC", T: "137D42" },
  { L: "4A16CC", B: "137766", R: "4A1B31", T: "137A54" },
  { L: "4A16CC", B: "137A54", R: "4A1B31", T: "137D42" },
  { L: "49AD54", B: "138030", R: "49B61E", T: "13860C" },
  { L: "49B61E", B: "138030", R: "49BEE8", T: "13860C" },
  { L: "49BEE8", B: "138030", R: "49C7B2", T: "13860C" },
  { L: "4A0538", B: "138030", R: "4A0E02", T: "13860C" },
  { L: "4A0E02", B: "138030", R: "4A16CC", T: "13860C" },
  { L: "4A0538", B: "13860C", R: "4A0E02", T: "138BE8" },
  { L: "4A0E02", B: "13860C", R: "4A16CC", T: "138BE8" },
  { L: "4A099D", B: "138ED6", R: "4A0E02", T: "1391C4" },
  { L: "4A0E02", B: "138ED6", R: "4A1267", T: "1391C4" },
  { L: "4A099D", B: "1391C4", R: "4A0E02", T: "1394B2" },
  { L: "4A0E02", B: "1391C4", R: "4A1267", T: "1394B2" },
  { L: "4A5452", B: "137478", R: "4A5D1C", T: "137A54" },
  { L: "4A5452", B: "137A54", R: "4A5D1C", T: "138030" },
  { L: "4A5D1C", B: "137478", R: "4A65E6", T: "137A54" },
  { L: "4A5D1C", B: "137A54", R: "4A65E6", T: "138030" },
  { L: "4A890E", B: "137A54", R: "4A91D8", T: "138030" },
  { L: "4A91D8", B: "137A54", R: "4A9AA2", T: "138030" },
  { L: "4A42BE", B: "138030", R: "4A4B88", T: "13860C" },
  { L: "4A39F4", B: "13860C", R: "4A42BE", T: "138BE8" },
  { L: "4A42BE", B: "13860C", R: "4A4B88", T: "138BE8" },
  { L: "4A890E", B: "138030", R: "4A91D8", T: "13860C" },
  { L: "4A91D8", B: "138030", R: "4A9AA2", T: "13860C" },
  { L: "4ACF5E", B: "136E9C", R: "4AD828", T: "137478" },
  { L: "4AD828", B: "1368C0", R: "4AE0F2", T: "136E9C" },
  { L: "4AE0F2", B: "1368C0", R: "4AE9BC", T: "136E9C" },
  { L: "4AD828", B: "136E9C", R: "4AE0F2", T: "137478" },
  { L: "4AE0F2", B: "136E9C", R: "4AE9BC", T: "137478" },
  { L: "4AE9BC", B: "1368C0", R: "4AF286", T: "136E9C" },
  { L: "4AF286", B: "1368C0", R: "4AFB50", T: "136E9C" },
  { L: "4AFB50", B: "1368C0", R: "4B041A", T: "136E9C" },
  { L: "4B041A", B: "1368C0", R: "4B0CE4", T: "136E9C" },
  { L: "4B041A", B: "136E9C", R: "4B0CE4", T: "137478" },
  { L: "4B0CE4", B: "1368C0", R: "4B15AE", T: "136E9C" },
  { L: "4B15AE", B: "1368C0", R: "4B1E78", T: "136E9C" },
  { L: "4B0CE4", B: "136E9C", R: "4B15AE", T: "137478" },
  { L: "4B15AE", B: "136E9C", R: "4B1E78", T: "137478" },
  { L: "4B1E78", B: "1368C0", R: "4B2742", T: "136E9C" },
  { L: "4B2742", B: "1368C0", R: "4B300C", T: "136E9C" },
  { L: "4B1E78", B: "136E9C", R: "4B2742", T: "137478" },
  { L: "4B2742", B: "136E9C", R: "4B300C", T: "137478" },
  { L: "4B300C", B: "1368C0", R: "4B38D6", T: "136E9C" },
  { L: "4B38D6", B: "1368C0", R: "4B41A0", T: "136E9C" },
  { L: "4B300C", B: "136E9C", R: "4B38D6", T: "137478" },
  { L: "4B38D6", B: "136E9C", R: "4B41A0", T: "137478" },
  { L: "4B0CE4", B: "137478", R: "4B15AE", T: "137A54" },
  { L: "4B15AE", B: "137478", R: "4B1E78", T: "137A54" },
  { L: "4B15AE", B: "137A54", R: "4B1E78", T: "138030" },
  { L: "4B1E78", B: "137478", R: "4B2742", T: "137A54" },
  { L: "4B2742", B: "137478", R: "4B300C", T: "137A54" },
  { L: "4B1E78", B: "137A54", R: "4B2742", T: "138030" },
  { L: "4B2742", B: "137A54", R: "4B300C", T: "138030" },
  { L: "4B300C", B: "137478", R: "4B38D6", T: "137A54" },
  { L: "4B38D6", B: "137478", R: "4B41A0", T: "137A54" },
  { L: "4B300C", B: "137A54", R: "4B38D6", T: "138030" },
  { L: "4B38D6", B: "137A54", R: "4B41A0", T: "138030" },
  { L: "4B15AE", B: "138030", R: "4B1E78", T: "13860C" },
  { L: "4B1E78", B: "138030", R: "4B2742", T: "13860C" },
  { L: "4B2742", B: "138030", R: "4B300C", T: "13860C" },
  { L: "4B300C", B: "138030", R: "4B38D6", T: "13860C" },
  { L: "4B300C", B: "13860C", R: "4B38D6", T: "138BE8" },
  { L: "4AB500", B: "138BE8", R: "4ABDCA", T: "1391C4" },
  { L: "4ABDCA", B: "138BE8", R: "4AC694", T: "1391C4" },
  { L: "4AB500", B: "1391C4", R: "4ABDCA", T: "1397A0" },
  { L: "4ABDCA", B: "1391C4", R: "4AC694", T: "1397A0" },
  { L: "4ABDCA", B: "1397A0", R: "4AC694", T: "139D7C" },
  { L: "4B38D6", B: "13A06A", R: "4B41A0", T: "13A358" },
  { L: "4B38D6", B: "13A358", R: "4B41A0", T: "13A646" },
  { L: "4AC694", B: "13B4EC", R: "4ACF5E", T: "13BAC8" },
  { L: "4ACF5E", B: "13B4EC", R: "4AD828", T: "13BAC8" },
  { L: "4AC694", B: "13BAC8", R: "4ACF5E", T: "13C0A4" },
  { L: "4ACF5E", B: "13BAC8", R: "4AD828", T: "13C0A4" },
  { L: "4AC694", B: "13C0A4", R: "4ACF5E", T: "13C680" },
  { L: "4ACF5E", B: "13C0A4", R: "4AD828", T: "13C680" },
  { L: "4AD828", B: "13C0A4", R: "4AE0F2", T: "13C680" },
  { L: "4AF286", B: "13C0A4", R: "4AFB50", T: "13C680" },
  { L: "4AFB50", B: "13C0A4", R: "4B041A", T: "13C680" },
  { L: "4B41A0", B: "1368C0", R: "4B4A6A", T: "136E9C" },
  { L: "4B4A6A", B: "1368C0", R: "4B5334", T: "136E9C" },
  { L: "4B41A0", B: "136E9C", R: "4B4A6A", T: "137478" },
  { L: "4B4A6A", B: "136E9C", R: "4B5334", T: "137478" },
  { L: "4B5334", B: "1368C0", R: "4B5BFE", T: "136E9C" },
  { L: "4B5BFE", B: "1368C0", R: "4B64C8", T: "136E9C" },
  { L: "4B64C8", B: "1368C0", R: "4B6D92", T: "136E9C" },
  { L: "4B41A0", B: "137478", R: "4B4A6A", T: "137A54" },
  { L: "4B4A6A", B: "137478", R: "4B5334", T: "137A54" },
  { L: "4B41A0", B: "137A54", R: "4B4A6A", T: "138030" },
  { L: "4B4A6A", B: "137A54", R: "4B5334", T: "138030" },
  { L: "4B6D92", B: "137478", R: "4B765C", T: "137A54" },
  { L: "4B765C", B: "137478", R: "4B7F26", T: "137A54" },
  { L: "4B7F26", B: "137478", R: "4B87F0", T: "137A54" },
  { L: "4B765C", B: "137A54", R: "4B7F26", T: "138030" },
  { L: "4B7F26", B: "137A54", R: "4B87F0", T: "138030" },
  { L: "4B87F0", B: "137A54", R: "4B90BA", T: "138030" },
  { L: "4BAB18", B: "137A54", R: "4BB3E2", T: "138030" },
  { L: "4BB3E2", B: "137A54", R: "4BBCAC", T: "138030" },
  { L: "4B7F26", B: "138030", R: "4B87F0", T: "13860C" },
  { L: "4B87F0", B: "138030", R: "4B90BA", T: "13860C" },
  { L: "4B90BA", B: "138030", R: "4B9984", T: "13860C" },
  { L: "4B90BA", B: "13860C", R: "4B9984", T: "138BE8" },
  { L: "4BAB18", B: "138030", R: "4BB3E2", T: "13860C" },
  { L: "4BB3E2", B: "138030", R: "4BBCAC", T: "13860C" },
  { L: "4BBCAC", B: "139D7C", R: "4BC576", T: "13A358" },
  { L: "4BC576", B: "139D7C", R: "4BCE40", T: "13A358" },
  { L: "4B6063", B: "13A934", R: "4B64C8", T: "13AF10" },
  { L: "4B64C8", B: "13A934", R: "4B692D", T: "13AF10" },
  { L: "4BC576", B: "13A934", R: "4BCE40", T: "13AF10" },
  { L: "4BA24E", B: "13AF10", R: "4BAB18", T: "13B4EC" },
  { L: "4BC576", B: "13AF10", R: "4BCE40", T: "13B4EC" },
  { L: "4C37B8", B: "137A54", R: "4C4082", T: "138030" },
  { L: "4C4082", B: "137A54", R: "4C494C", T: "138030" },
  { L: "4C0BC6", B: "13860C", R: "4C1490", T: "138BE8" },
  { L: "4C1490", B: "13860C", R: "4C1D5A", T: "138BE8" },
  { L: "4C37B8", B: "138030", R: "4C4082", T: "13860C" },
  { L: "4C4082", B: "138030", R: "4C494C", T: "13860C" },
  { L: "4C494C", B: "138030", R: "4C5216", T: "13860C" },
  { L: "4C494C", B: "13860C", R: "4C5216", T: "138BE8" },
  { L: "4C5216", B: "13860C", R: "4C567B", T: "138BE8" },
  { L: "4C0BC6", B: "138BE8", R: "4C1490", T: "1391C4" },
  { L: "4C0BC6", B: "1391C4", R: "4C1490", T: "1397A0" },
  { L: "4C1490", B: "138BE8", R: "4C1D5A", T: "1391C4" },
  { L: "4C1D5A", B: "138BE8", R: "4C2624", T: "1391C4" },
  { L: "4C1490", B: "1391C4", R: "4C1D5A", T: "1397A0" },
  { L: "4C1D5A", B: "1391C4", R: "4C2624", T: "1397A0" },
  { L: "4C2624", B: "1391C4", R: "4C2EEE", T: "1397A0" },
  { L: "4C2EEE", B: "1391C4", R: "4C37B8", T: "1397A0" },
  { L: "4C494C", B: "138BE8", R: "4C5216", T: "1391C4" },
  { L: "4C5216", B: "138BE8", R: "4C5AE0", T: "1391C4" },
  { L: "4C0BC6", B: "1397A0", R: "4C1490", T: "139D7C" },
  { L: "4C0BC6", B: "139D7C", R: "4C1490", T: "13A358" },
  { L: "4C1490", B: "1397A0", R: "4C1D5A", T: "139D7C" },
  { L: "4C1D5A", B: "1397A0", R: "4C2624", T: "139D7C" },
  { L: "4C2624", B: "1397A0", R: "4C2EEE", T: "139D7C" },
  { L: "4C2EEE", B: "1397A0", R: "4C37B8", T: "139D7C" },
  { L: "4BD2A5", B: "13AC22", R: "4BD70A", T: "13AF10" },
  { L: "4BD70A", B: "13AC22", R: "4BDB6F", T: "13AF10" },
  { L: "4BD2A5", B: "13AF10", R: "4BD70A", T: "13B1FE" },
  { L: "4BD70A", B: "13AF10", R: "4BDB6F", T: "13B1FE" },
  { L: "4BF5CD", B: "13B1FE", R: "4BFA32", T: "13B4EC" },
  { L: "4BFA32", B: "13B1FE", R: "4BFE97", T: "13B4EC" },
  { L: "4BF5CD", B: "13B4EC", R: "4BFA32", T: "13B7DA" },
  { L: "4BFA32", B: "13B4EC", R: "4BFE97", T: "13B7DA" },
  { L: "4C0761", B: "13B7DA", R: "4C0BC6", T: "13BAC8" },
  { L: "4C0BC6", B: "13B7DA", R: "4C102B", T: "13BAC8" },
  { L: "4BDFD4", B: "13C0A4", R: "4BE89E", T: "13C680" },
  { L: "4C0761", B: "13BAC8", R: "4C0BC6", T: "13BDB6" },
  { L: "4C0BC6", B: "13BAC8", R: "4C102B", T: "13BDB6" },
  { L: "4C63AA", B: "1368C0", R: "4C6C74", T: "136E9C" },
  { L: "4C6C74", B: "1368C0", R: "4C753E", T: "136E9C" },
  { L: "4C753E", B: "1368C0", R: "4C7E08", T: "136E9C" },
  { L: "4C6C74", B: "136E9C", R: "4C753E", T: "137478" },
  { L: "4C753E", B: "136E9C", R: "4C7E08", T: "137478" },
  { L: "4C7E08", B: "1368C0", R: "4C86D2", T: "136E9C" },
  { L: "4C86D2", B: "1368C0", R: "4C8F9C", T: "136E9C" },
  { L: "4C7E08", B: "136E9C", R: "4C86D2", T: "137478" },
  { L: "4C86D2", B: "136E9C", R: "4C8F9C", T: "137478" },
  { L: "4C8F9C", B: "1368C0", R: "4C9866", T: "136E9C" },
  { L: "4C9866", B: "1368C0", R: "4CA130", T: "136E9C" },
  { L: "4C8F9C", B: "136E9C", R: "4C9866", T: "137478" },
  { L: "4C9866", B: "136E9C", R: "4CA130", T: "137478" },
  { L: "4CA130", B: "1368C0", R: "4CA9FA", T: "136E9C" },
  { L: "4CA9FA", B: "1368C0", R: "4CB2C4", T: "136E9C" },
  { L: "4CA130", B: "136E9C", R: "4CA9FA", T: "137478" },
  { L: "4CA9FA", B: "136E9C", R: "4CB2C4", T: "137478" },
  { L: "4CB2C4", B: "1368C0", R: "4CBB8E", T: "136E9C" },
  { L: "4CB2C4", B: "136E9C", R: "4CBB8E", T: "137478" },
  { L: "4CBB8E", B: "136E9C", R: "4CC458", T: "137478" },
  { L: "4CCD22", B: "1368C0", R: "4CD5EC", T: "136E9C" },
  { L: "4CD5EC", B: "1368C0", R: "4CDEB6", T: "136E9C" },
  { L: "4CDEB6", B: "1368C0", R: "4CE780", T: "136E9C" },
  { L: "4CD5EC", B: "136E9C", R: "4CDEB6", T: "137478" },
  { L: "4CDEB6", B: "136E9C", R: "4CE780", T: "137478" },
  { L: "4C7E08", B: "137478", R: "4C86D2", T: "137A54" },
  { L: "4C86D2", B: "137478", R: "4C8F9C", T: "137A54" },
  { L: "4C7E08", B: "137A54", R: "4C86D2", T: "138030" },
  { L: "4C86D2", B: "137A54", R: "4C8F9C", T: "138030" },
  { L: "4C8F9C", B: "137478", R: "4C9866", T: "137A54" },
  { L: "4C9866", B: "137478", R: "4CA130", T: "137A54" },
  { L: "4C8F9C", B: "137A54", R: "4C9866", T: "138030" },
  { L: "4C9866", B: "137A54", R: "4CA130", T: "138030" },
  { L: "4CA130", B: "137478", R: "4CA9FA", T: "137A54" },
  { L: "4CA9FA", B: "137478", R: "4CB2C4", T: "137A54" },
  { L: "4CA130", B: "137A54", R: "4CA9FA", T: "138030" },
  { L: "4CA9FA", B: "137A54", R: "4CB2C4", T: "138030" },
  { L: "4CB2C4", B: "137478", R: "4CBB8E", T: "137A54" },
  { L: "4CBB8E", B: "137478", R: "4CC458", T: "137A54" },
  { L: "4CB2C4", B: "137A54", R: "4CBB8E", T: "138030" },
  { L: "4CBB8E", B: "137A54", R: "4CC458", T: "138030" },
  { L: "4CC458", B: "137A54", R: "4CCD22", T: "138030" },
  { L: "4CCD22", B: "137A54", R: "4CD5EC", T: "138030" },
  { L: "4CD5EC", B: "137478", R: "4CDEB6", T: "137A54" },
  { L: "4CDEB6", B: "137478", R: "4CE780", T: "137A54" },
  { L: "4CD5EC", B: "137A54", R: "4CDEB6", T: "138030" },
  { L: "4CDEB6", B: "137A54", R: "4CE780", T: "138030" },
  { L: "4C753E", B: "13860C", R: "4C7E08", T: "138BE8" },
  { L: "4C7E08", B: "138030", R: "4C86D2", T: "13860C" },
  { L: "4C86D2", B: "138030", R: "4C8F9C", T: "13860C" },
  { L: "4C7E08", B: "13860C", R: "4C86D2", T: "138BE8" },
  { L: "4C86D2", B: "13860C", R: "4C8F9C", T: "138BE8" },
  { L: "4C8F9C", B: "138030", R: "4C9866", T: "13860C" },
  { L: "4C9866", B: "138030", R: "4CA130", T: "13860C" },
  { L: "4C8F9C", B: "13860C", R: "4C9866", T: "138BE8" },
  { L: "4C9866", B: "13860C", R: "4CA130", T: "138BE8" },
  { L: "4CA130", B: "138030", R: "4CA9FA", T: "13860C" },
  { L: "4CA9FA", B: "138030", R: "4CB2C4", T: "13860C" },
  { L: "4CA130", B: "13860C", R: "4CA9FA", T: "138BE8" },
  { L: "4CA9FA", B: "13860C", R: "4CB2C4", T: "138BE8" },
  { L: "4CB2C4", B: "138030", R: "4CBB8E", T: "13860C" },
  { L: "4CBB8E", B: "138030", R: "4CC458", T: "13860C" },
  { L: "4CB2C4", B: "13860C", R: "4CBB8E", T: "138BE8" },
  { L: "4CBB8E", B: "13860C", R: "4CC458", T: "138BE8" },
  { L: "4CC458", B: "138030", R: "4CCD22", T: "13860C" },
  { L: "4CCD22", B: "138030", R: "4CD5EC", T: "13860C" },
  { L: "4CC458", B: "13860C", R: "4CCD22", T: "138BE8" },
  { L: "4C753E", B: "138BE8", R: "4C7E08", T: "1391C4" },
  { L: "4C753E", B: "1391C4", R: "4C7E08", T: "1397A0" },
  { L: "4C7E08", B: "138BE8", R: "4C86D2", T: "1391C4" },
  { L: "4C86D2", B: "138BE8", R: "4C8F9C", T: "1391C4" },
  { L: "4C7E08", B: "1391C4", R: "4C86D2", T: "1397A0" },
  { L: "4C86D2", B: "1391C4", R: "4C8F9C", T: "1397A0" },
  { L: "4C8F9C", B: "138BE8", R: "4C9866", T: "1391C4" },
  { L: "4C9866", B: "138BE8", R: "4CA130", T: "1391C4" },
  { L: "4C8F9C", B: "1391C4", R: "4C9866", T: "1397A0" },
  { L: "4C9866", B: "1391C4", R: "4CA130", T: "1397A0" },
  { L: "4CA130", B: "138BE8", R: "4CA9FA", T: "1391C4" },
  { L: "4CA9FA", B: "138BE8", R: "4CB2C4", T: "1391C4" },
  { L: "4CA130", B: "1391C4", R: "4CA9FA", T: "1397A0" },
  { L: "4CA9FA", B: "1391C4", R: "4CB2C4", T: "1397A0" },
  { L: "4CB2C4", B: "138BE8", R: "4CBB8E", T: "1391C4" },
  { L: "4CBB8E", B: "138BE8", R: "4CC458", T: "1391C4" },
  { L: "4CB2C4", B: "1391C4", R: "4CBB8E", T: "1397A0" },
  { L: "4CBB8E", B: "1391C4", R: "4CC458", T: "1397A0" },
  { L: "4CC458", B: "138BE8", R: "4CCD22", T: "1391C4" },
  { L: "4CCD22", B: "138BE8", R: "4CD5EC", T: "1391C4" },
  { L: "4CC458", B: "1391C4", R: "4CCD22", T: "1397A0" },
  { L: "4CCD22", B: "1391C4", R: "4CD5EC", T: "1397A0" },
  { L: "4CD5EC", B: "138BE8", R: "4CDEB6", T: "1391C4" },
  { L: "4CD5EC", B: "1391C4", R: "4CDEB6", T: "1397A0" },
  { L: "4CDEB6", B: "1391C4", R: "4CE780", T: "1397A0" },
  { L: "4C753E", B: "1397A0", R: "4C7E08", T: "139D7C" },
  { L: "4C753E", B: "139D7C", R: "4C7E08", T: "13A358" },
  { L: "4C7E08", B: "1397A0", R: "4C86D2", T: "139D7C" },
  { L: "4C86D2", B: "1397A0", R: "4C8F9C", T: "139D7C" },
  { L: "4C7E08", B: "139D7C", R: "4C86D2", T: "13A358" },
  { L: "4C86D2", B: "139D7C", R: "4C8F9C", T: "13A358" },
  { L: "4C8F9C", B: "1397A0", R: "4C9866", T: "139D7C" },
  { L: "4C9866", B: "1397A0", R: "4CA130", T: "139D7C" },
  { L: "4C8F9C", B: "139D7C", R: "4C9866", T: "13A358" },
  { L: "4C9866", B: "139D7C", R: "4CA130", T: "13A358" },
  { L: "4CA130", B: "1397A0", R: "4CA9FA", T: "139D7C" },
  { L: "4CA9FA", B: "1397A0", R: "4CB2C4", T: "139D7C" },
  { L: "4CA130", B: "139D7C", R: "4CA9FA", T: "13A358" },
  { L: "4CA9FA", B: "139D7C", R: "4CB2C4", T: "13A358" },
  { L: "4CB2C4", B: "1397A0", R: "4CBB8E", T: "139D7C" },
  { L: "4CBB8E", B: "1397A0", R: "4CC458", T: "139D7C" },
  { L: "4CB2C4", B: "139D7C", R: "4CBB8E", T: "13A358" },
  { L: "4CBB8E", B: "139D7C", R: "4CC458", T: "13A358" },
  { L: "4CC458", B: "1397A0", R: "4CCD22", T: "139D7C" },
  { L: "4CCD22", B: "1397A0", R: "4CD5EC", T: "139D7C" },
  { L: "4CC458", B: "139D7C", R: "4CCD22", T: "13A358" },
  { L: "4CCD22", B: "139D7C", R: "4CD5EC", T: "13A358" },
  { L: "4CD5EC", B: "1397A0", R: "4CDEB6", T: "139D7C" },
  { L: "4CDEB6", B: "1397A0", R: "4CE780", T: "139D7C" },
  { L: "4CD5EC", B: "139D7C", R: "4CDEB6", T: "13A358" },
  { L: "4CDEB6", B: "139D7C", R: "4CE780", T: "13A358" },
  { L: "4C753E", B: "13A358", R: "4C7E08", T: "13A934" },
  { L: "4C753E", B: "13A934", R: "4C7E08", T: "13AF10" },
  { L: "4C7E08", B: "13A358", R: "4C86D2", T: "13A934" },
  { L: "4C86D2", B: "13A358", R: "4C8F9C", T: "13A934" },
  { L: "4C7E08", B: "13A934", R: "4C86D2", T: "13AF10" },
  { L: "4C86D2", B: "13A934", R: "4C8F9C", T: "13AF10" },
  { L: "4C8F9C", B: "13A358", R: "4C9866", T: "13A934" },
  { L: "4C9866", B: "13A358", R: "4CA130", T: "13A934" },
  { L: "4C8F9C", B: "13A934", R: "4C9866", T: "13AF10" },
  { L: "4C9866", B: "13A934", R: "4CA130", T: "13AF10" },
  { L: "4CA130", B: "13A358", R: "4CA9FA", T: "13A934" },
  { L: "4CA9FA", B: "13A358", R: "4CB2C4", T: "13A934" },
  { L: "4CA130", B: "13A934", R: "4CA9FA", T: "13AF10" },
  { L: "4CA9FA", B: "13A934", R: "4CB2C4", T: "13AF10" },
  { L: "4CB2C4", B: "13A358", R: "4CBB8E", T: "13A934" },
  { L: "4CBB8E", B: "13A358", R: "4CC458", T: "13A934" },
  { L: "4CB2C4", B: "13A934", R: "4CBB8E", T: "13AF10" },
  { L: "4CBB8E", B: "13A934", R: "4CC458", T: "13AF10" },
  { L: "4CC458", B: "13A358", R: "4CCD22", T: "13A934" },
  { L: "4CCD22", B: "13A358", R: "4CD5EC", T: "13A934" },
  { L: "4CC458", B: "13A934", R: "4CCD22", T: "13AF10" },
  { L: "4CCD22", B: "13A934", R: "4CD5EC", T: "13AF10" },
  { L: "4CD5EC", B: "13A358", R: "4CDEB6", T: "13A934" },
  { L: "4CDEB6", B: "13A358", R: "4CE780", T: "13A934" },
  { L: "4CD5EC", B: "13A934", R: "4CDEB6", T: "13AF10" },
  { L: "4CDEB6", B: "13A934", R: "4CE780", T: "13AF10" },
  { L: "4C7E08", B: "13AF10", R: "4C86D2", T: "13B4EC" },
  { L: "4C86D2", B: "13AF10", R: "4C8F9C", T: "13B4EC" },
  { L: "4C7E08", B: "13B4EC", R: "4C86D2", T: "13BAC8" },
  { L: "4C86D2", B: "13B4EC", R: "4C8F9C", T: "13BAC8" },
  { L: "4C8F9C", B: "13AF10", R: "4C9866", T: "13B4EC" },
  { L: "4C9866", B: "13AF10", R: "4CA130", T: "13B4EC" },
  { L: "4C8F9C", B: "13B4EC", R: "4C9866", T: "13BAC8" },
  { L: "4C9866", B: "13B4EC", R: "4CA130", T: "13BAC8" },
  { L: "4CA130", B: "13AF10", R: "4CA9FA", T: "13B4EC" },
  { L: "4CA9FA", B: "13AF10", R: "4CB2C4", T: "13B4EC" },
  { L: "4CA130", B: "13B4EC", R: "4CA9FA", T: "13BAC8" },
  { L: "4CA9FA", B: "13B4EC", R: "4CB2C4", T: "13BAC8" },
  { L: "4CB2C4", B: "13AF10", R: "4CBB8E", T: "13B4EC" },
  { L: "4CBB8E", B: "13AF10", R: "4CC458", T: "13B4EC" },
  { L: "4CB2C4", B: "13B4EC", R: "4CBB8E", T: "13BAC8" },
  { L: "4CBB8E", B: "13B4EC", R: "4CC458", T: "13BAC8" },
  { L: "4CC458", B: "13AF10", R: "4CCD22", T: "13B4EC" },
  { L: "4CCD22", B: "13AF10", R: "4CD5EC", T: "13B4EC" },
  { L: "4CC458", B: "13B4EC", R: "4CCD22", T: "13BAC8" },
  { L: "4CCD22", B: "13B4EC", R: "4CD5EC", T: "13BAC8" },
  { L: "4CD5EC", B: "13AF10", R: "4CDEB6", T: "13B4EC" },
  { L: "4CDEB6", B: "13AF10", R: "4CE780", T: "13B4EC" },
  { L: "4CD5EC", B: "13B4EC", R: "4CDEB6", T: "13BAC8" },
  { L: "4CDEB6", B: "13B4EC", R: "4CE780", T: "13BAC8" },
  { L: "4C63AA", B: "13C0A4", R: "4C6C74", T: "13C680" },
  { L: "4C86D2", B: "13BAC8", R: "4C8F9C", T: "13C0A4" },
  { L: "4C86D2", B: "13C0A4", R: "4C8F9C", T: "13C680" },
  { L: "4C8F9C", B: "13BAC8", R: "4C9866", T: "13C0A4" },
  { L: "4C9866", B: "13BAC8", R: "4CA130", T: "13C0A4" },
  { L: "4C8F9C", B: "13C0A4", R: "4C9866", T: "13C680" },
  { L: "4C9866", B: "13C0A4", R: "4CA130", T: "13C680" },
  { L: "4CA130", B: "13BAC8", R: "4CA9FA", T: "13C0A4" },
  { L: "4CA9FA", B: "13BAC8", R: "4CB2C4", T: "13C0A4" },
  { L: "4CA130", B: "13C0A4", R: "4CA9FA", T: "13C680" },
  { L: "4CA9FA", B: "13C0A4", R: "4CB2C4", T: "13C680" },
  { L: "4CB2C4", B: "13BAC8", R: "4CBB8E", T: "13C0A4" },
  { L: "4CBB8E", B: "13BAC8", R: "4CC458", T: "13C0A4" },
  { L: "4CB2C4", B: "13C0A4", R: "4CBB8E", T: "13C680" },
  { L: "4CBB8E", B: "13C0A4", R: "4CC458", T: "13C680" },
  { L: "4CC458", B: "13BAC8", R: "4CCD22", T: "13C0A4" },
  { L: "4CCD22", B: "13BAC8", R: "4CD5EC", T: "13C0A4" },
  { L: "4CC458", B: "13C0A4", R: "4CCD22", T: "13C680" },
  { L: "4CCD22", B: "13C0A4", R: "4CD5EC", T: "13C680" },
  { L: "4CD5EC", B: "13BAC8", R: "4CDEB6", T: "13C0A4" },
  { L: "4CDEB6", B: "13BAC8", R: "4CE780", T: "13C0A4" },
  { L: "4CD5EC", B: "13C0A4", R: "4CDEB6", T: "13C680" },
  { L: "4CDEB6", B: "13C0A4", R: "4CE780", T: "13C680" },
  { L: "4CE780", B: "136E9C", R: "4CF04A", T: "137478" },
  { L: "4D0AA8", B: "136E9C", R: "4D1372", T: "137478" },
  { L: "4D1372", B: "136E9C", R: "4D1C3C", T: "137478" },
  { L: "4CE780", B: "137478", R: "4CF04A", T: "137A54" },
  { L: "4CF04A", B: "137478", R: "4CF914", T: "137A54" },
  { L: "4CE780", B: "137A54", R: "4CF04A", T: "138030" },
  { L: "4CF04A", B: "137A54", R: "4CF914", T: "138030" },
  { L: "4CF914", B: "137A54", R: "4D01DE", T: "138030" },
  { L: "4D01DE", B: "137A54", R: "4D0AA8", T: "138030" },
  { L: "4D0AA8", B: "137478", R: "4D1372", T: "137A54" },
  { L: "4D1372", B: "137478", R: "4D1C3C", T: "137A54" },
  { L: "4D0AA8", B: "137A54", R: "4D1372", T: "138030" },
  { L: "4D1372", B: "137A54", R: "4D1C3C", T: "138030" },
  { L: "4CE780", B: "138030", R: "4CF04A", T: "13860C" },
  { L: "4CF04A", B: "138030", R: "4CF914", T: "13860C" },
  { L: "4CF04A", B: "13860C", R: "4CF914", T: "138BE8" },
  { L: "4CF914", B: "138030", R: "4D01DE", T: "13860C" },
  { L: "4D01DE", B: "138030", R: "4D0AA8", T: "13860C" },
  { L: "4CF914", B: "13860C", R: "4D01DE", T: "138BE8" },
  { L: "4D01DE", B: "13860C", R: "4D0AA8", T: "138BE8" },
  { L: "4D0AA8", B: "138030", R: "4D1372", T: "13860C" },
  { L: "4D1372", B: "138030", R: "4D1C3C", T: "13860C" },
  { L: "4D0AA8", B: "13860C", R: "4D1372", T: "138BE8" },
  { L: "4D1372", B: "13860C", R: "4D1C3C", T: "138BE8" },
  { L: "4D1C3C", B: "13860C", R: "4D2506", T: "138BE8" },
  { L: "4CE780", B: "138BE8", R: "4CF04A", T: "1391C4" },
  { L: "4CF04A", B: "138BE8", R: "4CF914", T: "1391C4" },
  { L: "4CE780", B: "1391C4", R: "4CF04A", T: "1397A0" },
  { L: "4CF04A", B: "1391C4", R: "4CF914", T: "1397A0" },
  { L: "4CF914", B: "138BE8", R: "4D01DE", T: "1391C4" },
  { L: "4D01DE", B: "138BE8", R: "4D0AA8", T: "1391C4" },
  { L: "4CF914", B: "1391C4", R: "4D01DE", T: "1397A0" },
  { L: "4D01DE", B: "1391C4", R: "4D0AA8", T: "1397A0" },
  { L: "4D0AA8", B: "138BE8", R: "4D1372", T: "1391C4" },
  { L: "4D1372", B: "138BE8", R: "4D1C3C", T: "1391C4" },
  { L: "4D0AA8", B: "1391C4", R: "4D1372", T: "1397A0" },
  { L: "4D1372", B: "1391C4", R: "4D1C3C", T: "1397A0" },
  { L: "4D1C3C", B: "138BE8", R: "4D2506", T: "1391C4" },
  { L: "4D1C3C", B: "1391C4", R: "4D2506", T: "1397A0" },
  { L: "4CE780", B: "1397A0", R: "4CF04A", T: "139D7C" },
  { L: "4CF04A", B: "1397A0", R: "4CF914", T: "139D7C" },
  { L: "4CE780", B: "139D7C", R: "4CF04A", T: "13A358" },
  { L: "4CF04A", B: "139D7C", R: "4CF914", T: "13A358" },
  { L: "4CF914", B: "1397A0", R: "4D01DE", T: "139D7C" },
  { L: "4D01DE", B: "1397A0", R: "4D0AA8", T: "139D7C" },
  { L: "4CF914", B: "139D7C", R: "4D01DE", T: "13A358" },
  { L: "4D01DE", B: "139D7C", R: "4D0AA8", T: "13A358" },
  { L: "4D0AA8", B: "1397A0", R: "4D1372", T: "139D7C" },
  { L: "4D1372", B: "1397A0", R: "4D1C3C", T: "139D7C" },
  { L: "4D0AA8", B: "139D7C", R: "4D1372", T: "13A358" },
  { L: "4D1372", B: "139D7C", R: "4D1C3C", T: "13A358" },
  { L: "4D1C3C", B: "1397A0", R: "4D2506", T: "139D7C" },
  { L: "4D1C3C", B: "139D7C", R: "4D2506", T: "13A358" },
  { L: "4D2DD0", B: "1397A0", R: "4D369A", T: "139D7C" },
  { L: "4D369A", B: "1397A0", R: "4D3F64", T: "139D7C" },
  { L: "4D2DD0", B: "139D7C", R: "4D369A", T: "13A358" },
  { L: "4D369A", B: "139D7C", R: "4D3F64", T: "13A358" },
  { L: "4D3F64", B: "1397A0", R: "4D482E", T: "139D7C" },
  { L: "4D3F64", B: "139D7C", R: "4D482E", T: "13A358" },
  { L: "4D59C2", B: "1397A0", R: "4D628C", T: "139D7C" },
  { L: "4D50F8", B: "139D7C", R: "4D59C2", T: "13A358" },
  { L: "4D59C2", B: "139D7C", R: "4D628C", T: "13A358" },
  { L: "4CE780", B: "13A358", R: "4CF04A", T: "13A934" },
  { L: "4CF04A", B: "13A358", R: "4CF914", T: "13A934" },
  { L: "4CE780", B: "13A934", R: "4CF04A", T: "13AF10" },
  { L: "4CF04A", B: "13A934", R: "4CF914", T: "13AF10" },
  { L: "4CF914", B: "13A358", R: "4D01DE", T: "13A934" },
  { L: "4D01DE", B: "13A358", R: "4D0AA8", T: "13A934" },
  { L: "4CF914", B: "13A934", R: "4D01DE", T: "13AF10" },
  { L: "4D01DE", B: "13A934", R: "4D0AA8", T: "13AF10" },
  { L: "4D0AA8", B: "13A358", R: "4D1372", T: "13A934" },
  { L: "4D1372", B: "13A358", R: "4D1C3C", T: "13A934" },
  { L: "4D0AA8", B: "13A934", R: "4D1372", T: "13AF10" },
  { L: "4D1372", B: "13A934", R: "4D1C3C", T: "13AF10" },
  { L: "4D1C3C", B: "13A358", R: "4D2506", T: "13A934" },
  { L: "4CE780", B: "13AF10", R: "4CF04A", T: "13B4EC" },
  { L: "4CF04A", B: "13AF10", R: "4CF914", T: "13B4EC" },
  { L: "4CE780", B: "13B4EC", R: "4CF04A", T: "13BAC8" },
  { L: "4CF04A", B: "13B4EC", R: "4CF914", T: "13BAC8" },
  { L: "4CF914", B: "13AF10", R: "4D01DE", T: "13B4EC" },
  { L: "4D01DE", B: "13AF10", R: "4D0AA8", T: "13B4EC" },
  { L: "4CF914", B: "13B4EC", R: "4D01DE", T: "13BAC8" },
  { L: "4D01DE", B: "13B4EC", R: "4D0AA8", T: "13BAC8" },
  { L: "4D2506", B: "13B4EC", R: "4D2DD0", T: "13BAC8" },
  { L: "4D2DD0", B: "13B4EC", R: "4D369A", T: "13BAC8" },
  { L: "4CE780", B: "13BAC8", R: "4CF04A", T: "13C0A4" },
  { L: "4CF04A", B: "13BAC8", R: "4CF914", T: "13C0A4" },
  { L: "4CE780", B: "13C0A4", R: "4CF04A", T: "13C680" },
  { L: "4CF04A", B: "13C0A4", R: "4CF914", T: "13C680" },
  { L: "4CF914", B: "13BAC8", R: "4D01DE", T: "13C0A4" },
  { L: "4D01DE", B: "13BAC8", R: "4D0AA8", T: "13C0A4" },
  { L: "4CF914", B: "13C0A4", R: "4D01DE", T: "13C680" },
  { L: "4D2DD0", B: "13BAC8", R: "4D369A", T: "13C0A4" },
  { L: "4D369A", B: "13BAC8", R: "4D3F64", T: "13C0A4" },
  { L: "4D2DD0", B: "13C0A4", R: "4D369A", T: "13C680" },
  { L: "4D369A", B: "13C0A4", R: "4D3F64", T: "13C680" },
  { L: "4D3F64", B: "13BAC8", R: "4D482E", T: "13C0A4" },
  { L: "4D3F64", B: "13C0A4", R: "4D482E", T: "13C680" },
  { L: "4AC694", B: "13C680", R: "4ACF5E", T: "13CC5C" },
  { L: "4ACF5E", B: "13C680", R: "4AD828", T: "13CC5C" },
  { L: "4AC694", B: "13CC5C", R: "4ACF5E", T: "13D238" },
  { L: "4ACF5E", B: "13CC5C", R: "4AD828", T: "13D238" },
  { L: "4AD828", B: "13C680", R: "4AE0F2", T: "13CC5C" },
  { L: "4AD828", B: "13CC5C", R: "4AE0F2", T: "13D238" },
  { L: "4AF286", B: "13CC5C", R: "4AFB50", T: "13D238" },
  { L: "4AFB50", B: "13C680", R: "4B041A", T: "13CC5C" },
  { L: "4AFB50", B: "13CC5C", R: "4B041A", T: "13D238" },
  { L: "4ABDCA", B: "13D814", R: "4AC694", T: "13DDF0" },
  { L: "4AC694", B: "13D238", R: "4ACF5E", T: "13D814" },
  { L: "4ACF5E", B: "13D238", R: "4AD828", T: "13D814" },
  { L: "4AC694", B: "13D814", R: "4ACF5E", T: "13DDF0" },
  { L: "4ACF5E", B: "13D814", R: "4AD828", T: "13DDF0" },
  { L: "4AD828", B: "13D238", R: "4AE0F2", T: "13D814" },
  { L: "4AD828", B: "13D814", R: "4AE0F2", T: "13DDF0" },
  { L: "4ABDCA", B: "13DDF0", R: "4AC694", T: "13E3CC" },
  { L: "4ABDCA", B: "13E3CC", R: "4AC694", T: "13E9A8" },
  { L: "4AC694", B: "13DDF0", R: "4ACF5E", T: "13E3CC" },
  { L: "4ACF5E", B: "13DDF0", R: "4AD828", T: "13E3CC" },
  { L: "4AC694", B: "13E3CC", R: "4ACF5E", T: "13E9A8" },
  { L: "4ACF5E", B: "13E3CC", R: "4AD828", T: "13E9A8" },
  { L: "4AD828", B: "13DDF0", R: "4AE0F2", T: "13E3CC" },
  { L: "4AD828", B: "13E3CC", R: "4AE0F2", T: "13E9A8" },
  { L: "4AE0F2", B: "13E3CC", R: "4AE9BC", T: "13E9A8" },
  { L: "4AE9BC", B: "13E3CC", R: "4AF286", T: "13E9A8" },
  { L: "4AC694", B: "13E9A8", R: "4ACF5E", T: "13EF84" },
  { L: "4ACF5E", B: "13E9A8", R: "4AD828", T: "13EF84" },
  { L: "4ACF5E", B: "13EF84", R: "4AD828", T: "13F560" },
  { L: "4AD828", B: "13E9A8", R: "4AE0F2", T: "13EF84" },
  { L: "4AE0F2", B: "13E9A8", R: "4AE9BC", T: "13EF84" },
  { L: "4AD828", B: "13EF84", R: "4AE0F2", T: "13F560" },
  { L: "4AE0F2", B: "13EF84", R: "4AE9BC", T: "13F560" },
  { L: "4AE9BC", B: "13E9A8", R: "4AF286", T: "13EF84" },
  { L: "4AE9BC", B: "13EF84", R: "4AF286", T: "13F560" },
  { L: "4AF286", B: "13EF84", R: "4AFB50", T: "13F560" },
  { L: "4AD828", B: "13F560", R: "4AE0F2", T: "13FB3C" },
  { L: "4AE0F2", B: "13F560", R: "4AE9BC", T: "13FB3C" },
  { L: "4AE0F2", B: "13FB3C", R: "4AE9BC", T: "140118" },
  { L: "4AE9BC", B: "13F560", R: "4AF286", T: "13FB3C" },
  { L: "4AF286", B: "13F560", R: "4AFB50", T: "13FB3C" },
  { L: "4AE9BC", B: "13FB3C", R: "4AF286", T: "140118" },
  { L: "4AF286", B: "13FB3C", R: "4AFB50", T: "140118" },
  { L: "4AFB50", B: "13FB3C", R: "4B041A", T: "140118" },
  { L: "4AE9BC", B: "140118", R: "4AF286", T: "1406F4" },
  { L: "4AF286", B: "140118", R: "4AFB50", T: "1406F4" },
  { L: "4AF286", B: "1406F4", R: "4AFB50", T: "140CD0" },
  { L: "4AFB50", B: "140118", R: "4B041A", T: "1406F4" },
  { L: "4B041A", B: "140118", R: "4B0CE4", T: "1406F4" },
  { L: "4AFB50", B: "1406F4", R: "4B041A", T: "140CD0" },
  { L: "4B041A", B: "1406F4", R: "4B0CE4", T: "140CD0" },
  { L: "4B0CE4", B: "140118", R: "4B15AE", T: "1406F4" },
  { L: "4B0CE4", B: "1406F4", R: "4B15AE", T: "140CD0" },
  { L: "4B15AE", B: "1406F4", R: "4B1E78", T: "140CD0" },
  { L: "4B1E78", B: "1406F4", R: "4B2742", T: "140CD0" },
  { L: "4AF286", B: "140CD0", R: "4AFB50", T: "1412AC" },
  { L: "4AFB50", B: "140CD0", R: "4B041A", T: "1412AC" },
  { L: "4B041A", B: "140CD0", R: "4B0CE4", T: "1412AC" },
  { L: "4AFB50", B: "1412AC", R: "4B041A", T: "141888" },
  { L: "4B041A", B: "1412AC", R: "4B0CE4", T: "141888" },
  { L: "4B0CE4", B: "140CD0", R: "4B15AE", T: "1412AC" },
  { L: "4B15AE", B: "140CD0", R: "4B1E78", T: "1412AC" },
  { L: "4B0CE4", B: "1412AC", R: "4B15AE", T: "141888" },
  { L: "4B15AE", B: "1412AC", R: "4B1E78", T: "141888" },
  { L: "4B1E78", B: "140CD0", R: "4B2742", T: "1412AC" },
  { L: "4B1E78", B: "1412AC", R: "4B2742", T: "141888" },
  { L: "4B2742", B: "1412AC", R: "4B300C", T: "141888" },
  { L: "4B300C", B: "140CD0", R: "4B38D6", T: "1412AC" },
  { L: "4B300C", B: "1412AC", R: "4B38D6", T: "141888" },
  { L: "4B38D6", B: "1412AC", R: "4B41A0", T: "141888" },
  { L: "4B041A", B: "141888", R: "4B0CE4", T: "141E64" },
  { L: "4B041A", B: "141E64", R: "4B0CE4", T: "142440" },
  { L: "4B0CE4", B: "141888", R: "4B15AE", T: "141E64" },
  { L: "4B15AE", B: "141888", R: "4B1E78", T: "141E64" },
  { L: "4B0CE4", B: "141E64", R: "4B15AE", T: "142440" },
  { L: "4B15AE", B: "141E64", R: "4B1E78", T: "142440" },
  { L: "4B1E78", B: "141888", R: "4B2742", T: "141E64" },
  { L: "4B2742", B: "141888", R: "4B300C", T: "141E64" },
  { L: "4B1E78", B: "141E64", R: "4B2742", T: "142440" },
  { L: "4B2742", B: "141E64", R: "4B300C", T: "142440" },
  { L: "4B300C", B: "141888", R: "4B38D6", T: "141E64" },
  { L: "4B38D6", B: "141888", R: "4B41A0", T: "141E64" },
  { L: "4B300C", B: "141E64", R: "4B38D6", T: "142440" },
  { L: "4B38D6", B: "141E64", R: "4B41A0", T: "142440" },
  { L: "4B5BFE", B: "13D238", R: "4B64C8", T: "13D814" },
  { L: "4B5BFE", B: "13D814", R: "4B64C8", T: "13DDF0" },
  { L: "4B64C8", B: "13D238", R: "4B6D92", T: "13D814" },
  { L: "4B64C8", B: "13D814", R: "4B6D92", T: "13DDF0" },
  { L: "4BBCAC", B: "13D238", R: "4BC576", T: "13D814" },
  { L: "4BC576", B: "13D238", R: "4BCE40", T: "13D814" },
  { L: "4BBCAC", B: "13D814", R: "4BC576", T: "13DDF0" },
  { L: "4BC576", B: "13D814", R: "4BCE40", T: "13DDF0" },
  { L: "4B5BFE", B: "13DDF0", R: "4B64C8", T: "13E3CC" },
  { L: "4B5799", B: "13E3CC", R: "4B5BFE", T: "13E9A8" },
  { L: "4B5BFE", B: "13E3CC", R: "4B6063", T: "13E9A8" },
  { L: "4B64C8", B: "13DDF0", R: "4B6D92", T: "13E3CC" },
  { L: "4BBCAC", B: "13DDF0", R: "4BC576", T: "13E3CC" },
  { L: "4BC576", B: "13DDF0", R: "4BCE40", T: "13E3CC" },
  { L: "4BBCAC", B: "13E3CC", R: "4BC576", T: "13E9A8" },
  { L: "4BC576", B: "13E3CC", R: "4BCE40", T: "13E9A8" },
  { L: "4B692D", B: "13F272", R: "4B6D92", T: "13F560" },
  { L: "4B6D92", B: "13F272", R: "4B71F7", T: "13F560" },
  { L: "4BBCAC", B: "13E9A8", R: "4BC576", T: "13EF84" },
  { L: "4BC576", B: "13E9A8", R: "4BCE40", T: "13EF84" },
  { L: "4BBCAC", B: "13EF84", R: "4BC576", T: "13F560" },
  { L: "4BC576", B: "13EF84", R: "4BCE40", T: "13F560" },
  { L: "4B692D", B: "13F560", R: "4B6D92", T: "13F84E" },
  { L: "4B6D92", B: "13F560", R: "4B71F7", T: "13F84E" },
  { L: "4BB3E2", B: "1406F4", R: "4BBCAC", T: "140CD0" },
  { L: "4BB3E2", B: "140CD0", R: "4BBCAC", T: "1412AC" },
  { L: "4B41A0", B: "141E64", R: "4B4A6A", T: "142440" },
  { L: "4B4A6A", B: "141E64", R: "4B5334", T: "142440" },
  { L: "4B5334", B: "141888", R: "4B5BFE", T: "141E64" },
  { L: "4B5BFE", B: "141888", R: "4B64C8", T: "141E64" },
  { L: "4B5334", B: "141E64", R: "4B5BFE", T: "142440" },
  { L: "4B5BFE", B: "141E64", R: "4B64C8", T: "142440" },
  { L: "4B64C8", B: "141888", R: "4B6D92", T: "141E64" },
  { L: "4B64C8", B: "141E64", R: "4B6D92", T: "142440" },
  { L: "4BCE40", B: "13C680", R: "4BD70A", T: "13CC5C" },
  { L: "4BD70A", B: "13C680", R: "4BDFD4", T: "13CC5C" },
  { L: "4BCE40", B: "13CC5C", R: "4BD70A", T: "13D238" },
  { L: "4BD70A", B: "13CC5C", R: "4BDFD4", T: "13D238" },
  { L: "4BDFD4", B: "13C680", R: "4BE89E", T: "13CC5C" },
  { L: "4BDFD4", B: "13CC5C", R: "4BE89E", T: "13D238" },
  { L: "4BCE40", B: "13DDF0", R: "4BD70A", T: "13E3CC" },
  { L: "4BCE40", B: "13E3CC", R: "4BD70A", T: "13E9A8" },
  { L: "4C0BC6", B: "13E3CC", R: "4C1490", T: "13E9A8" },
  { L: "4C4082", B: "13E3CC", R: "4C494C", T: "13E9A8" },
  { L: "4C494C", B: "13E3CC", R: "4C5216", T: "13E9A8" },
  { L: "4C5216", B: "13E3CC", R: "4C5AE0", T: "13E9A8" },
  { L: "4C0BC6", B: "13E9A8", R: "4C1490", T: "13EF84" },
  { L: "4C02FC", B: "13EF84", R: "4C0BC6", T: "13F560" },
  { L: "4C0BC6", B: "13EF84", R: "4C1490", T: "13F560" },
  { L: "4C1490", B: "13EF84", R: "4C1D5A", T: "13F560" },
  { L: "4C1D5A", B: "13EF84", R: "4C2624", T: "13F560" },
  { L: "4C4082", B: "13E9A8", R: "4C494C", T: "13EF84" },
  { L: "4C4082", B: "13EF84", R: "4C494C", T: "13F560" },
  { L: "4C494C", B: "13E9A8", R: "4C5216", T: "13EF84" },
  { L: "4C5216", B: "13E9A8", R: "4C5AE0", T: "13EF84" },
  { L: "4C494C", B: "13EF84", R: "4C5216", T: "13F560" },
  { L: "4C5216", B: "13EF84", R: "4C5AE0", T: "13F560" },
  { L: "4BE89E", B: "13F560", R: "4BF168", T: "13FB3C" },
  { L: "4BE89E", B: "13FB3C", R: "4BF168", T: "140118" },
  { L: "4BF168", B: "13F560", R: "4BFA32", T: "13FB3C" },
  { L: "4BFA32", B: "13F560", R: "4C02FC", T: "13FB3C" },
  { L: "4BF168", B: "13FB3C", R: "4BFA32", T: "140118" },
  { L: "4C02FC", B: "13F560", R: "4C0BC6", T: "13FB3C" },
  { L: "4C0BC6", B: "13F560", R: "4C1490", T: "13FB3C" },
  { L: "4C1490", B: "13F560", R: "4C1D5A", T: "13FB3C" },
  { L: "4C1D5A", B: "13F560", R: "4C2624", T: "13FB3C" },
  { L: "4C2624", B: "13F560", R: "4C2EEE", T: "13FB3C" },
  { L: "4C4082", B: "13F560", R: "4C494C", T: "13FB3C" },
  { L: "4C494C", B: "13F560", R: "4C5216", T: "13FB3C" },
  { L: "4C5216", B: "13F560", R: "4C5AE0", T: "13FB3C" },
  { L: "4BDFD4", B: "140118", R: "4BE89E", T: "1406F4" },
  { L: "4BE89E", B: "140118", R: "4BF168", T: "1406F4" },
  { L: "4BDFD4", B: "1406F4", R: "4BE89E", T: "140CD0" },
  { L: "4BE89E", B: "1406F4", R: "4BF168", T: "140CD0" },
  { L: "4C494C", B: "1409E2", R: "4C5216", T: "140CD0" },
  { L: "4C5216", B: "1406F4", R: "4C5AE0", T: "140CD0" },
  { L: "4BD70A", B: "140CD0", R: "4BDFD4", T: "1412AC" },
  { L: "4BD70A", B: "1412AC", R: "4BDFD4", T: "141888" },
  { L: "4BDFD4", B: "140CD0", R: "4BE89E", T: "1412AC" },
  { L: "4BDFD4", B: "1412AC", R: "4BE89E", T: "141888" },
  { L: "4BE89E", B: "1412AC", R: "4BF168", T: "141888" },
  { L: "4C494C", B: "140CD0", R: "4C5216", T: "140FBE" },
  { L: "4BDFD4", B: "141888", R: "4BE89E", T: "141E64" },
  { L: "4BE89E", B: "141888", R: "4BF168", T: "141E64" },
  { L: "4BDFD4", B: "141E64", R: "4BE89E", T: "142440" },
  { L: "4BE89E", B: "141E64", R: "4BF168", T: "142440" },
  { L: "4BF168", B: "141888", R: "4BFA32", T: "141E64" },
  { L: "4BF168", B: "141E64", R: "4BFA32", T: "142440" },
  { L: "4BFA32", B: "141E64", R: "4C02FC", T: "142440" },
  { L: "4C1D5A", B: "141B76", R: "4C2624", T: "141E64" },
  { L: "4C1D5A", B: "141E64", R: "4C2624", T: "142152" },
  { L: "4C63AA", B: "13C680", R: "4C6C74", T: "13CC5C" },
  { L: "4C86D2", B: "13C680", R: "4C8F9C", T: "13CC5C" },
  { L: "4C7E08", B: "13CC5C", R: "4C86D2", T: "13D238" },
  { L: "4C86D2", B: "13CC5C", R: "4C8F9C", T: "13D238" },
  { L: "4C8F9C", B: "13C680", R: "4C9866", T: "13CC5C" },
  { L: "4C9866", B: "13C680", R: "4CA130", T: "13CC5C" },
  { L: "4C8F9C", B: "13CC5C", R: "4C9866", T: "13D238" },
  { L: "4C9866", B: "13CC5C", R: "4CA130", T: "13D238" },
  { L: "4CA130", B: "13C680", R: "4CA9FA", T: "13CC5C" },
  { L: "4CA9FA", B: "13C680", R: "4CB2C4", T: "13CC5C" },
  { L: "4CA130", B: "13CC5C", R: "4CA9FA", T: "13D238" },
  { L: "4CA9FA", B: "13CC5C", R: "4CB2C4", T: "13D238" },
  { L: "4CB2C4", B: "13C680", R: "4CBB8E", T: "13CC5C" },
  { L: "4CBB8E", B: "13C680", R: "4CC458", T: "13CC5C" },
  { L: "4CB2C4", B: "13CC5C", R: "4CBB8E", T: "13D238" },
  { L: "4CBB8E", B: "13CC5C", R: "4CC458", T: "13D238" },
  { L: "4CC458", B: "13C680", R: "4CCD22", T: "13CC5C" },
  { L: "4CCD22", B: "13C680", R: "4CD5EC", T: "13CC5C" },
  { L: "4CC458", B: "13CC5C", R: "4CCD22", T: "13D238" },
  { L: "4CCD22", B: "13CC5C", R: "4CD5EC", T: "13D238" },
  { L: "4CD5EC", B: "13C680", R: "4CDEB6", T: "13CC5C" },
  { L: "4CDEB6", B: "13C680", R: "4CE780", T: "13CC5C" },
  { L: "4CD5EC", B: "13CC5C", R: "4CDEB6", T: "13D238" },
  { L: "4CDEB6", B: "13CC5C", R: "4CE780", T: "13D238" },
  { L: "4C753E", B: "13D238", R: "4C7E08", T: "13D814" },
  { L: "4C753E", B: "13D814", R: "4C7E08", T: "13DDF0" },
  { L: "4C7E08", B: "13D238", R: "4C86D2", T: "13D814" },
  { L: "4C86D2", B: "13D238", R: "4C8F9C", T: "13D814" },
  { L: "4C7E08", B: "13D814", R: "4C86D2", T: "13DDF0" },
  { L: "4C86D2", B: "13D814", R: "4C8F9C", T: "13DDF0" },
  { L: "4C8F9C", B: "13D238", R: "4C9866", T: "13D814" },
  { L: "4C9866", B: "13D238", R: "4CA130", T: "13D814" },
  { L: "4C8F9C", B: "13D814", R: "4C9866", T: "13DDF0" },
  { L: "4C9866", B: "13D814", R: "4CA130", T: "13DDF0" },
  { L: "4CA130", B: "13D238", R: "4CA9FA", T: "13D814" },
  { L: "4CA9FA", B: "13D238", R: "4CB2C4", T: "13D814" },
  { L: "4CA130", B: "13D814", R: "4CA9FA", T: "13DDF0" },
  { L: "4CA9FA", B: "13D814", R: "4CB2C4", T: "13DDF0" },
  { L: "4CB2C4", B: "13D238", R: "4CBB8E", T: "13D814" },
  { L: "4CBB8E", B: "13D238", R: "4CC458", T: "13D814" },
  { L: "4CB2C4", B: "13D814", R: "4CBB8E", T: "13DDF0" },
  { L: "4CBB8E", B: "13D814", R: "4CC458", T: "13DDF0" },
  { L: "4CC458", B: "13D238", R: "4CCD22", T: "13D814" },
  { L: "4CCD22", B: "13D238", R: "4CD5EC", T: "13D814" },
  { L: "4CC458", B: "13D814", R: "4CCD22", T: "13DDF0" },
  { L: "4CCD22", B: "13D814", R: "4CD5EC", T: "13DDF0" },
  { L: "4CD5EC", B: "13D238", R: "4CDEB6", T: "13D814" },
  { L: "4CDEB6", B: "13D238", R: "4CE780", T: "13D814" },
  { L: "4CD5EC", B: "13D814", R: "4CDEB6", T: "13DDF0" },
  { L: "4CDEB6", B: "13D814", R: "4CE780", T: "13DDF0" },
  { L: "4C5AE0", B: "13E3CC", R: "4C63AA", T: "13E9A8" },
  { L: "4C63AA", B: "13E3CC", R: "4C6C74", T: "13E9A8" },
  { L: "4C6C74", B: "13DDF0", R: "4C753E", T: "13E3CC" },
  { L: "4C753E", B: "13DDF0", R: "4C7E08", T: "13E3CC" },
  { L: "4C6C74", B: "13E3CC", R: "4C753E", T: "13E9A8" },
  { L: "4C753E", B: "13E3CC", R: "4C7E08", T: "13E9A8" },
  { L: "4C7E08", B: "13DDF0", R: "4C86D2", T: "13E3CC" },
  { L: "4C86D2", B: "13DDF0", R: "4C8F9C", T: "13E3CC" },
  { L: "4C7E08", B: "13E3CC", R: "4C86D2", T: "13E9A8" },
  { L: "4C86D2", B: "13E3CC", R: "4C8F9C", T: "13E9A8" },
  { L: "4C8F9C", B: "13DDF0", R: "4C9866", T: "13E3CC" },
  { L: "4C9866", B: "13DDF0", R: "4CA130", T: "13E3CC" },
  { L: "4C8F9C", B: "13E3CC", R: "4C9866", T: "13E9A8" },
  { L: "4C9866", B: "13E3CC", R: "4CA130", T: "13E9A8" },
  { L: "4CA130", B: "13DDF0", R: "4CA9FA", T: "13E3CC" },
  { L: "4CA9FA", B: "13DDF0", R: "4CB2C4", T: "13E3CC" },
  { L: "4CA130", B: "13E3CC", R: "4CA9FA", T: "13E9A8" },
  { L: "4CA9FA", B: "13E3CC", R: "4CB2C4", T: "13E9A8" },
  { L: "4CB2C4", B: "13DDF0", R: "4CBB8E", T: "13E3CC" },
  { L: "4CBB8E", B: "13DDF0", R: "4CC458", T: "13E3CC" },
  { L: "4CB2C4", B: "13E3CC", R: "4CBB8E", T: "13E9A8" },
  { L: "4CBB8E", B: "13E3CC", R: "4CC458", T: "13E9A8" },
  { L: "4CC458", B: "13DDF0", R: "4CCD22", T: "13E3CC" },
  { L: "4CCD22", B: "13DDF0", R: "4CD5EC", T: "13E3CC" },
  { L: "4CC458", B: "13E3CC", R: "4CCD22", T: "13E9A8" },
  { L: "4CCD22", B: "13E3CC", R: "4CD5EC", T: "13E9A8" },
  { L: "4CD5EC", B: "13DDF0", R: "4CDEB6", T: "13E3CC" },
  { L: "4CDEB6", B: "13DDF0", R: "4CE780", T: "13E3CC" },
  { L: "4CD5EC", B: "13E3CC", R: "4CDEB6", T: "13E9A8" },
  { L: "4CDEB6", B: "13E3CC", R: "4CE780", T: "13E9A8" },
  { L: "4C5AE0", B: "13E9A8", R: "4C63AA", T: "13EF84" },
  { L: "4C63AA", B: "13E9A8", R: "4C6C74", T: "13EF84" },
  { L: "4C5AE0", B: "13EF84", R: "4C63AA", T: "13F560" },
  { L: "4C63AA", B: "13EF84", R: "4C6C74", T: "13F560" },
  { L: "4C6C74", B: "13E9A8", R: "4C753E", T: "13EF84" },
  { L: "4C753E", B: "13E9A8", R: "4C7E08", T: "13EF84" },
  { L: "4C6C74", B: "13EF84", R: "4C753E", T: "13F560" },
  { L: "4C753E", B: "13EF84", R: "4C7E08", T: "13F560" },
  { L: "4C7E08", B: "13E9A8", R: "4C86D2", T: "13EF84" },
  { L: "4C86D2", B: "13E9A8", R: "4C8F9C", T: "13EF84" },
  { L: "4C7E08", B: "13EF84", R: "4C86D2", T: "13F560" },
  { L: "4C86D2", B: "13EF84", R: "4C8F9C", T: "13F560" },
  { L: "4C8F9C", B: "13E9A8", R: "4C9866", T: "13EF84" },
  { L: "4C9866", B: "13E9A8", R: "4CA130", T: "13EF84" },
  { L: "4C8F9C", B: "13EF84", R: "4C9866", T: "13F560" },
  { L: "4C9866", B: "13EF84", R: "4CA130", T: "13F560" },
  { L: "4CA130", B: "13E9A8", R: "4CA9FA", T: "13EF84" },
  { L: "4CA9FA", B: "13E9A8", R: "4CB2C4", T: "13EF84" },
  { L: "4CA130", B: "13EF84", R: "4CA9FA", T: "13F560" },
  { L: "4CA9FA", B: "13EF84", R: "4CB2C4", T: "13F560" },
  { L: "4CB2C4", B: "13E9A8", R: "4CBB8E", T: "13EF84" },
  { L: "4CBB8E", B: "13E9A8", R: "4CC458", T: "13EF84" },
  { L: "4CB2C4", B: "13EF84", R: "4CBB8E", T: "13F560" },
  { L: "4CBB8E", B: "13EF84", R: "4CC458", T: "13F560" },
  { L: "4CC458", B: "13E9A8", R: "4CCD22", T: "13EF84" },
  { L: "4CCD22", B: "13E9A8", R: "4CD5EC", T: "13EF84" },
  { L: "4CC458", B: "13EF84", R: "4CCD22", T: "13F560" },
  { L: "4CCD22", B: "13EF84", R: "4CD5EC", T: "13F560" },
  { L: "4CD5EC", B: "13E9A8", R: "4CDEB6", T: "13EF84" },
  { L: "4CDEB6", B: "13E9A8", R: "4CE780", T: "13EF84" },
  { L: "4CD5EC", B: "13EF84", R: "4CDEB6", T: "13F560" },
  { L: "4CDEB6", B: "13EF84", R: "4CE780", T: "13F560" },
  { L: "4C5AE0", B: "13F560", R: "4C63AA", T: "13FB3C" },
  { L: "4C63AA", B: "13F560", R: "4C6C74", T: "13FB3C" },
  { L: "4C5AE0", B: "13FB3C", R: "4C63AA", T: "140118" },
  { L: "4C63AA", B: "13FB3C", R: "4C6C74", T: "140118" },
  { L: "4C6C74", B: "13F560", R: "4C753E", T: "13FB3C" },
  { L: "4C753E", B: "13F560", R: "4C7E08", T: "13FB3C" },
  { L: "4C6C74", B: "13FB3C", R: "4C753E", T: "140118" },
  { L: "4C753E", B: "13FB3C", R: "4C7E08", T: "140118" },
  { L: "4C7E08", B: "13F560", R: "4C86D2", T: "13FB3C" },
  { L: "4C86D2", B: "13F560", R: "4C8F9C", T: "13FB3C" },
  { L: "4C7E08", B: "13FB3C", R: "4C86D2", T: "140118" },
  { L: "4C86D2", B: "13FB3C", R: "4C8F9C", T: "140118" },
  { L: "4C8F9C", B: "13F560", R: "4C9866", T: "13FB3C" },
  { L: "4C9866", B: "13F560", R: "4CA130", T: "13FB3C" },
  { L: "4CBB8E", B: "13F560", R: "4CC458", T: "13FB3C" },
  { L: "4CBB8E", B: "13FB3C", R: "4CC458", T: "140118" },
  { L: "4CC458", B: "13F560", R: "4CCD22", T: "13FB3C" },
  { L: "4CCD22", B: "13F560", R: "4CD5EC", T: "13FB3C" },
  { L: "4CC458", B: "13FB3C", R: "4CCD22", T: "140118" },
  { L: "4CCD22", B: "13FB3C", R: "4CD5EC", T: "140118" },
  { L: "4CD5EC", B: "13F560", R: "4CDEB6", T: "13FB3C" },
  { L: "4CDEB6", B: "13F560", R: "4CE780", T: "13FB3C" },
  { L: "4CD5EC", B: "13FB3C", R: "4CDEB6", T: "140118" },
  { L: "4CDEB6", B: "13FB3C", R: "4CE780", T: "140118" },
  { L: "4C5AE0", B: "140118", R: "4C63AA", T: "1406F4" },
  { L: "4C63AA", B: "140118", R: "4C6C74", T: "1406F4" },
  { L: "4C5AE0", B: "1406F4", R: "4C63AA", T: "140CD0" },
  { L: "4C7E08", B: "140118", R: "4C86D2", T: "1406F4" },
  { L: "4C86D2", B: "140118", R: "4C8F9C", T: "1406F4" },
  { L: "4CBB8E", B: "140118", R: "4CC458", T: "1406F4" },
  { L: "4CBB8E", B: "1406F4", R: "4CC458", T: "140CD0" },
  { L: "4CC458", B: "140118", R: "4CCD22", T: "1406F4" },
  { L: "4CCD22", B: "140118", R: "4CD5EC", T: "1406F4" },
  { L: "4CC458", B: "1406F4", R: "4CCD22", T: "140CD0" },
  { L: "4CCD22", B: "1406F4", R: "4CD5EC", T: "140CD0" },
  { L: "4CD5EC", B: "140118", R: "4CDEB6", T: "1406F4" },
  { L: "4CDEB6", B: "140118", R: "4CE780", T: "1406F4" },
  { L: "4CD5EC", B: "1406F4", R: "4CDEB6", T: "140CD0" },
  { L: "4CDEB6", B: "1406F4", R: "4CE780", T: "140CD0" },
  { L: "4CBB8E", B: "140CD0", R: "4CC458", T: "1412AC" },
  { L: "4CBB8E", B: "1412AC", R: "4CC458", T: "141888" },
  { L: "4CC458", B: "140CD0", R: "4CCD22", T: "1412AC" },
  { L: "4CCD22", B: "140CD0", R: "4CD5EC", T: "1412AC" },
  { L: "4CC458", B: "1412AC", R: "4CCD22", T: "141888" },
  { L: "4CCD22", B: "1412AC", R: "4CD5EC", T: "141888" },
  { L: "4CD5EC", B: "140CD0", R: "4CDEB6", T: "1412AC" },
  { L: "4CDEB6", B: "140CD0", R: "4CE780", T: "1412AC" },
  { L: "4CD5EC", B: "1412AC", R: "4CDEB6", T: "141888" },
  { L: "4CDEB6", B: "1412AC", R: "4CE780", T: "141888" },
  { L: "4C5AE0", B: "141E64", R: "4C63AA", T: "142440" },
  { L: "4C63AA", B: "141E64", R: "4C680F", T: "142440" },
  { L: "4CBB8E", B: "141888", R: "4CC458", T: "141E64" },
  { L: "4CBB8E", B: "141E64", R: "4CC458", T: "142440" },
  { L: "4CC458", B: "141888", R: "4CCD22", T: "141E64" },
  { L: "4CCD22", B: "141888", R: "4CD5EC", T: "141E64" },
  { L: "4CC458", B: "141E64", R: "4CCD22", T: "142440" },
  { L: "4CCD22", B: "141E64", R: "4CD5EC", T: "142440" },
  { L: "4CD5EC", B: "141888", R: "4CDEB6", T: "141E64" },
  { L: "4CDEB6", B: "141888", R: "4CE780", T: "141E64" },
  { L: "4CE780", B: "13C680", R: "4CF04A", T: "13CC5C" },
  { L: "4CF04A", B: "13C680", R: "4CF914", T: "13CC5C" },
  { L: "4CE780", B: "13CC5C", R: "4CF04A", T: "13D238" },
  { L: "4CF04A", B: "13CC5C", R: "4CF914", T: "13D238" },
  { L: "4CF914", B: "13C680", R: "4D01DE", T: "13CC5C" },
  { L: "4D01DE", B: "13C680", R: "4D0AA8", T: "13CC5C" },
  { L: "4CF914", B: "13CC5C", R: "4D01DE", T: "13D238" },
  { L: "4D01DE", B: "13CC5C", R: "4D0AA8", T: "13D238" },
  { L: "4D0AA8", B: "13C680", R: "4D1372", T: "13CC5C" },
  { L: "4D0AA8", B: "13CC5C", R: "4D1372", T: "13D238" },
  { L: "4CE780", B: "13D238", R: "4CF04A", T: "13D814" },
  { L: "4CF04A", B: "13D238", R: "4CF914", T: "13D814" },
  { L: "4CE780", B: "13D814", R: "4CF04A", T: "13DDF0" },
  { L: "4CF04A", B: "13D814", R: "4CF914", T: "13DDF0" },
  { L: "4CF914", B: "13D238", R: "4D01DE", T: "13D814" },
  { L: "4D01DE", B: "13D238", R: "4D0AA8", T: "13D814" },
  { L: "4CF914", B: "13D814", R: "4D01DE", T: "13DDF0" },
  { L: "4D01DE", B: "13D814", R: "4D0AA8", T: "13DDF0" },
  { L: "4D0AA8", B: "13D238", R: "4D1372", T: "13D814" },
  { L: "4D0AA8", B: "13D814", R: "4D1372", T: "13DDF0" },
  { L: "4D01DE", B: "13DDF0", R: "4D0AA8", T: "13E3CC" },
  { L: "4D0AA8", B: "13DDF0", R: "4D1372", T: "13E3CC" },
  { L: "4D1372", B: "13DDF0", R: "4D1C3C", T: "13E3CC" },
  { L: "4D0AA8", B: "13E3CC", R: "4D1372", T: "13E9A8" },
  { L: "4CE780", B: "13E9A8", R: "4CF04A", T: "13EF84" },
  { L: "4CE780", B: "13EF84", R: "4CF04A", T: "13F560" },
  { L: "4D1C3C", B: "13EF84", R: "4D2506", T: "13F560" },
  { L: "4D2506", B: "13EF84", R: "4D2DD0", T: "13F560" },
  { L: "4D2DD0", B: "13EF84", R: "4D369A", T: "13F560" },
  { L: "4D369A", B: "13EF84", R: "4D3F64", T: "13F560" },
  { L: "4CE780", B: "13F560", R: "4CF04A", T: "13FB3C" },
  { L: "4CE780", B: "13FB3C", R: "4CF04A", T: "140118" },
  { L: "4D0643", B: "13F84E", R: "4D0AA8", T: "13FB3C" },
  { L: "4D0643", B: "13FB3C", R: "4D0AA8", T: "13FE2A" },
  { L: "4D0AA8", B: "13F84E", R: "4D0F0D", T: "13FB3C" },
  { L: "4D0AA8", B: "13FB3C", R: "4D0F0D", T: "13FE2A" },
  { L: "4D1C3C", B: "13F560", R: "4D2506", T: "13FB3C" },
  { L: "4D2506", B: "13F560", R: "4D2DD0", T: "13FB3C" },
  { L: "4D1C3C", B: "13FB3C", R: "4D2506", T: "140118" },
  { L: "4D2506", B: "13FB3C", R: "4D2DD0", T: "140118" },
  { L: "4D2DD0", B: "13F560", R: "4D369A", T: "13FB3C" },
  { L: "4D369A", B: "13F560", R: "4D3F64", T: "13FB3C" },
  { L: "4D2DD0", B: "13FB3C", R: "4D369A", T: "140118" },
  { L: "4D369A", B: "13FB3C", R: "4D3F64", T: "140118" },
  { L: "4D3F64", B: "13F560", R: "4D482E", T: "13FB3C" },
  { L: "4D3F64", B: "13FB3C", R: "4D482E", T: "140118" },
  { L: "4CE780", B: "140118", R: "4CF04A", T: "1406F4" },
  { L: "4CE780", B: "1406F4", R: "4CF04A", T: "140CD0" },
  { L: "4D1C3C", B: "140118", R: "4D2506", T: "1406F4" },
  { L: "4D2506", B: "140118", R: "4D2DD0", T: "1406F4" },
  { L: "4D2DD0", B: "140118", R: "4D369A", T: "1406F4" },
  { L: "4D369A", B: "140118", R: "4D3F64", T: "1406F4" },
  { L: "4D2DD0", B: "1406F4", R: "4D369A", T: "140CD0" },
  { L: "4D369A", B: "1406F4", R: "4D3F64", T: "140CD0" },
  { L: "4D3F64", B: "140118", R: "4D482E", T: "1406F4" },
  { L: "4D3F64", B: "1406F4", R: "4D482E", T: "140CD0" },
  { L: "4CE780", B: "140CD0", R: "4CF04A", T: "1412AC" },
  { L: "4D2DD0", B: "140CD0", R: "4D369A", T: "1412AC" },
  { L: "4D369A", B: "140CD0", R: "4D3F64", T: "1412AC" },
  { L: "4D2DD0", B: "1412AC", R: "4D369A", T: "141888" },
  { L: "4D369A", B: "1412AC", R: "4D3F64", T: "141888" },
  { L: "4D3F64", B: "140CD0", R: "4D482E", T: "1412AC" },
  { L: "4D3F64", B: "1412AC", R: "4D482E", T: "141888" },
  { L: "4D3F64", B: "141888", R: "4D482E", T: "141E64" },
  { L: "4D482E", B: "141888", R: "4D50F8", T: "141E64" },
  { L: "4D3F64", B: "141E64", R: "4D482E", T: "142440" },
  { L: "4D482E", B: "141E64", R: "4D50F8", T: "142440" },
  { L: "4B0CE4", B: "142440", R: "4B15AE", T: "142A1C" },
  { L: "4B15AE", B: "142440", R: "4B1E78", T: "142A1C" },
  { L: "4B0CE4", B: "142A1C", R: "4B15AE", T: "142FF8" },
  { L: "4B15AE", B: "142A1C", R: "4B1E78", T: "142FF8" },
  { L: "4B1E78", B: "142440", R: "4B2742", T: "142A1C" },
  { L: "4B2742", B: "142440", R: "4B300C", T: "142A1C" },
  { L: "4B1E78", B: "142A1C", R: "4B2742", T: "142FF8" },
  { L: "4B300C", B: "142440", R: "4B38D6", T: "142A1C" },
  { L: "4B38D6", B: "142440", R: "4B41A0", T: "142A1C" },
  { L: "4B300C", B: "142A1C", R: "4B38D6", T: "142FF8" },
  { L: "4B38D6", B: "142A1C", R: "4B41A0", T: "142FF8" },
  { L: "4B38D6", B: "142FF8", R: "4B41A0", T: "1435D4" },
  { L: "4B38D6", B: "1435D4", R: "4B41A0", T: "143BB0" },
  { L: "4B1E78", B: "14418C", R: "4B2742", T: "144768" },
  { L: "4B38D6", B: "143BB0", R: "4B41A0", T: "14418C" },
  { L: "4B38D6", B: "145320", R: "4B41A0", T: "1458FC" },
  { L: "4B300C", B: "1458FC", R: "4B38D6", T: "145ED8" },
  { L: "4B38D6", B: "1458FC", R: "4B41A0", T: "145ED8" },
  { L: "4B300C", B: "145ED8", R: "4B38D6", T: "1464B4" },
  { L: "4B300C", B: "14706C", R: "4B38D6", T: "147648" },
  { L: "4B41A0", B: "142440", R: "4B4A6A", T: "142A1C" },
  { L: "4B4A6A", B: "142440", R: "4B5334", T: "142A1C" },
  { L: "4B41A0", B: "142A1C", R: "4B4A6A", T: "142FF8" },
  { L: "4B4A6A", B: "142A1C", R: "4B5334", T: "142FF8" },
  { L: "4B5334", B: "142440", R: "4B5BFE", T: "142A1C" },
  { L: "4B5BFE", B: "142440", R: "4B64C8", T: "142A1C" },
  { L: "4B5334", B: "142A1C", R: "4B5BFE", T: "142FF8" },
  { L: "4B5BFE", B: "142A1C", R: "4B64C8", T: "142FF8" },
  { L: "4B64C8", B: "142440", R: "4B6D92", T: "142A1C" },
  { L: "4B64C8", B: "142A1C", R: "4B6D92", T: "142FF8" },
  { L: "4B6D92", B: "142A1C", R: "4B765C", T: "142FF8" },
  { L: "4B765C", B: "142A1C", R: "4B7F26", T: "142FF8" },
  { L: "4B41A0", B: "142FF8", R: "4B4A6A", T: "1435D4" },
  { L: "4B4A6A", B: "142FF8", R: "4B5334", T: "1435D4" },
  { L: "4B41A0", B: "1435D4", R: "4B4A6A", T: "143BB0" },
  { L: "4B4A6A", B: "1435D4", R: "4B5334", T: "143BB0" },
  { L: "4B5334", B: "142FF8", R: "4B5BFE", T: "1435D4" },
  { L: "4B5BFE", B: "142FF8", R: "4B64C8", T: "1435D4" },
  { L: "4B64C8", B: "142FF8", R: "4B6D92", T: "1435D4" },
  { L: "4B6D92", B: "142FF8", R: "4B765C", T: "1435D4" },
  { L: "4B6D92", B: "1435D4", R: "4B765C", T: "143BB0" },
  { L: "4B765C", B: "142FF8", R: "4B7F26", T: "1435D4" },
  { L: "4B765C", B: "1435D4", R: "4B7F26", T: "143BB0" },
  { L: "4B41A0", B: "143BB0", R: "4B4A6A", T: "14418C" },
  { L: "4B765C", B: "143BB0", R: "4B7F26", T: "14418C" },
  { L: "4B7F26", B: "143BB0", R: "4B87F0", T: "14418C" },
  { L: "4B765C", B: "14418C", R: "4B7F26", T: "144768" },
  { L: "4B7F26", B: "14418C", R: "4B87F0", T: "144768" },
  { L: "4BB3E2", B: "145320", R: "4BBCAC", T: "1458FC" },
  { L: "4BB3E2", B: "1458FC", R: "4BBCAC", T: "145ED8" },
  { L: "4BBCAC", B: "145320", R: "4BC576", T: "1458FC" },
  { L: "4BBCAC", B: "1458FC", R: "4BC576", T: "145ED8" },
  { L: "4BDFD4", B: "142440", R: "4BE89E", T: "142A1C" },
  { L: "4BE89E", B: "142440", R: "4BF168", T: "142A1C" },
  { L: "4BF168", B: "142440", R: "4BFA32", T: "142A1C" },
  { L: "4BFA32", B: "142440", R: "4C02FC", T: "142A1C" },
  { L: "4BF168", B: "142A1C", R: "4BFA32", T: "142FF8" },
  { L: "4BFA32", B: "142A1C", R: "4C02FC", T: "142FF8" },
  { L: "4C02FC", B: "142440", R: "4C0BC6", T: "142A1C" },
  { L: "4C02FC", B: "142A1C", R: "4C0BC6", T: "142FF8" },
  { L: "4C0BC6", B: "142A1C", R: "4C1490", T: "142FF8" },
  { L: "4C37B8", B: "142440", R: "4C4082", T: "142A1C" },
  { L: "4BE89E", B: "1435D4", R: "4BF168", T: "143BB0" },
  { L: "4BFA32", B: "142FF8", R: "4C02FC", T: "1435D4" },
  { L: "4C02FC", B: "142FF8", R: "4C0BC6", T: "1435D4" },
  { L: "4C5216", B: "142FF8", R: "4C5AE0", T: "1435D4" },
  { L: "4BFE97", B: "143BB0", R: "4C02FC", T: "14418C" },
  { L: "4C02FC", B: "143BB0", R: "4C0761", T: "14418C" },
  { L: "4C0761", B: "14447A", R: "4C0BC6", T: "144768" },
  { L: "4C0BC6", B: "14447A", R: "4C102B", T: "144768" },
  { L: "4C0761", B: "144768", R: "4C0BC6", T: "144A56" },
  { L: "4C0BC6", B: "144768", R: "4C102B", T: "144A56" },
  { L: "4C3C1D", B: "144768", R: "4C4082", T: "144D44" },
  { L: "4C4082", B: "144768", R: "4C44E7", T: "144D44" },
  { L: "4BE89E", B: "145320", R: "4BF168", T: "1458FC" },
  { L: "4BF168", B: "145320", R: "4BFA32", T: "1458FC" },
  { L: "4BE89E", B: "145ED8", R: "4BF168", T: "1464B4" },
  { L: "4BE89E", B: "1464B4", R: "4BF168", T: "146A90" },
  { L: "4BF168", B: "145ED8", R: "4BFA32", T: "1464B4" },
  { L: "4BF168", B: "1464B4", R: "4BFA32", T: "146A90" },
  { L: "4C2EEE", B: "145ED8", R: "4C37B8", T: "1464B4" },
  { L: "4C2EEE", B: "1464B4", R: "4C37B8", T: "146A90" },
  { L: "4C37B8", B: "145ED8", R: "4C4082", T: "1464B4" },
  { L: "4C37B8", B: "1464B4", R: "4C4082", T: "146A90" },
  { L: "4BE89E", B: "146A90", R: "4BF168", T: "14706C" },
  { L: "4BF168", B: "146A90", R: "4BFA32", T: "14706C" },
  { L: "4C37B8", B: "147C24", R: "4C4082", T: "148200" },
  { L: "4C4082", B: "147C24", R: "4C494C", T: "148200" },
  { L: "4C9866", B: "142A1C", R: "4CA130", T: "142FF8" },
  { L: "4CA130", B: "142A1C", R: "4CA9FA", T: "142FF8" },
  { L: "4CA9FA", B: "142A1C", R: "4CB2C4", T: "142FF8" },
  { L: "4CBB8E", B: "142440", R: "4CC458", T: "142A1C" },
  { L: "4CB2C4", B: "142A1C", R: "4CBB8E", T: "142FF8" },
  { L: "4CBB8E", B: "142A1C", R: "4CC458", T: "142FF8" },
  { L: "4CC458", B: "142440", R: "4CCD22", T: "142A1C" },
  { L: "4CCD22", B: "142440", R: "4CD5EC", T: "142A1C" },
  { L: "4CA9FA", B: "142FF8", R: "4CB2C4", T: "1435D4" },
  { L: "4CBB8E", B: "142FF8", R: "4CC458", T: "1435D4" },
  { L: "4CBB8E", B: "1435D4", R: "4CC458", T: "143BB0" },
  { L: "4CDA51", B: "142FF8", R: "4CDEB6", T: "1435D4" },
  { L: "4CDEB6", B: "142FF8", R: "4CE780", T: "1435D4" },
  { L: "4CDA51", B: "1435D4", R: "4CDEB6", T: "143BB0" },
  { L: "4CDEB6", B: "1435D4", R: "4CE780", T: "143BB0" },
  { L: "4CBB8E", B: "143BB0", R: "4CC458", T: "14418C" },
  { L: "4CBB8E", B: "14418C", R: "4CC458", T: "144768" },
  { L: "4CDEB6", B: "143BB0", R: "4CE780", T: "14418C" },
  { L: "4CDEB6", B: "14418C", R: "4CE780", T: "144768" },
  { L: "4CCD22", B: "144D44", R: "4CD5EC", T: "145320" },
  { L: "4CDEB6", B: "144768", R: "4CE780", T: "144D44" },
  { L: "4D3F64", B: "142440", R: "4D482E", T: "142A1C" },
  { L: "4D482E", B: "142440", R: "4D50F8", T: "142A1C" },
  { L: "4D3F64", B: "142A1C", R: "4D482E", T: "142FF8" },
  { L: "4D482E", B: "142A1C", R: "4D50F8", T: "142FF8" },
  { L: "4D482E", B: "142FF8", R: "4D50F8", T: "1435D4" },
  { L: "4D482E", B: "1435D4", R: "4D50F8", T: "143BB0" },
  { L: "4D50F8", B: "142FF8", R: "4D59C2", T: "1435D4" },
  { L: "4D50F8", B: "1435D4", R: "4D59C2", T: "143BB0" },
  { L: "4CE780", B: "143BB0", R: "4CF04A", T: "14418C" },
  { L: "4CE780", B: "14418C", R: "4CF04A", T: "144768" },
  { L: "4D50F8", B: "143BB0", R: "4D59C2", T: "14418C" },
  { L: "4D50F8", B: "14418C", R: "4D59C2", T: "144768" },
  { L: "4D59C2", B: "14418C", R: "4D628C", T: "144768" },
  { L: "4CE780", B: "144768", R: "4CF04A", T: "144D44" },
  { L: "4CF04A", B: "144768", R: "4CF4AF", T: "144D44" },
  { L: "4CE780", B: "144D44", R: "4CF04A", T: "145320" },
  { L: "4CF04A", B: "144D44", R: "4CF4AF", T: "145320" },
  { L: "4D50F8", B: "144768", R: "4D59C2", T: "144D44" },
  { L: "4D59C2", B: "144768", R: "4D628C", T: "144D44" },
  { L: "4D59C2", B: "144D44", R: "4D628C", T: "145320" },
  { L: "4D628C", B: "144768", R: "4D6B56", T: "144D44" },
  { L: "4D6B56", B: "144768", R: "4D7420", T: "144D44" },
  { L: "4D628C", B: "144D44", R: "4D6B56", T: "145320" },
  { L: "4D6B56", B: "144D44", R: "4D7420", T: "145320" },
  { L: "4D59C2", B: "145320", R: "4D628C", T: "1458FC" },
  { L: "4D59C2", B: "1458FC", R: "4D628C", T: "145ED8" },
  { L: "4D628C", B: "145320", R: "4D6B56", T: "1458FC" },
  { L: "4D6B56", B: "145320", R: "4D7420", T: "1458FC" },
  { L: "4D628C", B: "1458FC", R: "4D6B56", T: "145ED8" },
  { L: "4D6B56", B: "1458FC", R: "4D7420", T: "145ED8" },
  { L: "4CF914", B: "145ED8", R: "4D01DE", T: "1464B4" },
  { L: "4D01DE", B: "145ED8", R: "4D0AA8", T: "1464B4" },
  { L: "4CF914", B: "1464B4", R: "4D01DE", T: "146A90" },
  { L: "4D01DE", B: "1464B4", R: "4D0AA8", T: "146A90" },
  { L: "4D6B56", B: "145ED8", R: "4D7420", T: "1464B4" },
  { L: "4D1372", B: "147648", R: "4D1C3C", T: "147C24" },
  { L: "4D1372", B: "147C24", R: "4D1C3C", T: "148200" },
  { L: "4D1C3C", B: "147648", R: "4D2506", T: "147C24" },
  { L: "4D1C3C", B: "147C24", R: "4D2506", T: "148200" },
  { L: "4D7420", B: "145ED8", R: "4D7CEA", T: "1464B4" },
  { L: "4B300C", B: "1487DC", R: "4B38D6", T: "148DB8" },
  { L: "4B64C8", B: "148DB8", R: "4B6D92", T: "149394" },
  { L: "4C1490", B: "148200", R: "4C1D5A", T: "1487DC" },
  { L: "4C1D5A", B: "148200", R: "4C2624", T: "1487DC" },
  { L: "4C1490", B: "1487DC", R: "4C1D5A", T: "148DB8" },
  { L: "4C1D5A", B: "1487DC", R: "4C2624", T: "148DB8" },
  { L: "4C3353", B: "1487DC", R: "4C37B8", T: "148DB8" },
  { L: "4C37B8", B: "1487DC", R: "4C4082", T: "148DB8" },
  { L: "4C4082", B: "1487DC", R: "4C494C", T: "148DB8" },
  { L: "4C494C", B: "1487DC", R: "4C5216", T: "148DB8" },
  { L: "4C3353", B: "148DB8", R: "4C37B8", T: "149394" },
  { L: "4C37B8", B: "148DB8", R: "4C4082", T: "149394" },
  { L: "4C4082", B: "148DB8", R: "4C494C", T: "149394" },
  { L: "4C37B8", B: "149394", R: "4C4082", T: "149970" },
  { L: "4C4082", B: "149394", R: "4C494C", T: "149970" },
  { L: "4C494C", B: "148DB8", R: "4C5216", T: "149394" },
  { L: "4C494C", B: "149394", R: "4C5216", T: "149970" },
  { L: "4C567B", B: "149394", R: "4C5AE0", T: "149970" },
  { L: "4C4082", B: "149970", R: "4C494C", T: "149F4C" },
  { L: "4C494C", B: "149970", R: "4C5216", T: "149F4C" },
  { L: "4C494C", B: "149F4C", R: "4C5216", T: "14A528" },
  { L: "4C494C", B: "14A528", R: "4C5216", T: "14AB04" },
  { L: "4C5216", B: "14A528", R: "4C5AE0", T: "14AB04" },
  { L: "4C494C", B: "14AB04", R: "4C5216", T: "14B0E0" },
  { L: "4C5216", B: "14AB04", R: "4C5AE0", T: "14B0E0" },
  { L: "4C4082", B: "14B0E0", R: "4C494C", T: "14B6BC" },
  { L: "4C4082", B: "14B6BC", R: "4C494C", T: "14BC98" },
  { L: "4C494C", B: "14B0E0", R: "4C5216", T: "14B6BC" },
  { L: "4C5216", B: "14B0E0", R: "4C5AE0", T: "14B6BC" },
  { L: "4C494C", B: "14B6BC", R: "4C5216", T: "14BC98" },
  { L: "4C5216", B: "14B6BC", R: "4C5AE0", T: "14BC98" },
  { L: "4BF168", B: "14C274", R: "4BFA32", T: "14C850" },
  { L: "4C494C", B: "14BC98", R: "4C5216", T: "14C274" },
  { L: "4C5216", B: "14BC98", R: "4C5AE0", T: "14C274" },
  { L: "4C494C", B: "14C274", R: "4C5216", T: "14C850" },
  { L: "4C5216", B: "14C274", R: "4C5AE0", T: "14C850" },
  { L: "4C494C", B: "14C850", R: "4C5216", T: "14CE2C" },
  { L: "4C5216", B: "14C850", R: "4C5AE0", T: "14CE2C" },
  { L: "4C5216", B: "14CE2C", R: "4C5AE0", T: "14D408" },
  { L: "4C5AE0", B: "149394", R: "4C5F45", T: "149970" },
  { L: "4CD5EC", B: "149394", R: "4CDEB6", T: "149970" },
  { L: "4CDEB6", B: "149394", R: "4CE780", T: "149970" },
  { L: "4CD5EC", B: "149970", R: "4CDEB6", T: "149F4C" },
  { L: "4CDEB6", B: "149970", R: "4CE780", T: "149F4C" },
  { L: "4C5AE0", B: "14AB04", R: "4C63AA", T: "14B0E0" },
  { L: "4C63AA", B: "14AB04", R: "4C6C74", T: "14B0E0" },
  { L: "4CD187", B: "14AB04", R: "4CD5EC", T: "14B0E0" },
  { L: "4CD5EC", B: "14AB04", R: "4CDA51", T: "14B0E0" },
  { L: "4C5AE0", B: "14B0E0", R: "4C63AA", T: "14B6BC" },
  { L: "4C63AA", B: "14B0E0", R: "4C6C74", T: "14B6BC" },
  { L: "4C5AE0", B: "14B6BC", R: "4C63AA", T: "14BC98" },
  { L: "4C63AA", B: "14B6BC", R: "4C6C74", T: "14BC98" },
  { L: "4C6C74", B: "14B6BC", R: "4C753E", T: "14BC98" },
  { L: "4C753E", B: "14B6BC", R: "4C7E08", T: "14BC98" },
  { L: "4C5AE0", B: "14BC98", R: "4C63AA", T: "14C274" },
  { L: "4C63AA", B: "14BC98", R: "4C6C74", T: "14C274" },
  { L: "4C5AE0", B: "14C274", R: "4C63AA", T: "14C850" },
  { L: "4C63AA", B: "14C274", R: "4C6C74", T: "14C850" },
  { L: "4C6C74", B: "14BC98", R: "4C753E", T: "14C274" },
  { L: "4C753E", B: "14BC98", R: "4C7E08", T: "14C274" },
  { L: "4C6C74", B: "14C274", R: "4C753E", T: "14C850" },
  { L: "4C753E", B: "14C274", R: "4C7E08", T: "14C850" },
  { L: "4C5AE0", B: "14C850", R: "4C63AA", T: "14CE2C" },
  { L: "4C63AA", B: "14C850", R: "4C6C74", T: "14CE2C" },
  { L: "4C5AE0", B: "14CE2C", R: "4C63AA", T: "14D408" },
  { L: "4C63AA", B: "14CE2C", R: "4C6C74", T: "14D408" },
  { L: "4C6C74", B: "14C850", R: "4C753E", T: "14CE2C" },
  { L: "4C753E", B: "14C850", R: "4C7E08", T: "14CE2C" },
  { L: "4C6C74", B: "14CE2C", R: "4C753E", T: "14D408" },
  { L: "4C753E", B: "14CE2C", R: "4C7E08", T: "14D408" },
  { L: "4C5AE0", B: "14D408", R: "4C63AA", T: "14D9E4" },
  { L: "4C63AA", B: "14D408", R: "4C6C74", T: "14D9E4" },
  { L: "4C63AA", B: "14D9E4", R: "4C6C74", T: "14DFC0" },
  { L: "4C6C74", B: "14D408", R: "4C753E", T: "14D9E4" },
  { L: "4C753E", B: "14D408", R: "4C7E08", T: "14D9E4" },
  { L: "4C6C74", B: "14D9E4", R: "4C753E", T: "14DFC0" },
  { L: "4C753E", B: "14D9E4", R: "4C7E08", T: "14DFC0" },
  { L: "4C7E08", B: "14D408", R: "4C86D2", T: "14D9E4" },
  { L: "4C86D2", B: "14D408", R: "4C8F9C", T: "14D9E4" },
  { L: "4C7E08", B: "14D9E4", R: "4C86D2", T: "14DFC0" },
  { L: "4C86D2", B: "14D9E4", R: "4C8F9C", T: "14DFC0" },
  { L: "4D1372", B: "148200", R: "4D1C3C", T: "1487DC" },
  { L: "4D1372", B: "1487DC", R: "4D1C3C", T: "148DB8" },
  { L: "4D1C3C", B: "148200", R: "4D2506", T: "1487DC" },
  { L: "4D1C3C", B: "1487DC", R: "4D2506", T: "148DB8" },
  { L: "4D1372", B: "148DB8", R: "4D1C3C", T: "149394" },
  { L: "4D0AA8", B: "149394", R: "4D1372", T: "149970" },
  { L: "4D1C3C", B: "148DB8", R: "4D2506", T: "149394" },
  { L: "4D2506", B: "148DB8", R: "4D2DD0", T: "149394" },
  { L: "4D2DD0", B: "148DB8", R: "4D369A", T: "149394" },
  { L: "4D369A", B: "148DB8", R: "4D3F64", T: "149394" },
  { L: "4D1C3C", B: "149F4C", R: "4D2506", T: "14A528" },
  { L: "4D2506", B: "149F4C", R: "4D2DD0", T: "14A528" },
  { L: "4D1C3C", B: "14A528", R: "4D2506", T: "14AB04" },
  { L: "4D2506", B: "14A528", R: "4D2DD0", T: "14AB04" },
  { L: "4D1C3C", B: "14AB04", R: "4D2506", T: "14B0E0" },
  { L: "4D2506", B: "14AB04", R: "4D2DD0", T: "14B0E0" },
  { L: "4D6B56", B: "14A528", R: "4D7420", T: "14AB04" },
  { L: "4D6B56", B: "14AB04", R: "4D7420", T: "14B0E0" },
  { L: "4D1372", B: "14B0E0", R: "4D1C3C", T: "14B6BC" },
  { L: "4D1C3C", B: "14B0E0", R: "4D2506", T: "14B6BC" },
  { L: "4D2506", B: "14B0E0", R: "4D2DD0", T: "14B6BC" },
  { L: "4D1C3C", B: "14B6BC", R: "4D2506", T: "14BC98" },
  { L: "4D2506", B: "14B6BC", R: "4D2DD0", T: "14BC98" },
  { L: "4D2DD0", B: "14B0E0", R: "4D369A", T: "14B6BC" },
  { L: "4D2DD0", B: "14B6BC", R: "4D369A", T: "14BC98" },
  { L: "4D1C3C", B: "14BC98", R: "4D2506", T: "14C274" },
  { L: "4D2506", B: "14BC98", R: "4D2DD0", T: "14C274" },
  { L: "4D1C3C", B: "14C274", R: "4D2506", T: "14C850" },
  { L: "4D2506", B: "14C274", R: "4D2DD0", T: "14C850" },
  { L: "4D2DD0", B: "14BC98", R: "4D369A", T: "14C274" },
  { L: "4D2DD0", B: "14C274", R: "4D369A", T: "14C850" },
  { L: "4D369A", B: "14C274", R: "4D3F64", T: "14C850" },
  { L: "4D628C", B: "14BC98", R: "4D6B56", T: "14C274" },
  { L: "4D628C", B: "14C274", R: "4D6B56", T: "14C850" },
  { L: "4CF04A", B: "14CE2C", R: "4CF914", T: "14D408" },
  { L: "4CF914", B: "14CE2C", R: "4D01DE", T: "14D408" },
  { L: "4D2506", B: "14C850", R: "4D2DD0", T: "14CE2C" },
  { L: "4CF04A", B: "14D408", R: "4CF914", T: "14D9E4" },
  { L: "4CF914", B: "14D408", R: "4D01DE", T: "14D9E4" },
  { L: "4D3AFF", B: "14DCD2", R: "4D3F64", T: "14DFC0" },
  { L: "4D3F64", B: "14DCD2", R: "4D43C9", T: "14DFC0" },
  { L: "4D50F8", B: "14D9E4", R: "4D59C2", T: "14DFC0" },
  { L: "4BED03", B: "14E2AE", R: "4BF168", T: "14E59C" },
  { L: "4BED03", B: "14E59C", R: "4BF168", T: "14E88A" },
  { L: "4BF168", B: "14E2AE", R: "4BF5CD", T: "14E59C" },
  { L: "4BF168", B: "14E59C", R: "4BF5CD", T: "14E88A" },
  { L: "4C02FC", B: "14E59C", R: "4C0BC6", T: "14EB78" },
  { L: "4C0BC6", B: "14E59C", R: "4C1490", T: "14EB78" },
  { L: "4C02FC", B: "14EB78", R: "4C0BC6", T: "14F154" },
  { L: "4C0BC6", B: "14EB78", R: "4C1490", T: "14F154" },
  { L: "4C9866", B: "14FD0C", R: "4CA130", T: "1502E8" },
  { L: "4CF914", B: "14DFC0", R: "4D01DE", T: "14E59C" },
  { L: "4CF914", B: "14E59C", R: "4D01DE", T: "14EB78" },
  { L: "4D3AFF", B: "14DFC0", R: "4D3F64", T: "14E2AE" },
  { L: "4D3F64", B: "14DFC0", R: "4D43C9", T: "14E2AE" },
  { L: "4D482E", B: "14DFC0", R: "4D50F8", T: "14E59C" },
  { L: "4D482E", B: "14E59C", R: "4D50F8", T: "14EB78" },
  { L: "4D50F8", B: "14DFC0", R: "4D59C2", T: "14E59C" },
  { L: "4D59C2", B: "14DFC0", R: "4D628C", T: "14E59C" },
  { L: "4D50F8", B: "14E59C", R: "4D59C2", T: "14EB78" },
  { L: "4D59C2", B: "14E59C", R: "4D628C", T: "14EB78" },
  { L: "4D628C", B: "14DFC0", R: "4D6B56", T: "14E59C" },
  { L: "4D628C", B: "14E59C", R: "4D6B56", T: "14EB78" },
  { L: "4CE780", B: "14EB78", R: "4CF04A", T: "14F154" },
  { L: "4D0AA8", B: "14F154", R: "4D1372", T: "14F730" },
  { L: "4D1372", B: "14F154", R: "4D1C3C", T: "14F730" },
  { L: "4D1C3C", B: "14F154", R: "4D2506", T: "14F730" },
  { L: "4D555D", B: "14EB78", R: "4D59C2", T: "14F154" },
  { L: "4D59C2", B: "14EB78", R: "4D628C", T: "14F154" },
  { L: "4D50F8", B: "14F154", R: "4D59C2", T: "14F730" },
  { L: "4D59C2", B: "14F154", R: "4D628C", T: "14F730" },
  { L: "4D628C", B: "14EB78", R: "4D6B56", T: "14F154" },
  { L: "4D6B56", B: "14EB78", R: "4D7420", T: "14F154" },
  { L: "4D628C", B: "14F154", R: "4D6B56", T: "14F730" },
  { L: "4D6B56", B: "14F154", R: "4D7420", T: "14F730" },
  { L: "4D0AA8", B: "14F730", R: "4D1372", T: "14FD0C" },
  { L: "4D1372", B: "14F730", R: "4D1C3C", T: "14FD0C" },
  { L: "4D0AA8", B: "14FD0C", R: "4D1372", T: "1502E8" },
  { L: "4D1372", B: "14FD0C", R: "4D1C3C", T: "1502E8" },
  { L: "4D1C3C", B: "14F730", R: "4D2506", T: "14FD0C" },
  { L: "4D1C3C", B: "14FD0C", R: "4D2506", T: "1502E8" },
  { L: "4D482E", B: "14FD0C", R: "4D50F8", T: "1502E8" },
  { L: "4D50F8", B: "14F730", R: "4D59C2", T: "14FD0C" },
  { L: "4D59C2", B: "14F730", R: "4D628C", T: "14FD0C" },
  { L: "4D50F8", B: "14FD0C", R: "4D59C2", T: "1502E8" },
  { L: "4D59C2", B: "14FD0C", R: "4D628C", T: "1502E8" },
  { L: "4D628C", B: "14F730", R: "4D6B56", T: "14FD0C" },
  { L: "4D6B56", B: "14F730", R: "4D7420", T: "14FD0C" },
  { L: "4D628C", B: "14FD0C", R: "4D6B56", T: "1502E8" },
  { L: "4D6B56", B: "14FD0C", R: "4D7420", T: "1502E8" },
  { L: "4D0AA8", B: "1502E8", R: "4D1372", T: "1508C4" },
  { L: "4D1372", B: "1502E8", R: "4D1C3C", T: "1508C4" },
  { L: "4D0AA8", B: "1508C4", R: "4D1372", T: "150EA0" },
  { L: "4D1372", B: "1508C4", R: "4D1C3C", T: "150EA0" },
  { L: "4D1C3C", B: "1502E8", R: "4D2506", T: "1508C4" },
  { L: "4D1C3C", B: "1508C4", R: "4D2506", T: "150EA0" },
  { L: "4D3AFF", B: "150BB2", R: "4D3F64", T: "150EA0" },
  { L: "4D4C93", B: "1502E8", R: "4D50F8", T: "1508C4" },
  { L: "4D3F64", B: "150BB2", R: "4D43C9", T: "150EA0" },
  { L: "4D4C93", B: "1508C4", R: "4D50F8", T: "150EA0" },
  { L: "4D50F8", B: "1502E8", R: "4D59C2", T: "1508C4" },
  { L: "4D59C2", B: "1502E8", R: "4D628C", T: "1508C4" },
  { L: "4D50F8", B: "1508C4", R: "4D59C2", T: "150EA0" },
  { L: "4D59C2", B: "1508C4", R: "4D628C", T: "150EA0" },
  { L: "4D628C", B: "1502E8", R: "4D6B56", T: "1508C4" },
  { L: "4D6B56", B: "1502E8", R: "4D7420", T: "1508C4" },
  { L: "4D628C", B: "1508C4", R: "4D6B56", T: "150EA0" },
  { L: "4D6B56", B: "1508C4", R: "4D7420", T: "150EA0" },
  { L: "4D0AA8", B: "150EA0", R: "4D1372", T: "15147C" },
  { L: "4D1372", B: "150EA0", R: "4D1C3C", T: "15147C" },
  { L: "4D0AA8", B: "15147C", R: "4D1372", T: "151A58" },
  { L: "4D1372", B: "15147C", R: "4D1C3C", T: "151A58" },
  { L: "4D1C3C", B: "150EA0", R: "4D2506", T: "15147C" },
  { L: "4D1C3C", B: "15147C", R: "4D2506", T: "151A58" },
  { L: "4D3AFF", B: "150EA0", R: "4D3F64", T: "15118E" },
  { L: "4D3F64", B: "150EA0", R: "4D43C9", T: "15118E" },
  { L: "4D50F8", B: "150EA0", R: "4D59C2", T: "15147C" },
  { L: "4D59C2", B: "150EA0", R: "4D628C", T: "15147C" },
  { L: "4D59C2", B: "15147C", R: "4D628C", T: "151A58" },
  { L: "4D628C", B: "150EA0", R: "4D6B56", T: "15147C" },
  { L: "4D6B56", B: "150EA0", R: "4D7420", T: "15147C" },
  { L: "4D628C", B: "15147C", R: "4D6B56", T: "151A58" },
  { L: "4D1372", B: "151A58", R: "4D1C3C", T: "152034" },
  { L: "4D1372", B: "152034", R: "4D1C3C", T: "152610" },
  { L: "4D1C3C", B: "151A58", R: "4D2506", T: "152034" },
  { L: "4D1C3C", B: "152034", R: "4D2506", T: "152610" },
  { L: "4D628C", B: "151A58", R: "4D6B56", T: "152034" },
  { L: "4D59C2", B: "152BEC", R: "4D628C", T: "1531C8" },
  { L: "4D628C", B: "152BEC", R: "4D6B56", T: "1531C8" },
  { L: "4D6B56", B: "152BEC", R: "4D7420", T: "1531C8" },
  { L: "4D1C3C", B: "1531C8", R: "4D2506", T: "1537A4" },
  { L: "4D66F1", B: "1531C8", R: "4D6B56", T: "1534B6" },
  { L: "4D6B56", B: "1531C8", R: "4D7420", T: "1534B6" },
  { L: "4D7420", B: "14FD0C", R: "4D7CEA", T: "1502E8" },
  { L: "4D7420", B: "1502E8", R: "4D7CEA", T: "1508C4" },
  { L: "4D7CEA", B: "1502E8", R: "4D85B4", T: "1508C4" },
  { L: "4D7420", B: "1508C4", R: "4D7CEA", T: "150EA0" },
  { L: "4D7CEA", B: "1508C4", R: "4D85B4", T: "150EA0" },
  { L: "4D7420", B: "150EA0", R: "4D7CEA", T: "15147C" },
  { L: "4D7CEA", B: "150EA0", R: "4D85B4", T: "15147C" },
  { L: "4D7420", B: "15147C", R: "4D7CEA", T: "151A58" },
  { L: "4D7CEA", B: "15147C", R: "4D85B4", T: "151A58" },
  { L: "4D85B4", B: "150EA0", R: "4D8E7E", T: "15147C" },
  { L: "4D85B4", B: "15147C", R: "4D8E7E", T: "151A58" },
  { L: "4D8E7E", B: "15147C", R: "4D9748", T: "151A58" },
  { L: "4D9748", B: "15147C", R: "4DA012", T: "151A58" },
  { L: "4DA012", B: "15147C", R: "4DA8DC", T: "151A58" },
  { L: "4D8E7E", B: "151A58", R: "4D9748", T: "152034" },
  { L: "4D9748", B: "151A58", R: "4DA012", T: "152034" },
  { L: "4DA012", B: "151A58", R: "4DA8DC", T: "152034" },
  { L: "4D814F", B: "1528FE", R: "4D85B4", T: "152BEC" },
  { L: "4D814F", B: "152BEC", R: "4D85B4", T: "152EDA" },
  { L: "4D85B4", B: "1528FE", R: "4D8A19", T: "152BEC" },
  { L: "4D85B4", B: "152BEC", R: "4D8A19", T: "152EDA" },
  { L: "4D9748", B: "1537A4", R: "4DA012", T: "153D80" },
  { L: "4CC458", B: "153D80", R: "4CCD22", T: "15435C" },
  { L: "4CCD22", B: "153D80", R: "4CD5EC", T: "15435C" },
  { L: "4CC458", B: "15435C", R: "4CCD22", T: "154938" },
  { L: "4CCD22", B: "15435C", R: "4CD5EC", T: "154938" },
  { L: "4CC458", B: "154938", R: "4CCD22", T: "154F14" },
  { L: "4CCD22", B: "154938", R: "4CD5EC", T: "154F14" },
  { L: "4CC458", B: "154F14", R: "4CCD22", T: "1554F0" },
  { L: "4CCD22", B: "154F14", R: "4CD5EC", T: "1554F0" },
  { L: "4CC458", B: "1554F0", R: "4CCD22", T: "155ACC" },
  { L: "4CCD22", B: "1554F0", R: "4CD5EC", T: "155ACC" },
  { L: "4CC458", B: "155ACC", R: "4CCD22", T: "1560A8" },
  { L: "4CCD22", B: "155ACC", R: "4CD5EC", T: "1560A8" },
  { L: "4CC458", B: "1560A8", R: "4CCD22", T: "156684" },
  { L: "4CCD22", B: "1560A8", R: "4CD5EC", T: "156684" },
  { L: "4CCD22", B: "156684", R: "4CD5EC", T: "156C60" },
  { L: "4D0F0D", B: "15435C", R: "4D1372", T: "154938" },
  { L: "4D1372", B: "15435C", R: "4D17D7", T: "154938" },
  { L: "4D482E", B: "15435C", R: "4D50F8", T: "154938" },
  { L: "4D0F0D", B: "154938", R: "4D1372", T: "154F14" },
  { L: "4D1372", B: "154938", R: "4D17D7", T: "154F14" },
  { L: "4D296B", B: "157DF4", R: "4D2DD0", T: "1583D0" },
  { L: "4D2DD0", B: "157DF4", R: "4D3235", T: "1583D0" },
  { L: "4D296B", B: "1583D0", R: "4D2DD0", T: "1589AC" },
  { L: "4D2DD0", B: "1583D0", R: "4D3235", T: "1589AC" },
  { L: "4D3235", B: "158F88", R: "4D369A", T: "159564" },
  { L: "4D369A", B: "158F88", R: "4D3AFF", T: "159564" },
  { L: "4D3235", B: "159564", R: "4D369A", T: "159B40" },
  { L: "4D369A", B: "159564", R: "4D3AFF", T: "159B40" },
  { L: "4D7420", B: "15435C", R: "4D7CEA", T: "154938" },
  { L: "4D8A19", B: "153D80", R: "4D8E7E", T: "15435C" },
  { L: "4D8E7E", B: "153D80", R: "4D92E3", T: "15435C" },
  { L: "4D7CEA", B: "155DBA", R: "4D85B4", T: "1560A8" },
  { L: "4D85B4", B: "155DBA", R: "4D8E7E", T: "1560A8" },
  { L: "4DBED5", B: "155ACC", R: "4DC33A", T: "1560A8" },
  { L: "4DC33A", B: "155ACC", R: "4DC79F", T: "1560A8" },
  { L: "4D7CEA", B: "1560A8", R: "4D85B4", T: "156684" },
  { L: "4D7CEA", B: "156684", R: "4D85B4", T: "156C60" },
  { L: "4D85B4", B: "1560A8", R: "4D8E7E", T: "156684" },
  { L: "4DC79F", B: "156C60", R: "4DCC04", T: "15723C" },
  { L: "4DCC04", B: "156C60", R: "4DD069", T: "15723C" },
  { L: "4DD4CE", B: "15723C", R: "4DDD98", T: "157818" },
  { L: "4D7CEA", B: "157818", R: "4D85B4", T: "157DF4" },
  { L: "4D7CEA", B: "157DF4", R: "4D85B4", T: "1583D0" },
  { L: "4D85B4", B: "157818", R: "4D8E7E", T: "157DF4" },
  { L: "4D8E7E", B: "157818", R: "4D9748", T: "157DF4" },
  { L: "4D85B4", B: "157DF4", R: "4D8E7E", T: "1583D0" },
  { L: "4D8E7E", B: "157DF4", R: "4D9748", T: "1583D0" },
  { L: "4DD4CE", B: "157818", R: "4DDD98", T: "157DF4" },
  { L: "4D7CEA", B: "1583D0", R: "4D85B4", T: "1589AC" },
  { L: "4D7CEA", B: "1589AC", R: "4D85B4", T: "158F88" },
  { L: "4D85B4", B: "1583D0", R: "4D8E7E", T: "1589AC" },
  { L: "4D8E7E", B: "1583D0", R: "4D9748", T: "1589AC" },
  { L: "4D85B4", B: "1589AC", R: "4D8E7E", T: "158F88" },
  { L: "4D7CEA", B: "158F88", R: "4D85B4", T: "159564" },
  { L: "4D7CEA", B: "159564", R: "4D85B4", T: "159B40" },
  { L: "4D85B4", B: "158F88", R: "4D8E7E", T: "159564" },
  { L: "4D85B4", B: "159564", R: "4D8E7E", T: "159B40" },
  { L: "4DBA70", B: "159852", R: "4DC33A", T: "159B40" },
  { L: "4DEAC7", B: "158F88", R: "4DEF2C", T: "159564" },
  { L: "4DEF2C", B: "158F88", R: "4DF391", T: "159564" },
  { L: "4CCD22", B: "15E190", R: "4CD5EC", T: "15E76C" },
  { L: "4CCD22", B: "15E76C", R: "4CD5EC", T: "15ED48" },
  { L: "4CE780", B: "159B40", R: "4CF04A", T: "15A11C" },
  { L: "4CF04A", B: "159B40", R: "4CF4AF", T: "15A11C" },
  { L: "4CE780", B: "15A11C", R: "4CF04A", T: "15A6F8" },
  { L: "4CF04A", B: "15A11C", R: "4CF4AF", T: "15A6F8" },
  { L: "4D2506", B: "15A6F8", R: "4D2DD0", T: "15ACD4" },
  { L: "4D2506", B: "15ACD4", R: "4D2DD0", T: "15B2B0" },
  { L: "4CF04A", B: "15C444", R: "4CF914", T: "15CA20" },
  { L: "4CF914", B: "15C444", R: "4D01DE", T: "15CA20" },
  { L: "4D3235", B: "15BE68", R: "4D369A", T: "15C444" },
  { L: "4D369A", B: "15BE68", R: "4D3F64", T: "15C444" },
  { L: "4CF04A", B: "15CA20", R: "4CF914", T: "15CFFC" },
  { L: "4CE780", B: "15CFFC", R: "4CF04A", T: "15D5D8" },
  { L: "4CF04A", B: "15CFFC", R: "4CF914", T: "15D5D8" },
  { L: "4CF914", B: "15CA20", R: "4D01DE", T: "15CFFC" },
  { L: "4CF914", B: "15CFFC", R: "4D01DE", T: "15D5D8" },
  { L: "4CE780", B: "15D5D8", R: "4CF04A", T: "15DBB4" },
  { L: "4CF04A", B: "15D5D8", R: "4CF914", T: "15DBB4" },
  { L: "4CF914", B: "15D5D8", R: "4D01DE", T: "15DBB4" },
  { L: "4D7CEA", B: "159B40", R: "4D85B4", T: "15A11C" },
  { L: "4D7CEA", B: "15A11C", R: "4D85B4", T: "15A6F8" },
  { L: "4D85B4", B: "159B40", R: "4D8E7E", T: "15A11C" },
  { L: "4D85B4", B: "15A11C", R: "4D8E7E", T: "15A6F8" },
  { L: "4DBA70", B: "159B40", R: "4DC33A", T: "159E2E" },
  { L: "4D7CEA", B: "15A6F8", R: "4D85B4", T: "15ACD4" },
  { L: "4D85B4", B: "15A6F8", R: "4D8E7E", T: "15ACD4" },
  { L: "4D7CEA", B: "15BE68", R: "4D85B4", T: "15C444" },
  { L: "4D7CEA", B: "15C444", R: "4D85B4", T: "15CA20" },
  { L: "4D85B4", B: "15BE68", R: "4D8E7E", T: "15C444" },
  { L: "4D85B4", B: "15C444", R: "4D8E7E", T: "15CA20" },
  { L: "4D8E7E", B: "15C444", R: "4D9748", T: "15CA20" },
  { L: "4DF7F6", B: "15C444", R: "4E00C0", T: "15CA20" },
  { L: "4D7420", B: "15CA20", R: "4D7CEA", T: "15CFFC" },
  { L: "4D7CEA", B: "15CA20", R: "4D85B4", T: "15CFFC" },
  { L: "4D7420", B: "15CFFC", R: "4D7CEA", T: "15D5D8" },
  { L: "4D7CEA", B: "15CFFC", R: "4D85B4", T: "15D5D8" },
  { L: "4D85B4", B: "15CA20", R: "4D8E7E", T: "15CFFC" },
  { L: "4D8E7E", B: "15CA20", R: "4D9748", T: "15CFFC" },
  { L: "4D85B4", B: "15CFFC", R: "4D8E7E", T: "15D5D8" },
  { L: "4D8E7E", B: "15CFFC", R: "4D9748", T: "15D5D8" },
  { L: "4D7CEA", B: "15D5D8", R: "4D85B4", T: "15DBB4" },
  { L: "4D7CEA", B: "15DBB4", R: "4D85B4", T: "15E190" },
  { L: "4D85B4", B: "15D5D8", R: "4D8E7E", T: "15DBB4" },
  { L: "4D85B4", B: "15DBB4", R: "4D8E7E", T: "15E190" },
  { L: "4CDEB6", B: "161070", R: "4CE780", T: "16164C" },
  { L: "4CDEB6", B: "16164C", R: "4CE780", T: "161C28" },
  { L: "4CE780", B: "161070", R: "4CF04A", T: "16164C" },
  { L: "4CE780", B: "16164C", R: "4CF04A", T: "161C28" },
  { L: "4D2DD0", B: "16164C", R: "4D369A", T: "161C28" },
  { L: "4D369A", B: "16164C", R: "4D3F64", T: "161C28" },
  { L: "4D50F8", B: "161070", R: "4D59C2", T: "16164C" },
  { L: "4D50F8", B: "16164C", R: "4D59C2", T: "161C28" },
  { L: "4D2DD0", B: "161C28", R: "4D369A", T: "162204" },
  { L: "4D369A", B: "161C28", R: "4D3F64", T: "162204" },
  { L: "4D2DD0", B: "162204", R: "4D369A", T: "1627E0" },
  { L: "4D369A", B: "162204", R: "4D3F64", T: "1627E0" },
  { L: "4D50F8", B: "161C28", R: "4D59C2", T: "162204" },
  { L: "4D1C3C", B: "16452C", R: "4D2506", T: "164B08" },
  { L: "4D2506", B: "16452C", R: "4D2DD0", T: "164B08" },
  { L: "4D2DD0", B: "16452C", R: "4D369A", T: "164B08" },
  { L: "4D369A", B: "16452C", R: "4D3F64", T: "164B08" },
  { L: "4D1C3C", B: "164B08", R: "4D2506", T: "1650E4" },
  { L: "4D2506", B: "164B08", R: "4D2DD0", T: "1650E4" },
  { L: "4D1C3C", B: "1650E4", R: "4D2506", T: "1656C0" },
  { L: "4D2506", B: "1650E4", R: "4D2DD0", T: "1656C0" },
  { L: "4D2DD0", B: "164B08", R: "4D369A", T: "1650E4" },
  { L: "4D369A", B: "164B08", R: "4D3F64", T: "1650E4" },
  { L: "4D2DD0", B: "1650E4", R: "4D369A", T: "1656C0" },
  { L: "4D369A", B: "1650E4", R: "4D3F64", T: "1656C0" },
  { L: "4DDD98", B: "161070", R: "4DE662", T: "16164C" },
  { L: "4D9BAD", B: "161C28", R: "4DA012", T: "162204" },
  { L: "4DA012", B: "161C28", R: "4DA477", T: "162204" },
  { L: "4DA8DC", B: "163974", R: "4DB1A6", T: "163F50" },
  { L: "4DB1A6", B: "163974", R: "4DBA70", T: "163F50" },
  { L: "4DBA70", B: "163974", R: "4DC33A", T: "163F50" },
  { L: "4DC33A", B: "163974", R: "4DCC04", T: "163F50" },
  { L: "4DA8DC", B: "163F50", R: "4DB1A6", T: "16452C" },
  { L: "4DB1A6", B: "163F50", R: "4DBA70", T: "16452C" },
  { L: "4DA8DC", B: "16452C", R: "4DB1A6", T: "164B08" },
  { L: "4DB1A6", B: "16452C", R: "4DBA70", T: "164B08" },
  { L: "4DBA70", B: "163F50", R: "4DC33A", T: "16452C" },
  { L: "4DC33A", B: "163F50", R: "4DCC04", T: "16452C" },
  { L: "4DBA70", B: "16452C", R: "4DC33A", T: "164B08" },
  { L: "4D8E7E", B: "164B08", R: "4D9748", T: "1650E4" },
  { L: "4DA012", B: "1650E4", R: "4DA8DC", T: "1656C0" },
  { L: "4DA8DC", B: "164B08", R: "4DB1A6", T: "1650E4" },
  { L: "4DB1A6", B: "164B08", R: "4DBA70", T: "1650E4" },
  { L: "4DA8DC", B: "1650E4", R: "4DB1A6", T: "1656C0" },
  { L: "4D20A1", B: "166566", R: "4D2506", T: "166854" },
  { L: "4D2506", B: "166566", R: "4D2DD0", T: "166854" },
  { L: "4D20A1", B: "166854", R: "4D2506", T: "166E30" },
  { L: "4D2506", B: "166854", R: "4D2DD0", T: "166E30" },
  { L: "4D3F64", B: "166278", R: "4D482E", T: "166854" },
  { L: "4D482E", B: "166278", R: "4D50F8", T: "166854" },
  { L: "4D3F64", B: "166854", R: "4D482E", T: "166E30" },
  { L: "4D482E", B: "166854", R: "4D50F8", T: "166E30" },
  { L: "4D50F8", B: "166278", R: "4D59C2", T: "166854" },
  { L: "4D59C2", B: "166278", R: "4D628C", T: "166854" },
  { L: "4D50F8", B: "166854", R: "4D59C2", T: "166E30" },
  { L: "4D59C2", B: "166854", R: "4D628C", T: "166E30" },
  { L: "4D3F64", B: "166E30", R: "4D482E", T: "16740C" },
  { L: "4D482E", B: "166E30", R: "4D50F8", T: "16740C" },
  { L: "4D50F8", B: "166E30", R: "4D59C2", T: "16740C" },
  { L: "4D59C2", B: "166E30", R: "4D628C", T: "16740C" },
  { L: "4DA012", B: "1656C0", R: "4DA8DC", T: "165C9C" },
  { L: "4DA8DC", B: "1656C0", R: "4DB1A6", T: "165C9C" },
  { L: "4D85B4", B: "16A8C8", R: "4D8E7E", T: "16AEA4" },
  { L: "4D8E7E", B: "16A8C8", R: "4D9748", T: "16AEA4" },
  { L: "4D85B4", B: "16AEA4", R: "4D8E7E", T: "16B480" },
  { L: "4D8E7E", B: "16AEA4", R: "4D9748", T: "16B480" },
  { L: "4D482E", B: "16E93C", R: "4D50F8", T: "16EF18" },
  { L: "4D482E", B: "16EF18", R: "4D50F8", T: "16F4F4" },
  { L: "4D3F64", B: "16F4F4", R: "4D482E", T: "16FAD0" },
  { L: "4D482E", B: "16F4F4", R: "4D50F8", T: "16FAD0" },
  { L: "4D50F8", B: "16EF18", R: "4D59C2", T: "16F4F4" },
  { L: "4D59C2", B: "16EF18", R: "4D628C", T: "16F4F4" },
  { L: "4D50F8", B: "16F4F4", R: "4D59C2", T: "16FAD0" },
  { L: "4D59C2", B: "16F4F4", R: "4D628C", T: "16FAD0" },
  { L: "4D3F64", B: "16FAD0", R: "4D482E", T: "1700AC" },
  { L: "4D482E", B: "16FAD0", R: "4D50F8", T: "1700AC" },
  { L: "4D50F8", B: "16FAD0", R: "4D59C2", T: "1700AC" },
  { L: "4D628C", B: "173B44", R: "4D6B56", T: "174120" },
  { L: "4D6B56", B: "173B44", R: "4D7420", T: "174120" },
  { L: "4D628C", B: "174120", R: "4D6B56", T: "1746FC" },
  { L: "4D6B56", B: "174120", R: "4D7420", T: "1746FC" },
  { L: "4D628C", B: "1746FC", R: "4D6B56", T: "174CD8" },
  { L: "4D6B56", B: "1746FC", R: "4D7420", T: "174CD8" },
  { L: "4D59C2", B: "174CD8", R: "4D628C", T: "1752B4" },
  { L: "4D59C2", B: "1752B4", R: "4D628C", T: "175890" },
  { L: "4D628C", B: "174CD8", R: "4D6B56", T: "1752B4" },
  { L: "4D628C", B: "1752B4", R: "4D6B56", T: "175890" },
  { L: "4D7420", B: "173B44", R: "4D7CEA", T: "174120" },
  { L: "4D7420", B: "174120", R: "4D7CEA", T: "1746FC" },
  { L: "4D7CEA", B: "174120", R: "4D85B4", T: "1746FC" },
  { L: "4D7420", B: "1746FC", R: "4D7CEA", T: "174CD8" },
  { L: "4D7CEA", B: "1746FC", R: "4D85B4", T: "174CD8" },
  { L: "4D85B4", B: "1746FC", R: "4D8E7E", T: "174CD8" },
  { L: "4D7CEA", B: "174CD8", R: "4D85B4", T: "1752B4" },
  { L: "4D85B4", B: "174CD8", R: "4D8E7E", T: "1752B4" },
  { L: "4D85B4", B: "1752B4", R: "4D8E7E", T: "175890" },
  { L: "4DBA70", B: "176448", R: "4DC33A", T: "176A24" },
  { L: "4DC33A", B: "176448", R: "4DCC04", T: "176A24" },
  { L: "4DBA70", B: "176A24", R: "4DC33A", T: "177000" },
  { L: "4DC33A", B: "176A24", R: "4DCC04", T: "177000" },
  { L: "4DCC04", B: "176448", R: "4DD4CE", T: "176A24" },
  { L: "4DCC04", B: "176A24", R: "4DD4CE", T: "177000" },
  { L: "4D6B56", B: "17B074", R: "4D7420", T: "17B650" },
  { L: "4D6B56", B: "17B650", R: "4D7420", T: "17BC2C" },
  { L: "4D6B56", B: "17BC2C", R: "4D7420", T: "17C208" },
  { L: "4DC33A", B: "177BB8", R: "4DCC04", T: "178194" },
  { L: "4DC33A", B: "178194", R: "4DCC04", T: "178770" },
  { L: "4DCC04", B: "177BB8", R: "4DD4CE", T: "178194" },
  { L: "4DD4CE", B: "177BB8", R: "4DDD98", T: "178194" },
  { L: "4DCC04", B: "178194", R: "4DD4CE", T: "178770" },
  { L: "4DD4CE", B: "178194", R: "4DDD98", T: "178770" },
  { L: "4DBA70", B: "178770", R: "4DC33A", T: "178D4C" },
  { L: "4DC33A", B: "178770", R: "4DCC04", T: "178D4C" },
  { L: "4DBA70", B: "178D4C", R: "4DC33A", T: "179328" },
  { L: "4DC33A", B: "178D4C", R: "4DCC04", T: "179328" },
  { L: "4DCC04", B: "178770", R: "4DD4CE", T: "178D4C" },
  { L: "4DD4CE", B: "178770", R: "4DDD98", T: "178D4C" },
  { L: "4DCC04", B: "178D4C", R: "4DD4CE", T: "179328" },
  { L: "4D85B4", B: "179328", R: "4D8E7E", T: "179904" },
  { L: "4D8E7E", B: "179328", R: "4D9748", T: "179904" },
  { L: "4D85B4", B: "179904", R: "4D8E7E", T: "179EE0" },
  { L: "4D8E7E", B: "179904", R: "4D9748", T: "179EE0" },
  { L: "4D9748", B: "179328", R: "4DA012", T: "179904" },
  { L: "4DA012", B: "179328", R: "4DA8DC", T: "179904" },
  { L: "4D9748", B: "179904", R: "4DA012", T: "179EE0" },
  { L: "4DA012", B: "179904", R: "4DA8DC", T: "179EE0" },
  { L: "4DA8DC", B: "179328", R: "4DB1A6", T: "179904" },
  { L: "4DB1A6", B: "179328", R: "4DBA70", T: "179904" },
  { L: "4DA8DC", B: "179904", R: "4DB1A6", T: "179EE0" },
  { L: "4DB1A6", B: "179904", R: "4DBA70", T: "179EE0" },
  { L: "4DBA70", B: "179328", R: "4DC33A", T: "179904" },
  { L: "4DC33A", B: "179328", R: "4DCC04", T: "179904" },
  { L: "4DBA70", B: "179904", R: "4DC33A", T: "179EE0" },
  { L: "4DC33A", B: "179904", R: "4DCC04", T: "179EE0" },
  { L: "4DCC04", B: "179328", R: "4DD4CE", T: "179904" },
  { L: "4D8E7E", B: "179EE0", R: "4D9748", T: "17A4BC" },
  { L: "4D8E7E", B: "17A4BC", R: "4D9748", T: "17AA98" },
  { L: "4D9748", B: "179EE0", R: "4DA012", T: "17A4BC" },
  { L: "4DA012", B: "179EE0", R: "4DA8DC", T: "17A4BC" },
  { L: "4D9748", B: "17A4BC", R: "4DA012", T: "17AA98" },
  { L: "4DA012", B: "17A4BC", R: "4DA8DC", T: "17AA98" },
  { L: "4DA8DC", B: "179EE0", R: "4DB1A6", T: "17A4BC" },
  { L: "4DB1A6", B: "179EE0", R: "4DBA70", T: "17A4BC" },
  { L: "4DA8DC", B: "17A4BC", R: "4DB1A6", T: "17AA98" },
  { L: "4DB1A6", B: "17A4BC", R: "4DBA70", T: "17AA98" },
  { L: "4DBA70", B: "179EE0", R: "4DC33A", T: "17A4BC" },
  { L: "4DC33A", B: "179EE0", R: "4DCC04", T: "17A4BC" },
  { L: "4DBA70", B: "17A4BC", R: "4DC33A", T: "17AA98" },
  { L: "4DC33A", B: "17A4BC", R: "4DCC04", T: "17AA98" },
  { L: "4DF7F6", B: "179EE0", R: "4E00C0", T: "17A4BC" },
  { L: "4DF7F6", B: "17A4BC", R: "4E00C0", T: "17AA98" },
  { L: "4D7420", B: "17B074", R: "4D7CEA", T: "17B650" },
  { L: "4D7CEA", B: "17B074", R: "4D85B4", T: "17B650" },
  { L: "4D85B4", B: "17AA98", R: "4D8E7E", T: "17B074" },
  { L: "4D8E7E", B: "17AA98", R: "4D9748", T: "17B074" },
  { L: "4D85B4", B: "17B074", R: "4D8E7E", T: "17B650" },
  { L: "4D8E7E", B: "17B074", R: "4D9748", T: "17B650" },
  { L: "4D9748", B: "17AA98", R: "4DA012", T: "17B074" },
  { L: "4DA012", B: "17AA98", R: "4DA8DC", T: "17B074" },
  { L: "4D9748", B: "17B074", R: "4DA012", T: "17B650" },
  { L: "4DA012", B: "17B074", R: "4DA8DC", T: "17B650" },
  { L: "4DA8DC", B: "17AA98", R: "4DB1A6", T: "17B074" },
  { L: "4DB1A6", B: "17AA98", R: "4DBA70", T: "17B074" },
  { L: "4DA8DC", B: "17B074", R: "4DB1A6", T: "17B650" },
  { L: "4DB1A6", B: "17B074", R: "4DBA70", T: "17B650" },
  { L: "4DBA70", B: "17AA98", R: "4DC33A", T: "17B074" },
  { L: "4DC33A", B: "17AA98", R: "4DCC04", T: "17B074" },
  { L: "4DBA70", B: "17B074", R: "4DC33A", T: "17B650" },
  { L: "4DC33A", B: "17B074", R: "4DCC04", T: "17B650" },
  { L: "4D7420", B: "17B650", R: "4D7CEA", T: "17BC2C" },
  { L: "4D7CEA", B: "17B650", R: "4D85B4", T: "17BC2C" },
  { L: "4D7420", B: "17BC2C", R: "4D7CEA", T: "17C208" },
  { L: "4D8E7E", B: "17B650", R: "4D9748", T: "17BC2C" },
  { L: "4D9748", B: "17B650", R: "4DA012", T: "17BC2C" },
  { L: "4DA012", B: "17B650", R: "4DA8DC", T: "17BC2C" },
  { L: "4DA8DC", B: "17B650", R: "4DB1A6", T: "17BC2C" },
  { L: "4DB1A6", B: "17B650", R: "4DBA70", T: "17BC2C" },
  { L: "4DD4CE", B: "17B650", R: "4DDD98", T: "17BC2C" },
  { L: "4DD4CE", B: "17BC2C", R: "4DDD98", T: "17C208" },
  { L: "4DDD98", B: "17B650", R: "4DE662", T: "17BC2C" },
  { L: "4DDD98", B: "17BC2C", R: "4DE662", T: "17C208" },
  { L: "4DE662", B: "17BC2C", R: "4DEF2C", T: "17C208" },
  { L: "4DEF2C", B: "17BC2C", R: "4DF7F6", T: "17C208" },
  { L: "4DE662", B: "17C7E4", R: "4DEF2C", T: "17CDC0" },
  { L: "4DEF2C", B: "17C7E4", R: "4DF7F6", T: "17CDC0" },
  { L: "4E962A", B: "178770", R: "4E9EF4", T: "178D4C" },
  { L: "4E962A", B: "178D4C", R: "4E9EF4", T: "179328" },
  { L: "4E9EF4", B: "178770", R: "4EA7BE", T: "178D4C" },
  { L: "4EA7BE", B: "178770", R: "4EB088", T: "178D4C" },
  { L: "4E9EF4", B: "178D4C", R: "4EA7BE", T: "179328" },
  { L: "4EA7BE", B: "178D4C", R: "4EB088", T: "179328" },
  { L: "4EB088", B: "178D4C", R: "4EB952", T: "179328" },
  { L: "4E962A", B: "179328", R: "4E9EF4", T: "179904" },
  { L: "4E9EF4", B: "179328", R: "4EA7BE", T: "179904" },
  { L: "4EA7BE", B: "179328", R: "4EB088", T: "179904" },
  { L: "4E9EF4", B: "179904", R: "4EA7BE", T: "179EE0" },
  { L: "4EA7BE", B: "179904", R: "4EB088", T: "179EE0" },
  { L: "4EB088", B: "179328", R: "4EB952", T: "179904" },
  { L: "4EB952", B: "179328", R: "4EC21C", T: "179904" },
  { L: "4E9EF4", B: "179EE0", R: "4EA7BE", T: "17A4BC" },
  { L: "4EA7BE", B: "179EE0", R: "4EB088", T: "17A4BC" },
  { L: "4F3D28", B: "179904", R: "4F45F2", T: "179EE0" },
  { L: "4F45F2", B: "179904", R: "4F4EBC", T: "179EE0" },
  { L: "4F4EBC", B: "179328", R: "4F5786", T: "179904" },
  { L: "4F5786", B: "179328", R: "4F6050", T: "179904" },
  { L: "4F4EBC", B: "179904", R: "4F5786", T: "179EE0" },
  { L: "4F5786", B: "179904", R: "4F6050", T: "179EE0" },
  { L: "4F3D28", B: "179EE0", R: "4F45F2", T: "17A4BC" },
  { L: "4F45F2", B: "179EE0", R: "4F4EBC", T: "17A4BC" },
  { L: "4F4EBC", B: "179EE0", R: "4F5786", T: "17A4BC" },
  { L: "4F5786", B: "179EE0", R: "4F6050", T: "17A4BC" },
  { L: "4FF5BA", B: "17C7E4", R: "4FFE84", T: "17CDC0" },
  { L: "4DE662", B: "17CDC0", R: "4DEF2C", T: "17D39C" },
  { L: "4DEF2C", B: "17CDC0", R: "4DF7F6", T: "17D39C" },
  { L: "4DEF2C", B: "17DF54", R: "4DF7F6", T: "17E530" },
  { L: "4DEF2C", B: "17E530", R: "4DF7F6", T: "17EB0C" },
  { L: "4DF7F6", B: "17E530", R: "4E00C0", T: "17EB0C" },
  { L: "4DEF2C", B: "17EB0C", R: "4DF7F6", T: "17F0E8" },
  { L: "4DF7F6", B: "17EB0C", R: "4E00C0", T: "17F0E8" },
  { L: "4DCC04", B: "181FC8", R: "4DD4CE", T: "1825A4" },
  { L: "4E357C", B: "17CDC0", R: "4E3E46", T: "17D39C" },
  { L: "4E00C0", B: "17E530", R: "4E098A", T: "17EB0C" },
  { L: "4E098A", B: "17E530", R: "4E1254", T: "17EB0C" },
  { L: "4E00C0", B: "17EB0C", R: "4E098A", T: "17F0E8" },
  { L: "4E098A", B: "17EB0C", R: "4E1254", T: "17F0E8" },
  { L: "4E1254", B: "17E530", R: "4E1B1E", T: "17EB0C" },
  { L: "4E1B1E", B: "17E530", R: "4E23E8", T: "17EB0C" },
  { L: "4E00C0", B: "17FCA0", R: "4E098A", T: "18027C" },
  { L: "4E098A", B: "17FCA0", R: "4E1254", T: "18027C" },
  { L: "4E00C0", B: "18027C", R: "4E098A", T: "180858" },
  { L: "4E098A", B: "18027C", R: "4E1254", T: "180858" },
  { L: "4E3117", B: "17FCA0", R: "4E357C", T: "18027C" },
  { L: "4E2CB2", B: "18027C", R: "4E357C", T: "180858" },
  { L: "4E357C", B: "17FCA0", R: "4E3E46", T: "18027C" },
  { L: "4E357C", B: "18027C", R: "4E3E46", T: "180858" },
  { L: "4E3E46", B: "18027C", R: "4E42AB", T: "180858" },
  { L: "4E23E8", B: "180858", R: "4E2CB2", T: "180E34" },
  { L: "4E2CB2", B: "180858", R: "4E357C", T: "180E34" },
  { L: "4E23E8", B: "180E34", R: "4E2CB2", T: "181410" },
  { L: "4E2CB2", B: "180E34", R: "4E357C", T: "181410" },
  { L: "4E357C", B: "180858", R: "4E3E46", T: "180E34" },
  { L: "4E3E46", B: "180858", R: "4E4710", T: "180E34" },
  { L: "4E357C", B: "180E34", R: "4E3E46", T: "181410" },
  { L: "4E3E46", B: "180E34", R: "4E4710", T: "181410" },
  { L: "4EFFA2", B: "180858", R: "4F086C", T: "180E34" },
  { L: "4EFFA2", B: "180E34", R: "4F086C", T: "181410" },
  { L: "4F086C", B: "180858", R: "4F1136", T: "180E34" },
  { L: "4F086C", B: "180E34", R: "4F1136", T: "181410" },
  { L: "4F345E", B: "1825A4", R: "4F3D28", T: "182B80" },
  { L: "4F3D28", B: "1825A4", R: "4F45F2", T: "182B80" },
  { L: "4FF5BA", B: "17CDC0", R: "4FFE84", T: "17D39C" },
  { L: "4E357C", B: "183D14", R: "4E3E46", T: "1842F0" },
  { L: "4E357C", B: "1842F0", R: "4E3E46", T: "1848CC" },
  { L: "4E3E46", B: "185A60", R: "4E4710", T: "18603C" },
  { L: "4EB952", B: "185484", R: "4EC21C", T: "185A60" },
  { L: "4EB952", B: "185A60", R: "4EC21C", T: "18603C" },
  { L: "4F345E", B: "182B80", R: "4F3D28", T: "18315C" },
  { L: "4F3D28", B: "182B80", R: "4F45F2", T: "18315C" },
  { L: "4DCC04", B: "18ECDC", R: "4DD4CE", T: "18F2B8" },
  { L: "4DD4CE", B: "18ECDC", R: "4DDD98", T: "18F2B8" },
  { L: "4DCC04", B: "18F2B8", R: "4DD4CE", T: "18F894" },
  { L: "4DD4CE", B: "18F2B8", R: "4DDD98", T: "18F894" },
];

function GetValue(v) {
  return parseInt(v, 16) / 10.0;
}

export function PosInMap(X, Y) {
  var cnt = ZR.length;
  var L = 0;
  var B = 0;
  var R = 0;
  var T = 0;
  for (var z = 0; z < cnt; z++) {
    L = GetValue(ZR[z].L);
    B = GetValue(ZR[z].B);
    R = GetValue(ZR[z].R);
    T = GetValue(ZR[z].T);

    if (X >= L && X <= R && Y >= B && Y <= T) return true;
  }

  return false;
}
